// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/MaterialIcons-Regular.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/MaterialIcons-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/MaterialIcons-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../fonts/MaterialIcons-Regular.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Mada:400,500,600,700&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.error-page .main-wrapper,
.css-equal-content,
.css-equal-heights {
  display: flex;
  display: -webkit-flex;
  flex-wrap: wrap;
  -webkit-flex-wrap: wrap;
}

.css-equal-content {
  color: red;
  float: left;
}

.attach-file,
.login-wrapper .loginbox .login-right,
.align-center {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
}

.error-page .main-wrapper,
.login-wrapper .loginbox .login-left,
.dash-widget-icon,
.avatar .avatar-title {
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}

.dash-widget-icon,
.avatar .avatar-title {
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}

.avatar-group {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
}

.avatar .avatar-title {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}

.onoffswitch {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

@font-face {
  font-family: "Material Icons";
  font-style: normal;
  font-weight: 400;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});

  src:
    local("Material Icons"),
    local("MaterialIcons-Regular"),
    url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff"),
    url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("truetype");
}

.primary {
  background-color: #00d0f1;
}

html {
  height: 100%;
}

body {
  background-color: #f8f9fa;
  color: #333333;
  font-family: "Mada", sans-serif;
  font-size: 1rem;
  height: 100%;
  line-height: 1.5;
  overflow-x: hidden;
}

@media (max-width: 767.98px) {
  body {
    font-size: 15px;
  }
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: "Mada", sans-serif;
  margin-top: 0;
}

a {
  -webkit-transition: all 0.4s ease;
  -ms-transition: all 0.4s ease;
  transition: all 0.4s ease;
  text-decoration: none;
}

a:hover,
a:focus,
a:active {
  outline: none;
  text-decoration: none;
  color: #00d0f1;
}

input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus {
  box-shadow: 0 0 0px 1000px white inset !important;
  -webkit-box-shadow: 0 0 0px 1000px white inset !important;
}

.form-control {
  border: 1px solid #dddddd;
  box-shadow: none;
  color: #333333;
  font-size: 15px;
  height: 40px;
}

.form-control:focus {
  border-color: #00d0f1;
  box-shadow: none;
  outline: 0 none;
}

.form-control.form-control-sm {
  height: calc(1.5em + 0.5rem + 2px);
}

.form-control.form-control-lg {
  height: calc(1.5em + 1rem + 2px);
}

a {
  color: #0dd9f9;
}

input,
button {
  -webkit-transition: all 0.4s ease;
  -ms-transition: all 0.4s ease;
  transition: all 0.4s ease;
}

input:focus,
input:hover,
button:focus,
button:hover {
  outline: none;
}

input[type="file"] {
  height: auto;
  min-height: calc(1.5em + 0.75rem + 2px);
}

input[type="text"],
input[type="password"] {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

textarea.form-control {
  resize: vertical;
}

.navbar-nav > li {
  float: left;
}

.form-group {
  margin-bottom: 1.25rem;
}

.input-group .form-control {
  height: 40px;
}

.nav .open a,
.nav .open a:hover,
.nav .open a:focus {
  background-color: rgba(0, 0, 0, 0.1);
  border-color: rgba(0, 0, 0, 0.1);
}

.material-icons {
  font-family: "Material Icons";
  font-weight: normal;
  font-style: normal;
  font-size: 24px;
  display: inline-block;
  line-height: 1;
  text-transform: none;
  letter-spacing: normal;
  word-wrap: normal;
  white-space: nowrap;
  direction: ltr;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
  -moz-osx-font-smoothing: grayscale;
  font-feature-settings: "liga";
}

.font-weight-600 {
  font-weight: 600;
}

@media (max-width: 767.98px) {
  h1,
  .h1 {
    font-size: 32px;
  }
}

@media (max-width: 767.98px) {
  h2,
  .h2 {
    font-size: 28px;
  }
}

@media (max-width: 767.98px) {
  h3,
  .h3 {
    font-size: 24px;
  }
}

@media (max-width: 767.98px) {
  h4,
  .h4 {
    font-size: 18px;
  }
}

@media (max-width: 767.98px) {
  h5,
  .h5 {
    font-size: 16px;
  }
}

@media (max-width: 767.98px) {
  h6,
  .h6 {
    font-size: 14px;
  }
}

.error-page .main-wrapper,
.css-equal-heights,
.css-equal-content {
  display: flex;
  display: -webkit-flex;
  flex-wrap: wrap;
  -webkit-flex-wrap: wrap;
}

.css-equal-content {
  color: red;
  float: left;
}

.attach-file,
.login-wrapper .loginbox .login-right,
.align-center {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
}

.error-page .main-wrapper,
.login-wrapper .loginbox .login-left,
.dash-widget-icon,
.avatar .avatar-title {
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}

.dash-widget-icon,
.avatar .avatar-title {
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}

.avatar-group {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
}

.avatar .avatar-title {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}

.onoffswitch {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.col {
  width: auto;
  padding-left: 15px;
  padding-right: 15px;
  float: left;
  position: relative;
  min-height: 1px;
}

@media (min-width: 320px) {
  .col.col-xs-12 {
    width: 100%;
  }

  .col.col-xs-11 {
    width: 91.66666667%;
  }

  .col.col-xs-10 {
    width: 83.33333333%;
  }

  .col.col-xs-9 {
    width: 75%;
  }

  .col.col-xs-8 {
    width: 66.66666667%;
  }

  .col.col-xs-7 {
    width: 58.33333333%;
  }

  .col.col-xs-6 {
    width: 50%;
  }

  .col.col-xs-5 {
    width: 41.66666667%;
  }

  .col.col-xs-4 {
    width: 33.33333333%;
  }

  .col.col-xs-3 {
    width: 25%;
  }

  .col.col-xs-2 {
    width: 16.66666667%;
  }

  .col.col-xs-1 {
    width: 8.33333333%;
  }
}

@media (min-width: 568px) {
  .col.col-sm-12 {
    width: 100%;
  }

  .col.col-sm-11 {
    width: 91.66666667%;
  }

  .col.col-sm-10 {
    width: 83.33333333%;
  }

  .col.col-sm-9 {
    width: 75%;
  }

  .col.col-sm-8 {
    width: 66.66666667%;
  }

  .col.col-sm-7 {
    width: 58.33333333%;
  }

  .col.col-sm-6 {
    width: 50%;
  }

  .col.col-sm-5 {
    width: 41.66666667%;
  }

  .col.col-sm-4 {
    width: 33.33333333%;
  }

  .col.col-sm-3 {
    width: 25%;
  }

  .col.col-sm-2 {
    width: 16.66666667%;
  }

  .col.col-sm-1 {
    width: 8.33333333%;
  }
}

@media (min-width: 768px) {
  .col.col-md-12 {
    width: 100%;
  }

  .col.col-md-11 {
    width: 91.66666667%;
  }

  .col.col-md-10 {
    width: 83.33333333%;
  }

  .col.col-md-9 {
    width: 75%;
  }

  .col.col-md-8 {
    width: 66.66666667%;
  }

  .col.col-md-7 {
    width: 58.33333333%;
  }

  .col.col-md-6 {
    width: 50%;
  }

  .col.col-md-5 {
    width: 41.66666667%;
  }

  .col.col-md-4 {
    width: 33.33333333%;
  }

  .col.col-md-3 {
    width: 25%;
  }

  .col.col-md-2 {
    width: 16.66666667%;
  }

  .col.col-md-1 {
    width: 8.33333333%;
  }
}

@media (min-width: 1024px) {
  .col.col-lg-12 {
    width: 100%;
  }

  .col.col-lg-11 {
    width: 91.66666667%;
  }

  .col.col-lg-10 {
    width: 83.33333333%;
  }

  .col.col-lg-9 {
    width: 75%;
  }

  .col.col-lg-8 {
    width: 66.66666667%;
  }

  .col.col-lg-7 {
    width: 58.33333333%;
  }

  .col.col-lg-6 {
    width: 50%;
  }

  .col.col-lg-5 {
    width: 41.66666667%;
  }

  .col.col-lg-4 {
    width: 33.33333333%;
  }

  .col.col-lg-3 {
    width: 25%;
  }

  .col.col-lg-2 {
    width: 16.66666667%;
  }

  .col.col-lg-1 {
    width: 8.33333333%;
  }
}

.check {
  display: block;
  width: 0;
  height: 0;
  visibility: hidden;
  opacity: 0;
  pointer-events: none;
  position: absolute;
  margin: 0;
  padding: 0;
}

.check:checked + .checktoggle {
  background-color: #55ce63;
}

.check:checked + .checktoggle:after {
  left: 100%;
  transform: translate(calc(-100% - 5px), -50%);
  -webkit-transform: translate(calc(-100% - 5px), -50%);
  -ms-transform: translate(calc(-100% - 5px), -50%);
}

.checktoggle {
  background-color: #e0001a;
  cursor: pointer;
  display: block;
  font-size: 0;
  height: 24px;
  margin-bottom: 0;
  position: relative;
  width: 48px;
  border-radius: 12px;
}

.checktoggle:after {
  content: " ";
  display: block;
  width: 16px;
  height: 16px;
  background-color: #ffffff;
  transition:
    left 300ms ease,
    transform 300ms ease;
  transform: translate(5px, -50%);
  -webkit-transform: translate(5px, -50%);
  -ms-transform: translate(5px, -50%);
  border-radius: 50%;
  position: absolute;
  top: 50%;
  left: 0;
}

.onoffswitch {
  margin-left: auto;
  position: relative;
  width: 73px;
}

.onoffswitch-checkbox {
  display: none;
}

.onoffswitch-checkbox:checked + .onoffswitch-label .onoffswitch-inner {
  margin-left: 0;
}

.onoffswitch-checkbox:checked + .onoffswitch-label .onoffswitch-switch {
  right: 0px;
}

.onoffswitch-label {
  display: block;
  overflow: hidden;
  cursor: pointer;
  margin-bottom: 0;
  border-radius: 20px;
}

.onoffswitch-inner {
  display: block;
  margin-left: -100%;
  -webkit-transition: margin 0.3s ease-in 0s;
  -ms-transition: margin 0.3s ease-in 0s;
  transition: margin 0.3s ease-in 0s;
  width: 200%;
}

.onoffswitch-inner:before,
.onoffswitch-inner:after {
  box-sizing: border-box;
  color: #ffffff;
  display: block;
  float: left;
  font-size: 16px;
  height: 30px;
  line-height: 32px;
  width: 50%;
  padding: 0;
}

.onoffswitch-inner:before {
  background-color: #55ce63;
  color: #ffffff;
  content: "ON";
  padding-left: 14px;
}

.onoffswitch-inner:after {
  content: "OFF";
  padding-right: 14px;
  background-color: #cccccc;
  color: #ffffff;
  text-align: right;
}

.onoffswitch-switch {
  background: #ffffff;
  display: block;
  height: 20px;
  width: 20px;
  border-radius: 20px;
  -webkit-transition: all 0.3s ease-in 0s;
  -ms-transition: all 0.3s ease-in 0s;
  transition: all 0.3s ease-in 0s;
  margin: 5px;
  position: absolute;
  top: 0;
  right: 43px;
  bottom: 0;
}

.card-header-tabs {
  border-bottom: 0;
}

.nav-tabs {
  border-bottom: 1px solid #e6e6e6;
}

.nav-tabs > li > a {
  margin-right: 0;
  color: #888888;
  border-radius: 0;
}

.nav-tabs > li > a:hover,
.nav-tabs > li > a:focus {
  border-color: transparent;
  color: #333333;
}

.nav-tabs .nav-tabs-solid > li > a {
  color: #333333;
}

.nav-tabs .nav-tabs-solid > .active > a,
.nav-tabs .nav-tabs-solid > .active > a:hover,
.nav-tabs .nav-tabs-solid > .active > a:focus {
  background-color: #00d0f1;
  border-color: #00d0f1;
  color: #ffffff;
}

.nav-tabs .nav-link {
  border-radius: 0;
}

.nav-tabs .nav-link:hover,
.nav-tabs .nav-link:focus {
  background-color: #eeeeee;
  border-color: transparent;
  color: #333333;
}

.nav-tabs.nav-justified > li > a {
  margin-bottom: 0;
  border-radius: 0;
}

.nav-tabs.nav-justified > li > a:hover,
.nav-tabs.nav-justified > li > a:focus {
  border-bottom-color: #dddddd;
}

.nav-tabs.nav-justified.nav-tabs-solid > li > a {
  border-color: transparent;
}

.nav-tabs.nav-justified.nav-tabs-top {
  border-bottom: 1px solid #dddddd;
}

.nav-tabs.nav-justified.nav-tabs-top > li > a,
.nav-tabs.nav-justified.nav-tabs-top > li > a:hover,
.nav-tabs.nav-justified.nav-tabs-top > li > a:focus {
  border-width: 2px 0 0 0;
}

.nav-tabs.nav-tabs-solid {
  background-color: #fafafa;
  border: 0;
}

.nav-tabs.nav-tabs-solid > li {
  margin-bottom: 0;
}

.nav-tabs.nav-tabs-solid > li > a {
  color: #333333;
  border-color: transparent;
}

.nav-tabs.nav-tabs-solid > li > a:hover,
.nav-tabs.nav-tabs-solid > li > a:focus {
  background-color: #f5f5f5;
}

.nav-tabs.nav-tabs-solid > li > a.active,
.nav-tabs.nav-tabs-solid > li > a.active:hover,
.nav-tabs.nav-tabs-solid > li > a.active:focus {
  background-color: #00d0f1;
  border-color: #00d0f1;
  color: #ffffff;
}

.nav-tabs.nav-tabs-solid.nav-tabs-rounded {
  border-radius: 50px;
}

.nav-tabs.nav-tabs-solid.nav-tabs-rounded > li > a {
  border-radius: 50px;
}

.nav-tabs.nav-tabs-solid.nav-tabs-rounded > li > a.active,
.nav-tabs.nav-tabs-solid.nav-tabs-rounded > li > a.active:hover,
.nav-tabs.nav-tabs-solid.nav-tabs-rounded > li > a.active:focus {
  border-radius: 50px;
}

.nav-tabs.nav-tabs-solid > .open:not(.active) > a {
  background-color: #f5f5f5;
  border-color: transparent;
}

.nav-tabs.nav-tabs-top > li > a,
.nav-tabs.nav-tabs-top > li > a:hover,
.nav-tabs.nav-tabs-top > li > a:focus {
  border-width: 2px 0 0 0;
}

.nav-tabs.nav-tabs-top > li > a.active,
.nav-tabs.nav-tabs-top > li > a.active:hover,
.nav-tabs.nav-tabs-top > li > a.active:focus {
  border-top-color: #00d0f1;
}

.nav-tabs.nav-tabs-top > li.open > a,
.nav-tabs.nav-tabs-top > li.open > a:hover,
.nav-tabs.nav-tabs-top > li.open > a:focus {
  border-top-color: #dddddd;
}

.nav-tabs.nav-tabs-top > li + li > a {
  margin-left: 1px;
}

.nav-tabs.nav-tabs-bottom > li {
  margin-bottom: -1px;
}

.nav-tabs.nav-tabs-bottom > li > a.active,
.nav-tabs.nav-tabs-bottom > li > a.active:hover,
.nav-tabs.nav-tabs-bottom > li > a.active:focus {
  border-bottom-width: 2px;
  border-color: transparent;
  border-bottom-color: #00d0f1;
  background-color: transparent;
  -webkit-transition: none 0s ease 0s;
  -ms-transition: none 0s ease 0s;
  transition: none 0s ease 0s;
}

.card-header-tabs {
  border-bottom: 0;
}

.tab-content {
  padding-top: 20px;
}

.nav-tabs-justified > li > a {
  margin-bottom: 0;
  border-radius: 0;
}

.nav-tabs-justified > li > a:hover,
.nav-tabs-justified > li > a:focus {
  border-bottom-color: #dddddd;
}

.nav-tabs-justified.nav-tabs-solid > li > a {
  border-color: transparent;
}

.nav-tabs-justified.nav-tabs-top {
  border-bottom: 1px solid #dddddd;
}

.nav-tabs-justified.nav-tabs-top > li > a,
.nav-tabs-justified.nav-tabs-top > li > a:hover,
.nav-tabs-justified.nav-tabs-top > li > a:focus {
  border-width: 2px 0 0 0;
}

.main-wrapper {
  width: 100%;
  height: 100vh;
  min-height: 100vh;
}

.page-wrapper {
  margin-left: 240px;
  padding-top: 60px;
  position: relative;
  -webkit-transition: all 0.4s ease;
  -ms-transition: all 0.4s ease;
  transition: all 0.4s ease;
}

@media (max-width: 991.98px) {
  .page-wrapper {
    margin-left: 0;
    padding-left: 0;
    padding-right: 0;
    -webkit-transition: all 0.4s ease;
    -ms-transition: all 0.4s ease;
    transition: all 0.4s ease;
  }
}

.page-wrapper > .content {
  padding: 1.875rem 1.875rem 0;
}

@media (max-width: 575.98px) {
  .page-wrapper > .content {
    padding: 0.9375rem 0.9375rem 0;
  }
}

.page-header {
  margin-bottom: 1.875rem;
}

@media (max-width: 575.98px) {
  .page-header {
    margin-bottom: 0.9375rem;
  }
}

.page-header .breadcrumb {
  background-color: transparent;
  color: #6c757d;
  font-size: 16px;
  font-weight: 500;
  margin: auto auto 0;
  padding: 0;
}

@media (max-width: 479px) {
  .page-header .breadcrumb {
    display: none;
  }
}

.page-header .breadcrumb a {
  color: #333333;
}

.page-title {
  color: #333333;
  margin-bottom: 5px;
}

@media (min-width: 992px) {
  .mini-sidebar .header .header-left {
    padding: 0 5px;
    width: 78px;
  }
}

@media (min-width: 992px) {
  .mini-sidebar .header .header-left .logo {
    display: none;
  }
}

@media (min-width: 992px) {
  .mini-sidebar .header .header-left .logo img {
    height: auto;
    max-height: 40px;
    width: auto;
  }
}

@media (min-width: 992px) {
  .mini-sidebar .header .header-left .logo.logo-small {
    display: block;
  }
}

.header {
  background: #ffffff;
  border-bottom: 1px solid #f0f0f0;
  z-index: 1001;
  height: 60px;
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
}

.header .header-left {
  float: left;
  height: 60px;
  position: relative;
  text-align: center;
  width: 240px;
  z-index: 1;
  -webkit-transition: all 0.2s ease-in-out;
  -ms-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;
  padding: 0 20px;
}

@media (max-width: 991.98px) {
  .header .header-left {
    position: absolute;
    width: 100%;
  }
}

@media (max-width: 767.98px) {
  .header .header-left {
    padding: 0 15px;
  }
}

.header .header-left .logo {
  display: inline-block;
  line-height: 60px;
}

@media (max-width: 767.98px) {
  .header .header-left .logo {
    display: none;
  }
}

.header .header-left .logo img {
  max-height: 40px;
  width: auto;
}

.header .header-left .logo.logo-small {
  display: none;
}

@media (max-width: 767.98px) {
  .header .header-left .logo.logo-small {
    display: inline-block;
  }
}

.header .dropdown-menu > li > a {
  position: relative;
  padding: 10px 18px;
}

.header .dropdown-menu > li > a:hover,
.header .dropdown-menu > li > a:focus {
  background-color: #00d0f1;
  color: #ffffff;
}

.header .dropdown-menu > li > a:hover i,
.header .dropdown-menu > li > a:focus i {
  color: #ffffff;
}

.header .dropdown-menu > li > a i {
  color: #00d0f1;
  margin-right: 10px;
  text-align: center;
  width: 18px;
}

.header .dropdown-toggle:after {
  display: none;
}

.header .has-arrow .dropdown-toggle:after {
  border-top: 0;
  border-left: 0;
  border-bottom: 2px solid #333333;
  border-right: 2px solid #333333;
  content: "";
  height: 8px;
  display: inline-block;
  pointer-events: none;
  transform-origin: 66% 66%;
  -webkit-transform-origin: 66% 66%;
  -ms-transform-origin: 66% 66%;
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  -webkit-transition: all 0.15s ease-in-out;
  -ms-transition: all 0.15s ease-in-out;
  transition: all 0.15s ease-in-out;
  width: 8px;
  vertical-align: 2px;
}

@media (max-width: 767.98px) {
  .header .has-arrow .dropdown-toggle:after {
    display: none;
  }
}

.header .has-arrow .dropdown-toggle[aria-expanded="true"]:after {
  transform: rotate(-135deg);
  -webkit-transform: rotate(-135deg);
  -ms-transform: rotate(-135deg);
}

.user-menu {
  float: right;
  position: relative;
  z-index: 99;
  margin: 0;
}

.user-menu.nav > li > a {
  color: #333333;
  font-size: 14px;
  line-height: 58px;
  height: 60px;
  padding: 0 15px;
}

.user-menu.nav > li > a:hover,
.user-menu.nav > li > a:focus {
  background-color: rgba(0, 0, 0, 0.2);
}

.user-menu.nav > li > a:hover i,
.user-menu.nav > li > a:focus i {
  color: #333333;
}

.user-menu.nav > li > a i {
  font-size: 24px;
  line-height: 60px;
}

.user-menu.nav > li > a .badge {
  background-color: #1b5a90;
  display: block;
  font-size: 10px;
  font-weight: 700;
  min-height: 15px;
  min-width: 15px;
  color: #ffffff;
  position: absolute;
  top: 6px;
  right: 3px;
}

@media (max-width: 767.98px) {
  .user-menu.nav > li > a > span:not(.user-img) {
    display: none;
  }
}

.user-menu .dropdown-menu {
  min-width: 200px;
  padding: 0;
}

.user-menu .dropdown-menu > li > a i {
  color: #00d0f1;
  font-size: 16px;
  margin-right: 10px;
  min-width: 18px;
  text-align: center;
}

.user-menu .dropdown-menu > li > a:hover i,
.user-menu .dropdown-menu > li > a:focus i {
  color: #ffffff;
}

.user-menu .dropdown-menu .dropdown-item {
  display: flex;
  align-items: center;
  border-top: 1px solid #e3e3e3;
  padding: 10px 15px;
}

.user-menu .dropdown-menu .dropdown-item:hover {
  color: #ffffff;
  background: #00d0f1;
}

.user-img {
  display: inline-block;
  margin-right: 3px;
  position: relative;
}

.user-img.nav > li > a .mobile_btn {
  border: 0;
  position: relative;
  cursor: pointer;
  margin: 0;
  padding: 0;
}

.user-img .dropdown-menu {
  min-width: 200px;
  padding: 0;
}

.user-img .dropdown-menu .dropdown-item {
  display: flex;
  align-items: center;
  border-top: 1px solid #e3e3e3;
  padding: 10px 15px;
}

.user-img .dropdown-menu .dropdown-item:hover {
  color: #ffffff;
  background: #00d0f1;
}

.mobile_btn {
  display: none;
  float: left;
}

@media (max-width: 991.98px) {
  .mobile_btn {
    color: #333333 !important;
    cursor: pointer;
    display: block;
    font-size: 24px;
    height: 60px;
    line-height: 60px;
    text-align: center;
    z-index: 10;
    padding: 0 15px;
    position: absolute;
    top: 0;
    left: 0;
  }
}

.slide-nav .sidebar {
  margin-left: 0;
}

@media (max-width: 767.98px) {
  .app-dropdown {
    display: none;
  }
}

.app-dropdown .dropdown-menu {
  width: 300px;
  padding: 0;
}

.app-dropdown-menu .app-list {
  padding: 15px;
}

.app-dropdown-menu .app-item {
  border: 1px solid transparent;
  color: #737373;
  display: block;
  text-align: center;
  border-radius: 3px;
  padding: 10px 0;
}

.app-dropdown-menu .app-item i {
  font-size: 20px;
  height: 24px;
}

.app-dropdown-menu .app-item span {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.app-dropdown-menu .app-item:hover,
.app-dropdown-menu .app-item:focus,
.app-dropdown-menu .app-item:active,
.app-dropdown-menu .app-item.active {
  background-color: #f9f9f9;
  border-color: #e3e3e3;
}

.app-list > div + div {
  margin-top: 5px;
}

.app-list > .row {
  margin-left: -5px;
  margin-right: -5px;
}

.app-list > .row > .col {
  padding-left: 5px;
  padding-right: 5px;
}

.user-header {
  background-color: #f9f9f9;
  display: flex;
  padding: 10px 15px;
}

.user-header .user-text {
  margin-left: 10px;
}

.user-header .user-text h6 {
  margin-bottom: 2px;
}

.menu-title {
  color: #a3a3a3;
  display: block;
  font-size: 14px;
  margin-bottom: 5px;
  padding: 0 25px;
}

.sidebar-overlay {
  background-color: rgba(0, 0, 0, 0.6);
  display: none;
  height: 100%;
  width: 100%;
  z-index: 1000;
  position: fixed;
  top: 60px;
  left: 0;
}

@media (max-width: 991.98px) {
  .sidebar-overlay.opened {
    display: block;
  }
}

html.menu-opened {
  overflow: hidden;
}

html.menu-opened body {
  overflow: hidden;
}

.top-nav-search {
  float: left;
  margin-left: 15px;
}

@media (max-width: 991.98px) {
  .top-nav-search {
    display: none;
  }
}

.top-nav-search form {
  margin-top: 10px;
  position: relative;
  width: 230px;
}

.top-nav-search .form-control {
  border-color: rgba(0, 0, 0, 0.1);
  color: #333333;
  height: 40px;
  border-radius: 50px;
  padding: 10px 50px 10px 15px;
}

.top-nav-search .form-control::-webkit-input-placeholder {
  color: #333333;
  opacity: 1;
}

.top-nav-search .form-control:-moz-placeholder {
  color: #333333;
  opacity: 1;
}

.top-nav-search .form-control::-moz-placeholder {
  color: #333333;
  opacity: 1;
}

.top-nav-search .form-control:-ms-input-placeholder {
  color: #333333;
  opacity: 1;
}

.top-nav-search .btn {
  background-color: transparent;
  border-color: transparent;
  color: #333333;
  min-height: 40px;
  padding: 7px 15px;
  position: absolute;
  top: 0;
  right: 0;
}

.top-nav-search.active form {
  display: block;
  position: absolute;
  left: 0;
}

@media (min-width: 991.98px) {
  #toggle_btn {
    align-items: center;
    color: #333333;
    display: inline-flex;
    float: left;
    font-size: 30px;
    height: 60px;
    justify-content: center;
    margin-left: 15px;
    padding: 0 15px;
  }
}

@media (max-width: 991.98px) {
  #toggle_btn {
    display: none;
  }
}

@media (max-width: 767.98px) {
  .login-wrapper .loginbox {
    max-width: 450px;
    min-height: unset;
  }
}

@media (max-width: 991.98px) {
  .login-wrapper .loginbox .login-left {
    width: 50%;
    padding: 80px 50px;
  }
}

@media (max-width: 767.98px) {
  .login-wrapper .loginbox .login-left {
    display: none;
  }
}

@media (max-width: 991.98px) {
  .login-wrapper .loginbox .login-right {
    width: 50%;
    padding: 50px;
  }
}

@media (max-width: 767.98px) {
  .login-wrapper .loginbox .login-right {
    float: none;
    width: 100%;
    padding: 1.875rem;
  }
}

@media (max-width: 767.98px) {
  .login-wrapper .loginbox .login-right h1 {
    font-size: 22px;
  }
}

@media (max-width: 991.98px) {
  .navbar-nav .open .dropdown-menu {
    float: left;
    position: absolute;
  }
}

@media (max-width: 767.98px) {
  .navbar-nav .open .dropdown-menu {
    float: left;
    position: absolute;
  }
}

@media (max-width: 991.98px) {
  .navbar-nav.user-menu .open .dropdown-menu {
    left: auto;
    right: 0;
  }
}

@media (max-width: 767.98px) {
  .navbar-nav.user-menu .open .dropdown-menu {
    left: auto;
    right: 0;
  }
}

.table {
  color: #333333;
  max-width: 100%;
  margin-bottom: 0;
  width: 100%;
  --bs-table-bg: transparent;
}

.table > tbody > tr > th {
  border-top: 0;
  padding: 10px 8px;
}

.table.no-border > tbody > tr > td,
.table.no-border > tbody > tr th,
.table.no-border tfoot > tr > td,
.table.no-border tfoot > tr th {
  border-top: 0;
  padding: 10px 8px;
}

.table.dataTable {
  border-collapse: collapse !important;
}

.table thead {
  background-color: #f8f9fa;
  border-bottom: 1px solid rgba(0, 0, 0, 0.03);
}

.table thead tr {
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.table thead tr:last-child {
  border-color: transparent;
}

.table thead tr th {
  font-weight: 600;
  border: 0;
}

.table.table-center th,
.table.table-center td {
  vertical-align: middle;
}

.table tbody tr {
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.table tbody tr:last-child {
  border-color: transparent;
}

.table-striped > thead > tr:nth-of-type(2n + 1) {
  background-color: #f8f9fa;
}

.table-striped thead tr {
  border-color: transparent;
}

.table-striped tbody tr {
  border-color: transparent;
}

.table-striped tbody tr:nth-of-type(even) {
  background-color: rgba(255, 255, 255, 0.3);
}

.table-striped tbody tr:nth-of-type(odd) {
  background-color: rgba(235, 235, 235, 0.4);
}

.table-nowrap th,
.table-nowrap td {
  white-space: nowrap;
}

table.table td h2 {
  display: inline-block;
  font-size: inherit;
  font-weight: 400;
  vertical-align: middle;
  margin: 0;
  padding: 0;
}

table.table td h2.table-avatar {
  align-items: center;
  display: inline-flex;
  font-size: inherit;
  font-weight: 400;
  vertical-align: middle;
  white-space: nowrap;
  margin: 0;
  padding: 0;
}

table.table td h2 a {
  color: #333333;
}

table.table td h2 a:hover {
  color: #00d0f1;
}

table.table td h2 span {
  color: #888888;
  display: block;
  font-size: 12px;
  margin-top: 3px;
}

.table-hover tbody tr:hover {
  background-color: #f7f7f7;
}

.table-hover tbody tr:hover td {
  color: #474648;
}

.table-bordered {
  border: 1px solid rgba(0, 0, 0, 0.05) !important;
}

.table-bordered th,
.table-bordered td {
  border-color: rgba(0, 0, 0, 0.05);
}

.card-table .card-body {
  padding: 0;
}

.card-table .card-body .table td,
.card-table .card-body .table th {
  border-top: 1px solid #e2e5e8;
  white-space: nowrap;
  padding: 1rem 0.75rem;
}

.card-table .card-body .table > thead > tr > th {
  border-top: 0;
}

.card-table .card-body .table tr th:first-child,
.card-table .card-body .table tr td:first-child {
  padding-left: 1.5rem;
}

.card-table .card-body .table tr th:last-child,
.card-table .card-body .table tr td:last-child {
  padding-right: 1.5rem;
}

#delete_modal .modal-content {
  text-align: center;
}

.table-responsive {
  white-space: nowrap;
}

.btn.focus,
.btn:focus {
  box-shadow: unset;
}

.btn.btn-rounded {
  border-radius: 50px;
}

.btn-white {
  background-color: #ffffff;
  border: 1px solid #cccccc;
  color: #272b41;
}

.bg-primary,
.badge-primary {
  background-color: #00d0f1 !important;
}

a.bg-primary:focus,
a.bg-primary:hover,
button.bg-primary:focus,
button.bg-primary:hover {
  background-color: #19c1dc !important;
}

.bg-success,
.badge-success {
  background-color: #7bb13c !important;
}

a.bg-success:focus,
a.bg-success:hover,
button.bg-success:focus,
button.bg-success:hover {
  background-color: #699834 !important;
}

.bg-info,
.badge-info {
  background-color: #009efb !important;
}

a.bg-info:focus,
a.bg-info:hover,
button.bg-info:focus,
button.bg-info:hover {
  background-color: #028ee1 !important;
}

.bg-warning,
.badge-warning {
  background-color: #ffbc34 !important;
}

a.bg-warning:focus,
a.bg-warning:hover,
button.bg-warning:focus,
button.bg-warning:hover {
  background-color: #e9ab2e !important;
}

.bg-danger,
.badge-danger {
  background-color: #e84646 !important;
}

a.bg-danger:focus,
a.bg-danger:hover,
button.bg-danger:focus,
button.bg-danger:hover {
  background-color: #e63333 !important;
}

.bg-white {
  background-color: #ffffff;
}

.bg-purple,
.badge-purple {
  background-color: #9368e9 !important;
}

.text-primary {
  color: #00d0f1 !important;
}

.dropdown-menu li > a.text-primary {
  color: #00d0f1 !important;
}

.text-success {
  color: #699834 !important;
}

.dropdown-menu li > a.text-success {
  color: #699834 !important;
}

.text-danger {
  color: #e84646 !important;
}

.dropdown-menu li > a.text-danger {
  color: #e84646 !important;
}

.text-info {
  color: #009efb !important;
}

.dropdown-menu li > a.text-info {
  color: #009efb !important;
}

.text-warning {
  color: #ffbc34 !important;
}

.dropdown-menu li > a.text-warning {
  color: #ffbc34 !important;
}

.text-purple {
  color: #7460ee !important;
}

.dropdown-menu li > a.text-purple {
  color: #7460ee !important;
}

.text-muted {
  color: #757575 !important;
}

.btn-primary {
  background-color: #00d0f1;
  border: 1px solid #00d0f1;
}

.btn-primary:focus,
.btn-primary:hover,
.btn-primary:active,
.btn-primary.active {
  color: #ffffff;
  background-color: #19c1dc;
  border-color: #19c1dc;
}

.btn-primary:focus .open > .dropdown-toggle.btn-primary,
.btn-primary:hover .open > .dropdown-toggle.btn-primary,
.btn-primary:active .open > .dropdown-toggle.btn-primary,
.btn-primary.active .open > .dropdown-toggle.btn-primary {
  background-color: #19c1dc;
  border: 1px solid #19c1dc;
}

.btn-primary.active.focus .open > .dropdown-toggle.btn-primary.focus,
.btn-primary.active.focus .open > .dropdown-toggle.btn-primary:focus,
.btn-primary.active.focus .open > .dropdown-toggle.btn-primary:hover,
.btn-primary.active:focus .open > .dropdown-toggle.btn-primary.focus,
.btn-primary.active:focus .open > .dropdown-toggle.btn-primary:focus,
.btn-primary.active:focus .open > .dropdown-toggle.btn-primary:hover,
.btn-primary.active:hover .open > .dropdown-toggle.btn-primary.focus,
.btn-primary.active:hover .open > .dropdown-toggle.btn-primary:focus,
.btn-primary.active:hover .open > .dropdown-toggle.btn-primary:hover,
.btn-primary .focus.focus .open > .dropdown-toggle.btn-primary.focus,
.btn-primary .focus.focus .open > .dropdown-toggle.btn-primary:focus,
.btn-primary .focus.focus .open > .dropdown-toggle.btn-primary:hover,
.btn-primary .focus:focus .open > .dropdown-toggle.btn-primary.focus,
.btn-primary .focus:focus .open > .dropdown-toggle.btn-primary:focus,
.btn-primary .focus:focus .open > .dropdown-toggle.btn-primary:hover,
.btn-primary .focus:hover .open > .dropdown-toggle.btn-primary.focus,
.btn-primary .focus:hover .open > .dropdown-toggle.btn-primary:focus,
.btn-primary .focus:hover .open > .dropdown-toggle.btn-primary:hover {
  background-color: #19c1dc;
  border: 1px solid #19c1dc;
}

.btn-primary:active:focus,
.btn-primary:active:hover {
  background-color: #19c1dc;
  border: 1px solid #19c1dc;
}

.btn-primary .active:not(:disabled):not(.disabled),
.btn-primary:active:not(:disabled):not(.disabled) {
  background-color: #19c1dc;
  border-color: #19c1dc;
  color: #ffffff;
}

.btn-primary .active:focus:not(:disabled):not(.disabled),
.btn-primary:active:focus:not(:disabled):not(.disabled) {
  box-shadow: unset;
}

.btn-primary .show > .btn-primary.dropdown-toggle {
  background-color: #19c1dc;
  border-color: #19c1dc;
  color: #ffffff;
}

.btn-primary .show > .btn-primary.dropdown-toggle:focus {
  box-shadow: unset;
}

.btn-primary.disabled,
.btn-primary:disabled {
  background-color: #00d0f1;
  border-color: #00d0f1;
  color: #ffffff;
}

.btn-secondary.active:focus :not(:disabled):not(.disabled),
.btn-secondary:active:focus :not(:disabled):not(.disabled) {
  box-shadow: unset;
}

.show > .btn-secondary.dropdown-toggle:focus {
  box-shadow: unset;
}

.show > .btn-success.dropdown-toggle {
  background-color: #699834;
  border-color: #699834;
  color: #ffffff;
}

.show > .btn-success.dropdown-toggle:focus {
  box-shadow: unset;
}

.show > .btn-info.dropdown-toggle {
  background-color: #028ee1;
  border-color: #028ee1;
  color: #ffffff;
}

.show > .btn-info.dropdown-toggle:focus {
  box-shadow: unset;
}

.show > .btn-warning.dropdown-toggle {
  background-color: #e9ab2e;
  border-color: #e9ab2e;
  color: #ffffff;
}

.show > .btn-warning.dropdown-toggle:focus {
  box-shadow: unset;
}

.show > .btn-danger.dropdown-toggle {
  background-color: #e63333;
  border-color: #e63333;
  color: #ffffff;
}

.show > .btn-danger.dropdown-toggle:focus {
  box-shadow: unset;
}

.show > .btn-light.dropdown-toggle:focus,
.show > .btn-dark.dropdown-toggle:focus {
  box-shadow: unset;
}

.show > .btn-outline-primary.dropdown-toggle {
  background-color: #00d0f1;
  border-color: #00d0f1;
}

.show > .btn-outline-primary.dropdown-toggle:focus {
  box-shadow: none;
}

.show > .btn-outline-success.dropdown-toggle {
  background-color: #7bb13c;
  border-color: #7bb13c;
}

.show > .btn-outline-success.dropdown-toggle:focus {
  box-shadow: none;
}

.show > .btn-outline-info.dropdown-toggle {
  background-color: #009efb;
  border-color: #009efb;
}

.show > .btn-outline-info.dropdown-toggle:focus {
  box-shadow: none;
}

.show > .btn-outline-warning.dropdown-toggle {
  color: #212529;
  background-color: #ffbc34;
  border-color: #ffbc34;
}

.show > .btn-outline-warning.dropdown-toggle:focus {
  box-shadow: none;
}

.show > .btn-outline-danger.dropdown-toggle {
  color: #212529;
  background-color: #ffbc34;
  border-color: #ffbc34;
}

.show > .btn-outline-danger.dropdown-toggle:focus {
  box-shadow: none;
}

.btn-success {
  background-color: #7bb13c;
  border: 1px solid #7bb13c;
}

.btn-success:hover,
.btn-success:focus .btn-success.active,
.btn-success:active,
.btn-success .open__ > .dropdown-toggle.btn-sccess {
  background-color: #699834;
  border: 1px solid #699834;
  color: #ffffff;
}

.btn-success .open > .dropdown-toggle.btn-success {
  background-color: #699834;
  border: 1px solid #699834;
  color: #ffffff;
}

.btn-success .open > .dropdown-toggle.btn-success.focus,
.btn-success .open > .dropdown-toggle.btn-success:hover,
.btn-success .open > .dropdown-toggle.btn-success:focus {
  background-color: #699834;
  border: 1px solid #699834;
}

.btn-success.active:focus,
.btn-success.active.focus,
.btn-success.active:hover,
.btn-success.focus,
.btn-success:active:focus,
.btn-success:active:hover {
  background-color: #699834;
  border: 1px solid #699834;
}

.btn-success.active:not(:disabled):not(.disabled),
.btn-success:active:not(:disabled):not(.disabled) {
  background-color: #699834;
  border-color: #699834;
  color: #ffffff;
}

.btn-success.active:focus:not(:disabled):not(.disabled),
.btn-success:active:focus:not(:disabled):not(.disabled) {
  box-shadow: unset;
}

.btn-success.disabled,
.btn-success:disabled {
  background-color: #7bb13c;
  border-color: #7bb13c;
  color: #ffffff;
}

.btn-info {
  background-color: #009efb;
  border: 1px solid #009efb;
}

.btn-info:hover,
.btn-info:focus,
.btn-info:active,
.btn-info.active {
  background-color: #028ee1;
  border: 1px solid #028ee1;
}

.btn-info.active:focus,
.btn-info.active.focus,
.btn-info.active:hover,
.btn-info.focus,
.btn-info:active:focus,
.btn-info:active:hover {
  background-color: #028ee1;
  border: 1px solid #028ee1;
}

.btn-info.active:not(:disabled):not(.disabled),
.btn-info:active:not(:disabled):not(.disabled) {
  background-color: #028ee1;
  border-color: #028ee1;
  color: #ffffff;
}

.btn-info.active:not(:disabled):not(.disabled):focus,
.btn-info:active:not(:disabled):not(.disabled):focus {
  box-shadow: unset;
}

.btn-info.disabled,
.btn-info:disabled {
  background-color: #009efb;
  border-color: #009efb;
  color: #ffffff;
}

.btn-warning {
  background-color: #ffbc34;
  border: 1px solid #ffbc34;
}

.btn-warning:hover,
.btn-warning:focus,
.btn-warning:active,
.btn-warning.active {
  background-color: #e9ab2e;
  border: 1px solid #e9ab2e;
}

.btn-warning.active:focus,
.btn-warning.active.focus,
.btn-warning.active:hover,
.btn-warning.focus,
.btn-warning:active:focus,
.btn-warning:active:hover {
  background-color: #e9ab2e;
  border: 1px solid #e9ab2e;
}

.btn-warning.active:not(:disabled):not(.disabled),
.btn-warning:active:not(:disabled):not(.disabled) {
  background-color: #e9ab2e;
  border-color: #e9ab2e;
  color: #ffffff;
}

.btn-warning.active:not(:disabled):not(.disabled):focus,
.btn-warning:active:not(:disabled):not(.disabled):focus {
  box-shadow: unset;
}

.btn-warning.disabled,
.btn-warning:disabled {
  background-color: #ffbc34;
  border-color: #ffbc34;
  color: #ffffff;
}

.btn-danger {
  background-color: #e84646;
  border: 1px solid #e84646;
}

.btn-danger:hover,
.btn-danger:focus,
.btn-danger:active,
.btn-danger.active {
  background-color: #e63333;
  border: 1px solid #e63333;
}

.btn-danger.active:focus,
.btn-danger.active.focus,
.btn-danger.active:hover,
.btn-danger.focus,
.btn-danger:active:focus,
.btn-danger:active:hover {
  background-color: #e63333;
  border: 1px solid #e63333;
}

.btn-danger.active:not(:disabled):not(.disabled),
.btn-danger:active:not(:disabled):not(.disabled) {
  background-color: #e63333;
  border-color: #e63333;
  color: #ffffff;
}

.btn-danger.active:not(:disabled):not(.disabled):focus,
.btn-danger:active:not(:disabled):not(.disabled):focus {
  box-shadow: unset;
}

.btn-danger.disabled,
.btn-danger:disabled {
  background-color: #e84646;
  border-color: #e84646;
  color: #ffffff;
}

.open > .dropdown-toggle.btn-info {
  background-color: #028ee1;
  border: 1px solid #028ee1;
}

.open > .dropdown-toggle.btn-info.focus,
.open > .dropdown-toggle.btn-info:focus,
.open > .dropdown-toggle.btn-info:hover {
  background-color: #028ee1;
  border: 1px solid #028ee1;
}

.open > .dropdown-toggle.btn-warning {
  background-color: #e9ab2e;
  border: 1px solid #e9ab2e;
}

.open > .dropdown-toggle.btn-warning.focus,
.open > .dropdown-toggle.btn-warning:focus,
.open > .dropdown-toggle.btn-warning:hover {
  background-color: #e9ab2e;
  border: 1px solid #e9ab2e;
}

.open > .dropdown-toggle.btn-danger {
  background-color: #e63333;
  border: 1px solid #e63333;
}

.open > .dropdown-toggle.btn-danger.focus,
.open > .dropdown-toggle.btn-danger:focus,
.open > .dropdown-toggle.btn-danger:hover {
  background-color: #e63333;
  border: 1px solid #e63333;
}

.btn-light.active:focus:not(:disabled):not(.disabled),
.btn-light:active:focus:not(:disabled):not(.disabled),
.btn-dark.active:focus:not(:disabled):not(.disabled),
.btn-dark:active:focus:not(:disabled):not(.disabled) {
  box-shadow: unset;
}

.btn-outline-primary {
  color: #00d0f1;
  border-color: #00d0f1;
}

.btn-outline-primary:hover {
  background-color: #00d0f1;
  border-color: #00d0f1;
}

.btn-outline-primary.focus,
.btn-outline-primary:focus {
  box-shadow: none;
}

.btn-outline-primary.disabled,
.btn-outline-primary:disabled {
  color: #00d0f1;
  background-color: transparent;
}

.btn-outline-primary:not(:disabled):not(.disabled).active,
.btn-outline-primary:not(:disabled):not(.disabled):active {
  background-color: #00d0f1;
  border-color: #00d0f1;
}

.btn-outline-success {
  color: #7bb13c;
  border-color: #7bb13c;
}

.btn-outline-success:hover {
  background-color: #7bb13c;
  border-color: #7bb13c;
}

.btn-outline-success.focus,
.btn-outline-success:focus {
  box-shadow: none;
}

.btn-outline-success.disabled,
.btn-outline-success:disabled {
  color: #7bb13c;
  background-color: transparent;
}

.btn-outline-success:not(:disabled):not(.disabled).active,
.btn-outline-success:not(:disabled):not(.disabled):active {
  background-color: #7bb13c;
  border-color: #7bb13c;
}

.btn-outline-success:not(:disabled):not(.disabled).active:focus,
.btn-outline-success:not(:disabled):not(.disabled):active:focus {
  box-shadow: none;
}

.btn-outline-info {
  color: #009efb;
  border-color: #009efb;
}

.btn-outline-info:hover {
  color: #ffffff;
  background-color: #009efb;
  border-color: #009efb;
}

.btn-outline-info.disabled,
.btn-outline-info:disabled {
  background-color: transparent;
  color: #009efb;
}

.btn-outline-info:focus,
.btn-outline-info.focus {
  box-shadow: none;
}

.btn-outline-info:not(:disabled):not(.disabled).active,
.btn-outline-info:not(:disabled):not(.disabled):active {
  background-color: #009efb;
  border-color: #009efb;
}

.btn-outline-info:not(:disabled):not(.disabled).active:focus,
.btn-outline-info:not(:disabled):not(.disabled):active:focus {
  box-shadow: none;
}

.btn-outline-warning {
  color: #ffbc34;
  border-color: #ffbc34;
}

.btn-outline-warning:hover {
  color: #212529;
  background-color: #ffbc34;
  border-color: #ffbc34;
}

.btn-outline-warning.disabled,
.btn-outline-warning:disabled {
  background-color: transparent;
  color: #ffbc34;
}

.btn-outline-warning:focus,
.btn-outline-warning.focus {
  box-shadow: none;
}

.btn-outline-warning:not(:disabled):not(.disabled).active,
.btn-outline-warning:not(:disabled):not(.disabled):active {
  background-color: #ffbc34;
  border-color: #ffbc34;
}

.btn-outline-warning:not(:disabled):not(.disabled).active:focus,
.btn-outline-warning:not(:disabled):not(.disabled):active:focus {
  box-shadow: none;
}

.btn-outline-danger {
  color: #e84646;
  border-color: #e84646;
}

.btn-outline-danger:hover {
  color: #212529;
  background-color: #e84646;
  border-color: #e84646;
}

.btn-outline-danger.disabled,
.btn-outline-danger:disabled {
  background-color: transparent;
  color: #e84646;
}

.btn-outline-danger:focus,
.btn-outline-danger.focus {
  box-shadow: none;
}

.btn-outline-danger:not(:disabled):not(.disabled).active,
.btn-outline-danger:not(:disabled):not(.disabled):active {
  background-color: #e84646;
  border-color: #e84646;
}

.btn-outline-danger:not(:disabled):not(.disabled).active:focus,
.btn-outline-danger:not(:disabled):not(.disabled):active:focus {
  box-shadow: none;
}

.btn-outline-light {
  color: #ababab;
  border-color: #e6e6e6;
}

.btn-outline-light.disabled,
.btn-outline-light:disabled {
  color: #ababab;
}

.pagination {
  --bs-pagination-disabled-bg: transparent;
}

.pagination > .active > a,
.pagination > .active > a:hover,
.pagination > .active > a:focus,
.pagination > .active > span,
.pagination > .active > span:hover,
.pagination > .active > span:focus {
  background-color: #20c0f3;
  border-color: #20c0f3;
}

.pagination > .active > a,
.pagination > .active > span {
  color: #ffffff;
}

.pagination > li > a,
.pagination > li > span {
  color: #20c0f3;
}

.page-link:hover {
  color: #20c0f3;
}

.page-link:focus {
  box-shadow: unset;
}

.page-item.active .page-link {
  background-color: #20c0f3;
  border-color: #20c0f3;
}

.dropdown-menu {
  background-color: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.1);
  box-shadow: inherit;
  font-size: 14px;
  border-radius: 3px;
  transform-origin: left top 0;
  -webkit-transform-origin: left top 0;
  -ms-transform-origin: left top 0;
}

.dropdown-item.active,
.dropdown-item:active {
  background-color: #0de0fe;
}

.navbar-nav__.open--.dropdown-menu {
  border: 0;
  -webkit-box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
}

.btn-light {
  border-color: #e6e6e6;
  color: #a6a6a6;
}

.bootstrap-datetimepicker-widget table td.active,
.bootstrap-datetimepicker-widget table td.active:hover {
  background-color: #20c0f3;
  text-shadow: unset;
}

.bootstrap-datetimepicker-widget table td.today::before {
  border-bottom-color: #20c0f3;
}

.bg-info-light {
  background-color: rgba(2, 182, 179, 0.12) !important;
  color: #1db9aa !important;
}

.bg-primary-light {
  background-color: rgba(17, 148, 247, 0.12) !important;
  color: #2196f3 !important;
}

.bg-danger-light {
  background-color: rgba(242, 17, 54, 0.12) !important;
  color: #e63c3c !important;
}

.bg-warning-light {
  background-color: rgba(255, 152, 0, 0.12) !important;
  color: #f39c12 !important;
}

.bg-success-light {
  background-color: rgba(15, 183, 107, 0.12) !important;
  color: #26af48 !important;
}

.bg-purple-light {
  background-color: rgba(197, 128, 255, 0.12) !important;
  color: #c580ff !important;
}

.bg-default-light {
  background-color: rgba(40, 52, 71, 0.12) !important;
  color: #283447 !important;
}

.text-xs {
  font-size: 12px !important;
}

.text-sm {
  font-size: 14px !important;
}

.text-lg {
  font-size: 18px !important;
}

.text-xl {
  font-size: 24px !important;
}

.form-group {
  margin-bottom: 20px;
}

.card {
  border: 1px solid #f0f0f0;
  margin-bottom: 30px;
}

@media (max-width: 575.98px) {
  .card {
    margin-bottom: 15px;
  }
}

.card .card-header {
  background-color: #ffffff;
  border-bottom: 1px solid #eaeaea;
}

.card .card-header .card-title {
  margin-bottom: 0;
}

.card-body {
  padding: 1.5rem;
}

@media (max-width: 575.98px) {
  .card-body {
    padding: 1.25rem;
  }
}

.card-header {
  border-bottom: 1px solid #e6e6e6;
  padding: 1rem 1.5rem;
}

@media (max-width: 575.98px) {
  .card-header {
    padding: 0.75rem 1.25rem;
  }
}

.card-footer {
  background-color: #ffffff;
  border-top: 1px solid #e6e6e6;
  padding: 1rem 1.5rem;
}

@media (max-width: 575.98px) {
  .card-footer {
    padding: 0.75rem 1.25rem;
  }
}

.modal-footer.text-start {
  text-align: left;
}

.modal-footer.text-center {
  text-align: center;
}

.border-primary {
  border-color: #00d0f1 !important;
}

.text-secondary {
  color: #b8bdc1 !important;
}

.page-item.active .page-link {
  background-color: #00d0f1;
  border-color: #00d0f1;
}

@media (max-width: 767.98px) {
  div.dataTables_wrapper div.dataTables_paginate ul.pagination {
    justify-content: center;
    margin-top: 10px;
  }

  div.dataTables_wrapper div.dataTables_info {
    text-align: center;
  }
}

@media (min-width: 992px) {
  .mini-sidebar.expand-menu .sidebar {
    width: 240px;
  }
}

@media (min-width: 992px) {
  .mini-sidebar.expand-menu .sidebar .sidebar-menu ul > li > a span {
    display: inline;
    opacity: 1;
  }
}

@media (min-width: 992px) {
  .mini-sidebar.expand-menu .sidebar .sidebar-menu ul > li > a i {
    font-size: 24px;
    width: 20px;
  }
}

@media (min-width: 992px) {
  .mini-sidebar.expand-menu .menu-title {
    visibility: visible;
  }
}

@media (min-width: 992px) {
  .mini-sidebar.expand-menu .menu-title a {
    visibility: hidden;
  }
}

@media (min-width: 992px) {
  .mini-sidebar .sidebar {
    width: 78px;
  }
}

@media (min-width: 992px) {
  .mini-sidebar .sidebar .sidebar-menu ul > li > a span {
    display: none;
    opacity: 0;
    -webkit-transition: all 0.2s ease-in-out;
    -ms-transition: all 0.2s ease-in-out;
    transition: all 0.2s ease-in-out;
  }
}

@media (min-width: 992px) {
  .mini-sidebar .menu-title {
    visibility: hidden;
    white-space: nowrap;
  }
}

@media (min-width: 992px) {
  .mini-sidebar .menu-title a {
    visibility: hidden;
  }
}

@media (min-width: 992px) {
  .mini-sidebar .page-wrapper {
    margin-left: 78px;
  }
}

.sidebar {
  background-color: #1b5a90;
  margin-top: 0;
  -webkit-transition: all 0.2s ease-in-out 0s;
  -ms-transition: all 0.2s ease-in-out 0s;
  transition: all 0.2s ease-in-out 0s;
  width: 240px;
  z-index: 1001;
  position: fixed;
  top: 60px;
  bottom: 0;
  left: 0;
}

@media (max-width: 991.98px) {
  .sidebar {
    margin-left: -225px;
    width: 225px;
    -webkit-transition: all 0.4s ease;
    -ms-transition: all 0.4s ease;
    transition: all 0.4s ease;
    z-index: 1000;
  }
}

.sidebar.opened {
  -webkit-transition: all 0.4s ease;
  -ms-transition: all 0.4s ease;
  transition: all 0.4s ease;
}

.sidebar .sidebar-menu > ul > li {
  margin-bottom: 3px;
  position: relative;
}

.sidebar .sidebar-menu > ul > li:last-child {
  margin-bottom: 0;
}

.sidebar .sidebar-menu > ul > li > a {
  align-items: center;
  display: flex;
  justify-content: flex-start;
  position: relative;
  color: #f1f1f1;
  -webkit-transition: all 0.2s ease-in-out 0s;
  -ms-transition: all 0.2s ease-in-out 0s;
  transition: all 0.2s ease-in-out 0s;
  border-radius: 3px;
  padding: 8px 15px;
}

.sidebar .sidebar-menu > ul > li > a span {
  display: inline-block;
  margin-left: 10px;
  white-space: nowrap;
  -webkit-transition: all 0.2s ease-in-out 0s;
  -ms-transition: all 0.2s ease-in-out 0s;
  transition: all 0.2s ease-in-out 0s;
}

.sidebar .sidebar-menu > ul > li > a span.chat-user {
  margin-left: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}

.sidebar .sidebar-menu > ul > li > a span.badge {
  margin-left: auto;
}

.sidebar .sidebar-menu .menu-arrow {
  display: inline-block;
  font-family: "FontAwesome";
  text-rendering: auto;
  line-height: 40px;
  font-size: 16px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  line-height: 18px;
  -webkit-transition: transform 0.15s;
  -ms-transition: transform 0.15s;
  transition: transform 0.15s;
  transform: translate(0, 0);
  -webkit-transform: translate(0, 0);
  -ms-transform: translate(0, 0);
  position: absolute;
  top: 11px;
  right: 15px;
}

.sidebar .sidebar-menu .menu-arrow:before {
  content: "\\f105";
}

.sidebar ul ul {
  display: none;
}

.sidebar ul ul a {
  display: block;
  font-size: 15px !important;
  padding: 7px 10px 7px 45px !important;
  position: relative;
}

.sidebar ul ul a .menu-arrow {
  top: 10px !important;
}

.sidebar ul ul ul a {
  padding-left: 65px !important;
}

.sidebar ul ul ul ul a {
  padding-left: 85px !important;
}

.sidebar ul li a.subdrop .menu-arrow {
  transform: rotate(90deg);
  -webkit-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
}

.sidebar ul li a i {
  display: inline-block;
  font-size: 24px;
  line-height: 24px;
  text-align: left;
  vertical-align: middle;
  width: 20px;
  -webkit-transition: all 0.2s ease-in-out 0s;
  -ms-transition: all 0.2s ease-in-out 0s;
  transition: all 0.2s ease-in-out 0s;
}

.sidebar ul li a > .badge {
  color: #ffffff;
}

.sidebar ul li.menu-title a i {
  font-size: 16px !important;
  margin-right: 0;
  text-align: right;
  width: auto;
}

.sidebar-inner {
  height: 100%;
  min-height: 100%;
  -webkit-transition: all 0.2s ease-in-out 0s;
  -ms-transition: all 0.2s ease-in-out 0s;
  transition: all 0.2s ease-in-out 0s;
}

.sidebar-menu {
  padding: 15px;
}

.sidebar-menu ul {
  font-size: 15px;
  list-style-type: none;
  position: relative;
  margin: 0;
  padding: 0;
}

.sidebar-menu ul li a {
  color: #ffffff;
  display: block;
  font-size: 16px;
  height: auto;
  padding: 0 20px;
}

.sidebar-menu ul li a:hover {
  color: #5ae8ff;
}

.sidebar-menu ul li.active a {
  background-color: #00d0f1;
  color: #fff;
}

.sidebar-menu ul ul a.active {
  color: #20e3ff;
  text-decoration: underline;
}

.sidebar-menu > ul > li > a:hover {
  background-color: #19c1dc;
  color: #ffffff;
}

.sidebar-menu > ul > li.active > a:hover {
  background-color: #19c1dc;
  color: #ffffff;
}

.menu-title {
  color: #ebebeb;
  display: flex;
  font-size: 14px;
  font-weight: 600;
  opacity: 1;
  white-space: nowrap;
  padding: 5px 15px;
}

.menu-title > i {
  float: right;
  line-height: 40px;
}

.menu-title li.menu-title a {
  color: #ff9b44;
  display: inline-block;
  margin-left: auto;
  padding: 0;
}

.menu-title li.menu-title a .btn {
  color: #ffffff;
  display: block;
  float: none;
  font-size: 15px;
  margin: auto auto 15px;
  padding: 10px 15px;
}

@media (min-width: 992px) {
  .modal-open.mini-sidebar .sidebar {
    z-index: 1051;
  }
}

.avatar {
  position: relative;
  display: inline-block;
  width: 3rem;
  height: 3rem;
}

.avatar > img {
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
  object-fit: cover;
}

.avatar .avatar-title {
  width: 100%;
  height: 100%;
  background-color: #00d0f1;
  color: #ffffff;
}

.avatar.avatar-online::before {
  width: 25%;
  height: 25%;
  border-radius: 50%;
  content: "";
  border: 2px solid #ffffff;
  position: absolute;
  right: 0;
  bottom: 0;
  background-color: #7bb13c;
}

.avatar.avatar-offline::before {
  width: 25%;
  height: 25%;
  border-radius: 50%;
  content: "";
  border: 2px solid #ffffff;
  position: absolute;
  right: 0;
  bottom: 0;
  background-color: #e84646;
}

.avatar.avatar-away::before {
  width: 25%;
  height: 25%;
  border-radius: 50%;
  content: "";
  border: 2px solid #ffffff;
  position: absolute;
  right: 0;
  bottom: 0;
  background-color: #ffbc34;
}

.avatar .border {
  border-width: 3px !important;
}

.avatar .rounded {
  border-radius: 6px !important;
}

.avatar .avatar-title {
  font-size: 18px;
}

.avatar .avatar-xs {
  width: 1.65rem;
  height: 1.65rem;
}

.avatar .avatar-xs .border {
  border-width: 2px !important;
}

.avatar .avatar-xs .rounded {
  border-radius: 4px !important;
}

.avatar .avatar-xs .avatar-title {
  font-size: 12px;
}

.avatar .avatar-xs.avatar-away::before,
.avatar .avatar-xs.avatar-offline::before,
.avatar .avatar-xs.avatar-online::before {
  border-width: 1px;
}

.avatar-sm {
  width: 2.5rem;
  height: 2.5rem;
}

.avatar-sm .border {
  border-width: 3px !important;
}

.avatar-sm .rounded {
  border-radius: 4px !important;
}

.avatar-sm .avatar-title {
  font-size: 15px;
}

.avatar-sm.avatar-away::before,
.avatar-sm.avatar-offline::before,
.avatar-sm.avatar-online::before {
  border-width: 2px;
}

.avatar-lg {
  width: 3.75rem;
  height: 3.75rem;
}

.avatar-lg .border {
  border-width: 3px !important;
}

.avatar-lg .rounded {
  border-radius: 8px !important;
}

.avatar-lg .avatar-title {
  font-size: 24px;
}

.avatar-lg.avatar-away::before,
.avatar-lg.avatar-offline::before,
.avatar-lg.avatar-online::before {
  border-width: 3px;
}

.avatar-xl {
  width: 5rem;
  height: 5rem;
}

.avatar-xl .border {
  border-width: 4px !important;
}

.avatar-xl .rounded {
  border-radius: 8px !important;
}

.avatar-xl .avatar-title {
  font-size: 28px;
}

.avatar-xl.avatar-away::before,
.avatar-xl.avatar-offline::before,
.avatar-xl.avatar-online::before {
  border-width: 4px;
}

.avatar-xxl {
  width: 5.125rem;
  height: 5.125rem;
}

@media (min-width: 768px) {
  .avatar-xxl {
    width: 8rem;
    height: 8rem;
  }
}

.avatar-xxl .border {
  border-width: 6px !important;
}

@media (min-width: 768px) {
  .avatar-xxl .border {
    border-width: 6px !important;
  }
}

.avatar-xxl .rounded {
  border-radius: 8px !important;
}

@media (min-width: 768px) {
  .avatar-xxl .rounded {
    border-width: 12px !important;
  }
}

.avatar-xxl .avatar-title {
  font-size: 30px;
}

@media (min-width: 768px) {
  .avatar-xxl .avatar-title {
    font-size: 42px;
  }
}

.avatar-xxl.avatar-away::before,
.avatar-xxl.avatar-offline::before,
.avatar-xxl.avatar-online::before {
  border-width: 4px;
}

@media (min-width: 768px) {
  .avatar-xxl.avatar-away::before,
  .avatar-xxl.avatar-offline::before,
  .avatar-xxl.avatar-online::before {
    border-width: 4px;
  }
}

.avatar-group .avatar + .avatar {
  margin-left: -0.75rem;
}

.avatar-group .avatar:hover {
  z-index: 1;
}

.avatar-group .avatar-xs + .avatar-xs {
  margin-left: -0.40625rem;
}

.avatar-group .avatar-sm + .avatar-sm {
  margin-left: -0.625rem;
}

.avatar-group .avatar-lg + .avatar-lg {
  margin-left: -1rem;
}

.avatar-group .avatar-xl + .avatar-xl {
  margin-left: -1.28125rem;
}

.avatar-xs {
  width: 1.65rem;
  height: 1.65rem;
}

.select2-results__option {
  padding: 6px 15px;
}

.select2-container .select2-selection--single {
  border: 1px solid #dddddd;
  height: 40px;
}

.select2-container .select2-selection--single .select2-selection__rendered {
  padding-right: 30px;
  padding-left: 15px;
}

.select2-container--default .select2-selection--single .select2-selection__arrow {
  height: 38px;
  right: 7px;
}

.select2-container--default .select2-selection--single .select2-selection__arrow b {
  border-color: #dcdcdc transparent transparent;
  border-style: solid;
  border-width: 6px 6px 0;
  height: 0;
  margin-left: -10px;
  margin-top: -2px;
  width: 0;
  position: absolute;
  top: 50%;
  left: 50%;
}

.select2-container--default .select2-selection--single .select2-selection__rendered {
  color: #272b41;
  font-size: 15px;
  font-weight: normal;
  line-height: 38px;
}

.select2-container--default.select2-container--open
  .select2-selection--single
  .select2-selection__arrow
  b {
  border-color: transparent transparent #dcdcdc;
  border-width: 0 6px 6px;
}

.select2-container--default .select2-results__option--highlighted[aria-selected] {
  background-color: #20c0f3;
}

.select2-container--default .select2-selection--multiple {
  border: 1px solid #dcdcdc;
  min-height: 46px;
}

.select2-dropdown {
  border-color: #dcdcdc;
}

.p-20 {
  padding: 20px !important;
}

.p-t-0 {
  padding-top: 0 !important;
}

.m-0 {
  margin: 0 !important;
}

.m-r-5 {
  margin-right: 5px !important;
}

.m-r-10 {
  margin-right: 10px !important;
}

.m-l-5 {
  margin-left: 5px !important;
}

.m-l-15 {
  margin-left: 15px !important;
}

.m-t-5 {
  margin-top: 5px !important;
}

.m-t-0 {
  margin-top: 0 !important;
}

.m-t-10 {
  margin-top: 10px !important;
}

.m-t-15 {
  margin-top: 15px !important;
}

.m-t-20 {
  margin-top: 20px !important;
}

.m-t-30 {
  margin-top: 30px !important;
}

.m-t-50 {
  margin-top: 50px !important;
}

.m-b-5 {
  margin-bottom: 5px !important;
}

.m-b-10 {
  margin-bottom: 10px !important;
}

.m-b-15 {
  margin-bottom: 15px !important;
}

.m-b-20 {
  margin-bottom: 20px !important;
}

.m-b-30 {
  margin-bottom: 30px !important;
}

.block {
  display: block !important;
}

.cal-icon {
  position: relative;
  width: 100%;
}

.cal-icon:after {
  color: #979797;
  content: "\\f073";
  display: block;
  font-family: "FontAwesome";
  font-size: 15px;
  margin: auto;
  position: absolute;
  top: 10px;
  right: 15px;
}

.dash-widget-icon {
  display: inline-flex;
  font-size: 30px;
  height: 50px;
  line-height: 48px;
  text-align: center;
  width: 50px;
  border: 3px solid;
  border-radius: 50px;
  padding: 28px;
}

.dash-widget-icon h3 {
  margin-bottom: 10px;
}

.dash-count {
  font-size: 18px;
  margin-left: auto;
}

@media (max-width: 767.98px) {
  .dash-count {
    font-size: 16px;
  }
}

.dash-widget-header {
  align-items: center;
  display: flex;
  margin-bottom: 15px;
}

.card-chart .card-body {
  padding: 8px;
}

@media (max-width: 575.98px) {
  .card-chart .card-body {
    padding: 5px;
  }
}

#morrisArea > svg,
#morrisArea #morrisLine > svg {
  width: 100%;
}

.activity-feed {
  list-style: none;
  margin-bottom: 0;
  margin-left: 5px;
  padding: 0;
}

.activity-feed .feed-item {
  border-left: 2px solid #e4e8eb;
  padding-bottom: 19px;
  padding-left: 20px;
  position: relative;
}

.activity-feed .feed-item:last-child {
  border-color: transparent;
  padding-bottom: 0;
}

.activity-feed .feed-item:after {
  content: "";
  display: block;
  width: 12px;
  height: 12px;
  background-color: #177dff;
  border-radius: 50%;
  position: absolute;
  top: 0;
  left: -7px;
}

.activity-feed .feed-item .feed-date {
  display: block;
  position: relative;
  color: #777;
  text-transform: uppercase;
  font-size: 13px;
}

.activity-feed .feed-item .feed-text {
  color: #777;
  position: relative;
}

.activity-feed .feed-item .feed-text a {
  color: #333333;
  font-weight: 600;
}

.section-header {
  margin-bottom: 1.875rem;
}

.section-header .section-title {
  color: #333333;
}

.comp-header {
  margin-bottom: 1.875rem;
}

.comp-header .comp-title {
  color: #272b41;
}

.line {
  background-color: #20c0f3;
  height: 2px;
  width: 60px;
  margin: 0;
}

.comp-buttons .btn {
  margin-bottom: 5px;
}

.pagination-box .pagination {
  margin-top: 0;
}

.comp-dropdowns .btn-group {
  margin-bottom: 5px;
}

.progress-example .progress {
  margin-bottom: 1.5rem;
}

.progress-xs {
  height: 4px;
}

.progress-sm {
  height: 15px;
}

.progress.progress-sm {
  height: 6px;
}

.progress.progress-md {
  height: 8px;
}

.progress.progress-lg {
  height: 18px;
}

.row.row-sm {
  margin-left: -3px;
  margin-right: -3px;
}

.row.row-sm > div {
  padding-left: 3px;
  padding-right: 3px;
}

.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: #ffffff;
  background-color: #00d0f1;
}

@media (max-width: 575.98px) {
  .pagination-lg .page-link {
    font-size: 1.2rem;
    padding: 0.5rem 0.625rem;
  }
}

.notifications {
  padding: 0;
}

.notifications .notification-time {
  font-size: 12px;
  line-height: 1.35;
  color: #bdbdbd;
}

.notifications .notify-block {
  margin-top: 0;
  border-bottom: 1px solid #f5f5f5;
}

.notifications .notify-block:last-child {
  border-bottom: none;
}

.notifications .notify-block a {
  display: block;
  padding: 10px 15px;
  border-radius: 2px;
}

.notifications .notify-block a:hover {
  background-color: #fafafa;
}

.notifications .notify-block > .avatar {
  margin-right: 10px;
}

.notifications .media-list .media-left {
  padding-right: 8px;
}

.notifications .noti-content {
  height: 290px;
  width: 350px;
  overflow-y: auto;
  position: relative;
}

@media (max-width: 479px) {
  .notifications .noti-content {
    width: 300px;
  }
}

.notifications ul.notification-list > li {
  margin-top: 0;
  border-bottom: 1px solid #f5f5f5;
}

.notifications ul.notification-list > li:last-child {
  border-bottom: none;
}

.notifications ul.notification-list > li a {
  display: block;
  border-radius: 2px;
  padding: 10px 15px;
}

.notifications ul.notification-list > li a:hover {
  background-color: #fafafa;
}

.notifications ul.notification-list > li .list-item {
  border: 0;
  position: relative;
  padding: 0;
}

.topnav-dropdown-header {
  border-bottom: 1px solid #eeeeee;
  text-align: center;
}

.topnav-dropdown-header .notification-title {
  color: #333333;
  display: block;
  float: left;
  font-size: 14px;
}

.topnav-dropdown-header .clear-noti {
  color: #f83f37;
  float: right;
  font-size: 12px;
  text-transform: uppercase;
}

.topnav-dropdown-header,
.topnav-dropdown-footer {
  font-size: 14px;
  height: 40px;
  line-height: 40px;
  padding-left: 15px;
  padding-right: 15px;
}

.topnav-dropdown-footer {
  border-top: 1px solid #eeeeee;
}

.topnav-dropdown-footer a {
  display: block;
  text-align: center;
  color: #333333;
}

.noti-details {
  color: #989c9e;
  margin-bottom: 0;
}

.noti-title {
  color: #333333;
}

.notification-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.noti-time {
  margin: 0;
}

.login-body {
  display: table;
  height: 100vh;
  min-height: 100vh;
}

.login-wrapper {
  width: 100%;
  height: 100%;
  display: table-cell;
  vertical-align: middle;
}

.login-wrapper .loginbox {
  background-color: #ffffff;
  display: flex;
  max-width: 800px;
  min-height: 500px;
  width: 100%;
  margin: 1.875rem auto;
  border-radius: 6px;
  -webkit-box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

@media (max-width: 767.98px) {
  .login-wrapper .loginbox {
    max-width: 450px;
    min-height: unset;
  }
}

.login-wrapper .loginbox .login-left {
  align-items: center;
  flex-direction: column;
  width: 400px;
  display: flex;
  background: linear-gradient(180deg, #aab6c1, #4b8b96);
  border-radius: 6px 0 0 6px;
  padding: 80px;
}

@media (max-width: 991.98px) {
  .login-wrapper .loginbox .login-left {
    width: 50%;
    padding: 80px 50px;
  }
}

@media (max-width: 767.98px) {
  .login-wrapper .loginbox .login-left {
    display: none;
  }
}

.login-wrapper .loginbox .login-right {
  padding: 40px;
  width: 400px;
}

@media (max-width: 991.98px) {
  .login-wrapper .loginbox .login-right {
    width: 50%;
    padding: 50px;
  }
}

@media (max-width: 767.98px) {
  .login-wrapper .loginbox .login-right {
    float: none;
    width: 100%;
    padding: 1.875rem;
  }
}

.login-wrapper .loginbox .login-right .login-right-wrap {
  max-width: 100%;
  flex: 0 0 100%;
}

.login-wrapper .loginbox .login-right h1 {
  font-size: 26px;
  font-weight: 500;
  margin-bottom: 5px;
  text-align: center;
}

@media (max-width: 767.98px) {
  .login-wrapper .loginbox .login-right h1 {
    font-size: 22px;
  }
}

.login-wrapper .loginbox .login-right .forgotpass a {
  color: #a0a0a0;
}

.login-wrapper .loginbox .login-right .forgotpass a:hover {
  color: #333333;
  text-decoration: underline;
}

.login-wrapper .loginbox .login-right .dont-have {
  color: #a0a0a0;
  margin-top: 1.875rem;
}

.login-wrapper .loginbox .login-right .dont-have a {
  color: #333333;
}

.login-wrapper .loginbox .login-right .dont-have a:hover {
  text-decoration: underline;
}

.account-subtitle {
  color: #4c4c4c;
  font-size: 17px;
  margin-bottom: 1.875rem;
  text-align: center;
}

.social-login {
  text-align: center;
}

.social-login > span {
  color: #a0a0a0;
  margin-right: 8px;
}

.social-login > a {
  background-color: #cccccc;
  color: #ffffff;
  display: inline-block;
  font-size: 18px;
  height: 32px;
  line-height: 32px;
  margin-right: 6px;
  text-align: center;
  width: 32px;
  border-radius: 4px;
}

.social-login > a:last-child {
  margin-right: 0;
}

.social-login > a.facebook {
  background-color: #4b75bd;
}

.social-login > a.google {
  background-color: #fe5240;
}

.login-or {
  color: #a0a0a0;
  position: relative;
  margin-bottom: 20px;
  margin-top: 20px;
  padding-bottom: 10px;
  padding-top: 10px;
}

.or-line {
  background-color: #e5e5e5;
  height: 1px;
  display: block;
  margin: 0 auto;
}

.span-or {
  background-color: #ffffff;
  display: block;
  margin-left: -20px;
  text-align: center;
  text-transform: uppercase;
  width: 42px;
  position: absolute;
  top: 0;
  left: 50%;
}

.lock-user {
  margin-bottom: 20px;
  text-align: center;
}

.lock-user img {
  margin-bottom: 15px;
  width: 100px;
}

.add-btn {
  border: 1px solid transparent;
  color: #666;
  display: inline-block;
  padding: 0.375rem 0.75rem;
  border-radius: 20px;
}

@media (max-width: 479px) {
  .add-btn {
    font-size: 14px;
    padding: 6px 7px;
  }
}

.add-btn:focus,
.add-btn:active,
.add-btn:hover {
  background-color: #ffffff;
  border-color: #dddddd;
  color: #666;
}

.add-btn span {
  align-items: center;
  background-color: #ffc107;
  color: #ffffff;
  display: inline-flex;
  font-size: 14px;
  height: 22px;
  justify-content: center;
  margin-right: 3px;
  width: 22px;
  border-radius: 50%;
}

.invoice-details {
  float: right;
  text-align: right;
}

@media (max-width: 575.98px) {
  .invoice-details {
    float: left;
    text-align: left;
  }
}

.invoice-details h4 {
  color: #666;
  font-size: 16px;
  font-weight: 400;
  margin-bottom: 1.875rem;
  text-transform: uppercase;
}

.inv-badge {
  color: #ffffff;
  display: inline-flex;
  font-size: 11px;
  justify-content: center;
  min-width: 80px;
}

.inv-logo {
  max-height: 80px;
  height: auto;
  max-height: 100px;
  width: auto;
}

.invoice-container {
  background-color: #ffffff;
  border: 1px solid #f0f0f0;
  max-width: 900px;
  margin: 0 auto 1.875rem;
  padding: 1.5rem;
}

@media (max-width: 767.98px) {
  .invoice-container {
    padding: 20px;
  }
}

.invoice-payment-details > li span {
  float: right;
  text-align: right;
}

@media (max-width: 575.98px) {
  .invoice-payment-details > li span {
    float: left;
    text-align: left;
  }
}

#calendar-events {
  background-color: #fcfcfc;
}

.calendar-events {
  border: 1px solid transparent;
  cursor: move;
  padding: 10px 15px;
}

.calendar-events:hover {
  border-color: #e9e9e9;
  background-color: #ffffff;
}

.calendar-events i {
  margin-right: 8px;
}

.calendar {
  float: left;
  margin-bottom: 0;
}

.fc-toolbar.fc-header-toolbar {
  margin-bottom: 1.5rem;
}

@media (max-width: 575.98px) {
  .fc-toolbar .fc-center {
    display: inline-block;
    width: 100%;
    text-align: center;
  }
}

@media (max-width: 575.98px) {
  .fc-toolbar .fc-center h2 {
    width: 100%;
  }
}

@media (max-width: 575.98px) {
  .fc-toolbar .fc-left {
    float: none;
    width: 200px;
    margin: 0 auto;
  }
}

@media (max-width: 575.98px) {
  .fc-toolbar .fc-right {
    display: inline-block;
    float: none;
    width: 200px;
    clear: both;
    margin: 10px auto 0;
  }
}

.fc-toolbar h2 {
  font-size: 18px;
  font-weight: 600;
  font-family: "Roboto", sans-serif;
  line-height: 30px;
  text-transform: uppercase;
}

.fc-toolbar .fc-state-active,
.fc-toolbar .ui-state-active,
.fc-toolbar .ui-state-hover,
.fc-toolbar button:hover,
.fc-toolbar button:focus {
  z-index: 0;
}

.none-border .modal-footer {
  border-top: none;
}

.fc-day-grid-event .fc-time {
  font-family: "Roboto", sans-serif;
}

.fc-day {
  background: #ffffff;
}

.fc th.fc-widget-header {
  background: #eeeeee;
  font-size: 14px;
  line-height: 20px;
  text-transform: uppercase;
  padding: 10px 0;
}

.fc-unthemed th,
.fc-unthemed td,
.fc-unthemed thead,
.fc-unthemed tbody,
.fc-unthemed .fc-divider,
.fc-unthemed .fc-row,
.fc-unthemed .fc-popover {
  border-color: #f3f3f3;
}

.fc-unthemed .fc-today {
  background: #ffffff;
}

.fc-basic-view .fc-day-number,
.fc-basic-view .fc-week-number {
  padding: 2px 5px;
}

.fc-basic-view td.fc-week-number span {
  padding-right: 8px;
  font-weight: 700;
  font-family: "Roboto", sans-serif;
}

.fc-basic-view td.fc-day-number {
  padding-right: 8px;
  font-weight: 700;
  font-family: "Roboto", sans-serif;
}

.fc-button {
  background: #f1f1f1;
  border: none;
  color: #797979;
  text-transform: capitalize;
  box-shadow: none !important;
  border-radius: 3px !important;
  height: auto !important;
  margin: 0 3px !important;
  padding: 6px 12px !important;
}

.fc-text-arrow {
  font-family: inherit;
  font-size: 16px;
}

.fc-state-hover {
  background: #f3f3f3;
}

.fc-state-highlight {
  background: #f0f0f0;
}

.fc-state-down,
.fc-state-active,
.fc-state-disabled {
  background-color: #20c0f3 !important;
  color: #ffffff !important;
  text-shadow: none !important;
}

.fc-cell-overlay {
  background: #f0f0f0;
}

.fc-event {
  border: none;
  color: #ffffff !important;
  cursor: move;
  font-size: 13px;
  text-align: center;
  border-radius: 2px;
  margin: 1px 7px;
  padding: 5px 5px;
}

.event-form .input-group .form-control {
  height: 40px;
}

.dropdown-action {
  margin-bottom: 5px;
}

.dropdown-action .dropdown-toggle:after {
  display: none;
}

.table-inbox {
  font-size: 15px;
  margin-bottom: 0;
}

.table-inbox input[type="radio"],
.table-inbox input[type="checkbox"] {
  cursor: pointer;
}

.table-inbox .starred.fa-star,
.table-inbox .fa-star {
  color: #ffd200;
}

.table-inbox tr {
  cursor: pointer;
}

.mail-list {
  list-style: none;
  padding: 0;
}

.mail-list > li > a {
  color: #333333;
  display: block;
  padding: 10px;
}

.mail-list > li.active > a {
  color: #00d0f1;
  font-weight: 700;
}

.unread .name,
.unread .subject,
.unread .mail-date {
  color: #000000;
  font-weight: 600;
}

.table.table-inbox > tbody > tr > th,
.table.table-inbox > tbody > tr > td,
.table.table-inbox > thead > tr > th,
.table.table-inbox > thead > tr > td,
.table.table-inbox > tfoot > tr > th,
.table.table-inbox > tfoot > tr > td {
  border-bottom: 1px solid #f2f2f2;
  border-top: 0;
}

.table.table-inbox thead {
  background-color: #ffffff;
}

.note-editor.note-frame {
  border: 1px solid #dddddd;
  box-shadow: inherit;
}

.note-editor.note-frame .note-statusbar {
  background-color: #ffffff;
}

.note-editor.note-frame.fullscreen {
  top: 60px;
}

.note-editor.note-frame .btn-light {
  background-color: #f9f9f9;
  box-shadow: unset;
  color: #333333;
}

.mail-title {
  font-weight: 700;
  text-transform: uppercase;
}

.form-control.search-message {
  border-color: #cccccc;
  height: 38px;
  width: 180px;
  border-radius: 4px;
}

table.table-inbox tbody tr.checked {
  background-color: #ffffcc;
}

.mail-label {
  font-size: 16px !important;
  margin-right: 5px;
}

.attachments {
  list-style: none;
  margin: 0;
  padding: 0;
}

.attachments li {
  border: 1px solid #eeeeee;
  float: left;
  margin-bottom: 10px;
  margin-right: 10px;
  width: 180px;
}

.attach-info {
  background-color: #f4f4f4;
  padding: 10px;
}

.attach-file {
  color: #777;
  font-size: 70px;
  min-height: 138px;
  padding: 10px;
}

.attach-file img {
  height: auto;
  max-width: 100%;
}

.mailview-header,
.mailview-footer {
  border-bottom: 1px solid #dddddd;
  margin-bottom: 20px;
  padding-bottom: 15px;
}

.mailview-footer .btn-white {
  margin-top: 10px;
  min-width: 102px;
}

.sender-img {
  float: left;
  margin-right: 10px;
  width: 40px;
}

.sender-name {
  display: block;
}

.receiver-name {
  color: #777;
}

.right-action,
.mail-view-action,
.mail-sent-time {
  text-align: right;
}

@media (max-width: 767.98px) {
  .mail-sent-time {
    float: left;
    margin-top: 10px;
    width: 100%;
  }
}

@media (max-width: 767.98px) {
  .right-action {
    text-align: center;
  }
}

@media (max-width: 767.98px) {
  .left-action {
    text-align: center;
    margin-bottom: 15px;
  }
}

.mail-view-title {
  font-weight: 500;
  font-size: 24px;
  margin: 0;
}

.inbox-menu {
  display: inline-block;
  width: 100%;
  margin: 0 0 1.875rem;
  padding: 0;
}

.inbox-menu li {
  display: inline-block;
  width: 100%;
}

.inbox-menu li + li {
  margin-top: 2px;
}

.inbox-menu li a {
  color: #333333;
  display: inline-block;
  width: 100%;
  text-transform: capitalize;
  -webkit-transition: 0.3s ease;
  -ms-transition: 0.3s ease;
  transition: 0.3s ease;
  padding: 10px 15px;
}

.inbox-menu li a i {
  font-size: 16px;
  padding-right: 10px;
  color: #878787;
}

.inbox-menu li a:hover,
.inbox-menu li a:focus {
  background: rgba(33, 33, 33, 0.05);
}

.inbox-menu li.active a {
  background: rgba(33, 33, 33, 0.05);
}

.compose-btn {
  margin-bottom: 1.875rem;
}

.compose-btn a {
  font-weight: 600;
  padding: 8px 15px;
}

.error-page {
  align-items: center;
  color: #1f1f1f;
  display: flex;
}

.error-page .main-wrapper {
  height: auto;
  width: 100%;
  min-height: unset;
}

.error-box {
  max-width: 480px;
  text-align: center;
  width: 100%;
  margin: 0 auto;
  padding: 1.875rem 0;
}

.error-box h1 {
  color: #00d0f1;
  font-size: 10em;
}

@media (max-width: 767.98px) {
  .error-box h1 {
    font-size: 6em;
  }
}

.error-box p {
  margin-bottom: 1.875rem;
}

.error-box .btn {
  font-size: 18px;
  font-weight: 600;
  min-width: 200px;
  border-radius: 50px;
  padding: 10px 20px;
}

@media (max-width: 767.98px) {
  .error-box .btn {
    font-size: 15px;
    min-width: 150px;
    padding: 8px 20px;
  }
}

.profile-header {
  background-color: #ffffff;
  border: 1px solid #f0f0f0;
  padding: 1.5rem;
}

.profile-header img {
  height: auto;
  max-width: 120px;
  width: 120px;
}

.profile-menu {
  background-color: #ffffff;
  border: 1px solid #f0f0f0;
  padding: 0.9375rem 1.5rem;
}

.profile-menu .nav-tabs.nav-tabs-solid {
  background-color: transparent;
}

.profile-tab-cont {
  padding-top: 1.875rem;
}

@media (max-width: 575.98px) {
  .profile-tab-cont {
    padding-top: 1.25rem;
  }
}

.about-text {
  max-width: 500px;
}

.skill-tags span {
  background-color: #f4f4f5;
  color: #66676b;
  display: inline-block;
  font-size: 15px;
  line-height: 22px;
  border-radius: 4px;
  margin: 2px 0;
  padding: 5px 15px;
}

.edit-link {
  color: #66676b;
  font-size: 16px;
  margin-top: 4px;
}

@media (max-width: 767.98px) {
  .edit-link {
    font-size: 0.875rem;
    margin-top: 0;
  }
}

.cal-icon {
  position: relative;
  width: 100%;
}

.cal-icon:after {
  color: #979797;
  content: "\\f073";
  display: block;
  font-family: "FontAwesome";
  font-size: 15px;
  margin: auto;
  position: absolute;
  top: 10px;
  right: 15px;
}

.form-title {
  width: 100%;
  max-width: 100%;
  font-size: 20px;
  font-weight: 500;
  line-height: inherit;
  color: #333333;
  white-space: normal;
  position: relative;
  display: block;
  margin: auto auto 20px;
  padding: 0;
}

.form-title:before {
  content: "";
  height: 1px;
  background-color: rgba(0, 0, 0, 0.1);
  position: absolute;
  top: 50%;
  right: 0px;
  left: 0;
}

.form-title span {
  background-color: #ffffff;
  display: inline-block;
  z-index: 2;
  position: relative;
  padding: 0px 0.5rem 0 0;
}

@media (max-width: 575.98px) {
  .account-wrapper {
    padding: 0.9375rem;
  }
}

@media (max-width: 575.98px) {
  .profile-image {
    flex: 0 0 100%;
    margin-bottom: 20px;
    text-align: center;
  }
}

@media (max-width: 575.98px) {
  .profile-user-info {
    text-align: center;
  }
}

@media (max-width: 767.98px) {
  .profile-btn {
    flex: 0 0 100%;
    margin-top: 20px;
  }
}

@media (max-width: 575.98px) {
  .profile-btn {
    text-align: center;
  }
}

.ant-form-item-label {
  padding: 0px !important;
  height: auto !important;
}

.chat-page .footer {
  display: none;
}

.chat-window {
  position: relative;
}

.chat-window .chat-cont-left {
  border-right: 1px solid #f0f0f0;
  -ms-flex: 0 0 35%;
  flex: 0 0 35%;
  max-width: 35%;
  z-index: 4;
  position: relative;
  left: 0;
}

@media (max-width: 1199.98px) {
  .chat-window .chat-cont-left {
    -ms-flex: 0 0 40%;
    flex: 0 0 40%;
    max-width: 40%;
  }
}

@media (max-width: 991.98px) {
  .chat-window .chat-cont-left {
    -ms-flex: 0 0 100%;
    flex: 0 0 100%;
    max-width: 100%;
    transition:
      left 0.3s ease-in-out 0s,
      right 0.3s ease-in-out 0s;
    width: 100%;
    border-right: 0;
  }
}

@media (max-width: 479.98px) {
  .chat-window .chat-cont-left a.media .media-body > div:first-child .user-name,
  .chat-window .chat-cont-left a.media .media-body > div:first-child .user-last-chat {
    max-width: 160px;
  }
}

.chat-window .chat-cont-left .chat-header {
  background-color: #ffffff;
  border-bottom: 1px solid #f0f0f0;
  color: #272b41;
  height: 72px;
  padding: 0 15px;
}

.chat-window .chat-cont-left .chat-header span {
  font-size: 20px;
  font-weight: 500;
  text-transform: capitalize;
}

.chat-window .chat-cont-left .chat-header .chat-compose {
  color: #8a8a8a;
}

.chat-window .chat-cont-left .chat-search {
  background-color: #f5f5f6;
  border-bottom: 1px solid #f3f3f3;
  padding: 10px 15px;
  width: 100%;
}

.chat-window .chat-cont-left .chat-search .input-group {
  width: 100%;
}

.chat-window .chat-cont-left .chat-search .input-group .form-control {
  background-color: #ffffff;
  padding-left: 36px;
  border-radius: 50px;
}

.chat-window .chat-cont-left .chat-search .input-group .form-control:focus {
  border-color: #cccccc;
  box-shadow: none;
}

.chat-window .chat-cont-left .chat-search .input-group .form-control::placeholder {
  font-size: 14px;
}

.chat-window .chat-cont-left .chat-search .input-group .input-group-prepend {
  color: #666;
  pointer-events: none;
  z-index: 4;
  position: absolute;
  top: 10px;
  bottom: 0;
  left: 15px;
}

.chat-window .chat-cont-left .chat-users-list {
  background-color: #ffffff;
}

.chat-window .chat-cont-left .chat-users-list a.media {
  border-bottom: 1px solid #f0f0f0;
  padding: 10px 15px;
  -webkit-transition: all 0.2s ease 0s;
  -ms-transition: all 0.2s ease 0s;
  transition: all 0.2s ease 0s;
}

.chat-window .chat-cont-left .chat-users-list a.media:last-child {
  border-bottom: 0;
}

.chat-window .chat-cont-left .chat-users-list a.media .media-img-wrap {
  margin-right: 15px;
  position: relative;
}

.chat-window .chat-cont-left .chat-users-list a.media .media-img-wrap .avatar {
  height: 45px;
  width: 45px;
}

.chat-window .chat-cont-left .chat-users-list a.media .media-img-wrap .status {
  height: 10px;
  width: 10px;
  border: 2px solid #ffffff;
  position: absolute;
  right: 4px;
  bottom: 7px;
}

.chat-window .chat-cont-left .chat-users-list a.media .media-body > div:first-child .user-name {
  max-width: 250px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #272b41;
  text-transform: capitalize;
}

@media (max-width: 1399.98px) {
  .chat-window .chat-cont-left .chat-users-list a.media .media-body > div:first-child .user-name {
    max-width: 180px;
  }
}

@media (max-width: 1199.98px) {
  .chat-window .chat-cont-left .chat-users-list a.media .media-body > div:first-child .user-name {
    max-width: 150px;
  }
}

@media (max-width: 767.98px) {
  .chat-window .chat-cont-left .chat-users-list a.media .media-body > div:first-child .user-name {
    max-width: 250px;
  }
}

@media (max-width: 479.98px) {
  .chat-window .chat-cont-left .chat-users-list a.media .media-body > div:first-child .user-name {
    max-width: 160px;
  }
}

.chat-window
  .chat-cont-left
  .chat-users-list
  a.media
  .media-body
  > div:first-child
  .user-last-chat {
  max-width: 250px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #8a8a8a;
  font-size: 14px;
  line-height: 24px;
}

@media (max-width: 1399.98px) {
  .chat-window
    .chat-cont-left
    .chat-users-list
    a.media
    .media-body
    > div:first-child
    .user-last-chat {
    max-width: 180px;
  }
}

@media (max-width: 1199.98px) {
  .chat-window
    .chat-cont-left
    .chat-users-list
    a.media
    .media-body
    > div:first-child
    .user-last-chat {
    max-width: 150px;
  }
}

@media (max-width: 767.98px) {
  .chat-window
    .chat-cont-left
    .chat-users-list
    a.media
    .media-body
    > div:first-child
    .user-last-chat {
    max-width: 250px;
  }
}

@media (max-width: 479.98px) {
  .chat-window
    .chat-cont-left
    .chat-users-list
    a.media
    .media-body
    > div:first-child
    .user-last-chat {
    max-width: 160px;
  }
}

.chat-window .chat-cont-left .chat-users-list a.media .media-body > div:last-child {
  text-align: right;
}

.chat-window .chat-cont-left .chat-users-list a.media .media-body > div:last-child .last-chat-time {
  color: #8a8a8a;
  font-size: 13px;
}

.chat-window .chat-cont-left .chat-users-list a.media:hover {
  background-color: #f5f5f6;
}

.chat-window
  .chat-cont-left
  .chat-users-list
  a.media.read-chat
  .media-body
  > div:last-child
  .last-chat-time {
  color: #8a8a8a;
}

.chat-window .chat-cont-left .chat-users-list a.media.active {
  background-color: #f5f5f6;
}

.chat-window .chat-scroll {
  min-height: 300px;
  max-height: calc(100vh - 224px);
  overflow-y: auto;
}

.chat-window .chat-cont-right {
  -ms-flex: 0 0 65%;
  flex: 0 0 65%;
  max-width: 65%;
}

@media (max-width: 1199.98px) {
  .chat-window .chat-cont-right {
    -ms-flex: 0 0 60%;
    flex: 0 0 60%;
    max-width: 60%;
  }
}

@media (max-width: 991.98px) {
  .chat-window .chat-cont-right {
    opacity: 0;
    visibility: hidden;
    position: absolute;
    top: 0;
    right: -100%;
    -ms-flex: 0 0 100%;
    flex: 0 0 100%;
    max-width: 100%;
    transition:
      left 0.3s ease-in-out 0s,
      right 0.3s ease-in-out 0s;
    width: 100%;
  }
}

.chat-window .chat-cont-right .chat-header {
  background-color: #ffffff;
  border-bottom: 1px solid #f0f0f0;
  height: 72px;
  padding: 0 15px;
}

@media (max-width: 991.98px) {
  .chat-window .chat-cont-right .chat-header {
    justify-content: start;
    -webkit-justify-content: start;
    -ms-flex-pack: start;
  }
}

.chat-window .chat-cont-right .chat-header .back-user-list {
  display: none;
  margin-right: 5px;
  margin-left: -7px;
}

@media (max-width: 991.98px) {
  .chat-window .chat-cont-right .chat-header .back-user-list {
    display: block;
  }
}

.chat-window .chat-cont-right .chat-header .media .media-img-wrap {
  position: relative;
  margin-right: 15px;
}

.chat-window .chat-cont-right .chat-header .media .media-img-wrap .avatar {
  height: 50px;
  width: 50px;
}

.chat-window .chat-cont-right .chat-header .media .media-img-wrap .status {
  border: 2px solid #ffffff;
  height: 10px;
  width: 10px;
  position: absolute;
  right: 3px;
  bottom: 0;
}

@media (max-width: 767.98px) {
  .chat-window .chat-cont-right .chat-header .media .media-body {
    display: none;
  }
}

.chat-window .chat-cont-right .chat-header .media .media-body .user-name {
  color: #272b41;
  font-size: 16px;
  font-weight: 500;
  text-transform: capitalize;
}

.chat-window .chat-cont-right .chat-header .media .media-body .user-status {
  color: #666;
  font-size: 14px;
}

@media (max-width: 991.98px) {
  .chat-window .chat-cont-right .chat-header .chat-options {
    margin-left: auto;
  }
}

.chat-window .chat-cont-right .chat-header .chat-options > a {
  border-radius: 50%;
  height: 30px;
  color: #8a8a8a;
  margin-left: 10px;
  width: 30px;
}

.chat-window .chat-cont-right .chat-body {
  background-color: #f5f5f6;
}

.chat-window .chat-cont-right .chat-body ul.list-unstyled {
  width: 100%;
  margin: 0 auto;
  padding: 15px;
}

.chat-window .chat-cont-right .chat-body .media .avatar {
  height: 30px;
  width: 30px;
}

.chat-window .chat-cont-right .chat-body .media .media-body {
  margin-left: 20px;
}

.chat-window .chat-cont-right .chat-body .media .media-body .msg-box > div {
  display: inline-block;
  position: relative;
  border-radius: 0.25rem;
  padding: 10px 15px;
}

.chat-window .chat-cont-right .chat-body .media .media-body .msg-box > div p {
  color: #272b41;
  margin-bottom: 0;
}

.chat-window .chat-cont-right .chat-body .media .media-body .msg-box + .msg-box {
  margin-top: 5px;
}

.chat-window .chat-cont-right .chat-body .media.received {
  margin-bottom: 20px;
}

.chat-window .chat-cont-right .chat-body .media.received .media-body {
  position: relative;
}

.chat-window .chat-cont-right .chat-body .media.received .media-body .msg-box > div {
  background-color: #ffffff;
}

.chat-window .chat-cont-right .chat-body .media.received .media-body .msg-box > div .chat-time {
  color: rgba(50, 65, 72, 0.4);
}

.chat-window .chat-cont-right .chat-body .media.received .media-body .msg-box:first-child:before {
  border-bottom: 6px solid transparent;
  border-right: 6px solid #ffffff;
  border-top: 6px solid transparent;
  content: "";
  height: 0;
  width: 0;
  position: absolute;
  top: 8px;
  right: auto;
  left: -6px;
}

.chat-window .chat-cont-right .chat-body .media.sent .media-body .msg-box {
  padding-left: 50px;
  position: relative;
}

.chat-window .chat-cont-right .chat-body .media.sent .media-body .msg-box:first-child:before {
  border-bottom: 6px solid transparent;
  border-left: 6px solid #e3e3e3;
  border-top: 6px solid transparent;
  content: "";
  height: 0;
  width: 0;
  position: absolute;
  top: 8px;
  right: -6px;
  left: auto;
}

.chat-window .chat-cont-right .chat-body .media.sent .media-body .msg-box > div .chat-time {
  color: rgba(50, 65, 72, 0.4);
}

.chat-window .chat-cont-right .chat-body .media:last-child {
  margin-bottom: 0;
}

.chat-window .chat-cont-right .chat-body .media.sent {
  margin-bottom: 20px;
}

.chat-window .chat-cont-right .chat-body .media.sent .media-body {
  margin-left: 0;
}

.chat-window .chat-cont-right .chat-body .media.sent .media-body .msg-box > div {
  background-color: #e3e3e3;
}

.chat-window .chat-cont-right .chat-body .media.sent .media-body .msg-box > div p {
  color: #272b41;
}

.chat-window .chat-cont-right .chat-body .media.sent .media-body .msg-box > div .chat-msg-info {
  flex-direction: row-reverse;
}

.chat-window .chat-cont-right .chat-body .media.sent .media-body .msg-box > div .chat-msg-info li {
  padding-left: 16px;
  padding-right: 0;
  position: relative;
}

.chat-window
  .chat-cont-right
  .chat-body
  .media.sent
  .media-body
  .msg-box
  > div
  .chat-msg-attachments {
  flex-direction: row-reverse;
}

.chat-window
  .chat-cont-right
  .chat-body
  .media.sent
  .media-body
  .msg-box
  > div:hover
  .chat-msg-actions {
  opacity: 1;
}

.chat-window .chat-cont-right .chat-body .chat-date {
  font-size: 14px;
  margin: 1.875rem 0;
  overflow: hidden;
  position: relative;
  text-align: center;
  text-transform: capitalize;
}

.chat-window .chat-cont-right .chat-body .chat-date:before {
  background-color: #eef6ff;
  content: "";
  height: 1px;
  margin-right: 28px;
  width: 100%;
  position: absolute;
  top: 50%;
  right: 50%;
}

.chat-window .chat-cont-right .chat-body .chat-date:after {
  background-color: #eef6ff;
  content: "";
  height: 1px;
  margin-left: 28px;
  width: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
}

.chat-window .chat-cont-right .chat-footer {
  background-color: #ffffff;
  position: relative;
  border-top: 1px solid #f0f0f0;
  padding: 10px 15px;
}

.chat-window .chat-cont-right .chat-footer .input-group {
  width: 100%;
}

.chat-window .chat-cont-right .chat-footer .input-group .form-control {
  background-color: #f5f5f6;
  border: none;
  border-radius: 50px;
}

.chat-window .chat-cont-right .chat-footer .input-group .form-control:focus {
  background-color: #f5f5f6;
  border: none;
  box-shadow: none;
}

.chat-window .chat-cont-right .chat-footer .input-group .form-control::placeholder {
  font-size: 14px;
}

.chat-window .chat-cont-right .chat-footer .input-group .btn {
  background-color: transparent;
  border: none;
  color: #9f9f9f;
}

.chat-window .chat-cont-right .chat-footer .input-group .btn.msg-send-btn {
  background-color: #0de0fe;
  border-color: #0de0fe;
  color: #ffffff;
  margin-left: 10px;
  min-width: 46px;
  font-size: 20px;
  border-radius: 50%;
}

.chat-window .chat-cont-right .msg-typing {
  width: auto;
  height: 24px;
  padding-top: 8px;
}

.chat-window .chat-cont-right .msg-typing span {
  height: 8px;
  width: 8px;
  float: left;
  margin: 0 1px;
  background-color: #a0a0a0;
  display: block;
  opacity: 0.4;
  border-radius: 50%;
}

.chat-window .chat-cont-right .msg-typing span:nth-of-type(1) {
  animation: 1s blink infinite 0.33333s;
}

.chat-window .chat-cont-right .msg-typing span:nth-of-type(2) {
  animation: 1s blink infinite 0.66666s;
}

.chat-window .chat-cont-right .msg-typing span:nth-of-type(3) {
  animation: 1s blink infinite 0.99999s;
}

.chat-window .chat-msg-info {
  clear: both;
  list-style: none;
  margin: 5px 0 0;
  padding: 0;
}

.chat-window .chat-msg-info li {
  font-size: 13px;
  padding-right: 16px;
  position: relative;
}

.chat-window .chat-msg-info li:not(:last-child):after {
  content: "";
  height: 4px;
  width: 4px;
  background: #d2dde9;
  border-radius: 50%;
  transform: translate(50%, -50%);
  -webkit-transform: translate(50%, -50%);
  -ms-transform: translate(50%, -50%);
  position: absolute;
  top: 50%;
  right: 8px;
}

.chat-window .chat-msg-info li a {
  color: #777;
}

.chat-window .chat-msg-info li a:hover {
  color: #2c80ff;
}

@media (max-width: 991.98px) {
  .chat-window.chat-slide .chat-cont-left {
    left: -100%;
  }
}

@media (max-width: 991.98px) {
  .chat-window.chat-slide .chat-cont-right {
    right: 0;
    opacity: 1;
    visibility: visible;
  }
}

.chat-seen i {
  color: #00d285;
  font-size: 16px;
}

.chat-msg-attachments {
  width: 100%;
  margin: 0 -1px;
  padding: 4px 0;
}

.chat-msg-attachments > div {
  margin: 0 1px;
}

.chat-attachment {
  position: relative;
  max-width: 130px;
  overflow: hidden;
  border-radius: 0.25rem;
}

.chat-attachment img {
  max-width: 100%;
}

.chat-attachment:before {
  background: #000000;
  content: "";
  opacity: 0.4;
  -webkit-transition: all 0.4s;
  -ms-transition: all 0.4s;
  transition: all 0.4s;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.chat-attachment:hover:before {
  opacity: 0.6;
}

.chat-attachment:hover .chat-attach-caption {
  opacity: 0;
}

.chat-attachment:hover .chat-attach-download {
  opacity: 1;
}

.chat-attach-caption {
  color: #ffffff;
  padding: 7px 15px;
  font-size: 13px;
  opacity: 1;
  -webkit-transition: all 0.4s;
  -ms-transition: all 0.4s;
  transition: all 0.4s;
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
}

.chat-attach-download {
  opacity: 0;
  color: #ffffff;
  width: 32px;
  line-height: 32px;
  background: rgba(255, 255, 255, 0.2);
  text-align: center;
  transform: translate(-50%, -50%);
  -webkit-transition: all 0.4s;
  -ms-transition: all 0.4s;
  transition: all 0.4s;
  position: absolute;
  top: 50%;
  left: 50%;
}

.chat-attach-download:hover {
  color: #495463;
  background: #ffffff;
}

chat-attachment-list {
  margin: -5px;
}

chat-attachment-list li {
  width: 33.33%;
  padding: 5px;
}

.chat-attachment-item {
  border: 5px solid rgba(230, 239, 251, 0.5);
  height: 100%;
  min-height: 60px;
  text-align: center;
  font-size: 30px;
}

.chat-msg-actions {
  opacity: 0;
  z-index: 2;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  -webkit-transition: all 0.4s;
  -ms-transition: all 0.4s;
  transition: all 0.4s;
  position: absolute;
  top: 50%;
  left: -30px;
}

.chat-msg-actions > a {
  color: #495463;
  font-size: 24px;
  padding: 0 10px;
}

.chat-msg-actions > a:hover {
  color: #2c80ff;
}

@keyframes blink {
  50% {
    opacity: 1;
  }
}

.btn-file {
  font-size: 20px;
  overflow: hidden;
  position: relative;
  vertical-align: middle;
  padding: 0 0.75rem;
}

.btn-file input {
  cursor: pointer;
  filter: alpha(opacity=0);
  font-size: 23px;
  height: 100%;
  margin: 0;
  opacity: 0;
  width: 100%;
  position: absolute;
  top: 0;
  right: 0;
}

.incoming-btns {
  margin-top: 20px;
}

.call-wrapper {
  position: relative;
  height: calc(100vh - 145px);
}

.chat-window {
  display: flex;
}

/* Only the search *button* icon sits on a filled background; icons in inputs keep their color. */
.ant-input-search-button .anticon.anticon-search {
  color: #fff !important;
}

.ant-alert-with-description {
  align-items: center !important;
}
`, "",{"version":3,"sources":["webpack://./src/commons/PanelAssets/css/custom.css"],"names":[],"mappings":"AAEA;;;EAGE,aAAa;EACb,qBAAqB;EACrB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;;;EAGE,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,2BAA2B;EAC3B,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;;;;EAIE,uBAAuB;EACvB,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;;EAEE,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,4CAA4C;;EAE5C;;;;;8DAK4D;AAC9D;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,+BAA+B;EAC/B,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;;;;;;EAME,+BAA+B;EAC/B,aAAa;AACf;;AAEA;EACE,iCAAiC;EACjC,6BAA6B;EAC7B,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,aAAa;EACb,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;;EAGE,iDAAiD;EACjD,yDAAyD;AAC3D;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,iCAAiC;EACjC,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;;;;EAIE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,uCAAuC;AACzC;;AAEA;;EAEE,wBAAwB;EACxB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;;;EAGE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,cAAc;EACd,oBAAoB;EACpB,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,mCAAmC;EACnC,kCAAkC;EAClC,kCAAkC;EAClC,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;;IAEE,eAAe;EACjB;AACF;;AAEA;EACE;;IAEE,eAAe;EACjB;AACF;;AAEA;EACE;;IAEE,eAAe;EACjB;AACF;;AAEA;EACE;;IAEE,eAAe;EACjB;AACF;;AAEA;EACE;;IAEE,eAAe;EACjB;AACF;;AAEA;EACE;;IAEE,eAAe;EACjB;AACF;;AAEA;;;EAGE,aAAa;EACb,qBAAqB;EACrB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;;;EAGE,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,2BAA2B;EAC3B,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;;;;EAIE,uBAAuB;EACvB,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;;EAEE,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,cAAc;EACd,QAAQ;EACR,SAAS;EACT,kBAAkB;EAClB,UAAU;EACV,oBAAoB;EACpB,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,6CAA6C;EAC7C,qDAAqD;EACrD,iDAAiD;AACnD;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB;;wBAEsB;EACtB,+BAA+B;EAC/B,uCAAuC;EACvC,mCAAmC;EACnC,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;EACR,OAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,0CAA0C;EAC1C,sCAAsC;EACtC,kCAAkC;EAClC,WAAW;AACb;;AAEA;;EAEE,sBAAsB;EACtB,cAAc;EACd,cAAc;EACd,WAAW;EACX,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,uCAAuC;EACvC,mCAAmC;EACnC,+BAA+B;EAC/B,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;EAGE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;;EAGE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;;;EAGE,uBAAuB;AACzB;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;EAGE,wBAAwB;EACxB,yBAAyB;EACzB,4BAA4B;EAC5B,6BAA6B;EAC7B,mCAAmC;EACnC,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;;EAGE,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,iCAAiC;EACjC,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iCAAiC;IACjC,6BAA6B;IAC7B,yBAAyB;EAC3B;AACF;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE;IACE,cAAc;IACd,WAAW;EACb;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,YAAY;IACZ,gBAAgB;IAChB,WAAW;EACb;AACF;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,aAAa;EACb,YAAY;EACZ,eAAe;EACf,MAAM;EACN,QAAQ;EACR,OAAO;AACT;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,wCAAwC;EACxC,oCAAoC;EACpC,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE;IACE,kBAAkB;IAClB,WAAW;EACb;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;EAEE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,cAAc;EACd,gCAAgC;EAChC,+BAA+B;EAC/B,WAAW;EACX,WAAW;EACX,qBAAqB;EACrB,oBAAoB;EACpB,yBAAyB;EACzB,iCAAiC;EACjC,6BAA6B;EAC7B,wBAAwB;EACxB,gCAAgC;EAChC,4BAA4B;EAC5B,yCAAyC;EACzC,qCAAqC;EACrC,iCAAiC;EACjC,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,0BAA0B;EAC1B,kCAAkC;EAClC,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,eAAe;AACjB;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE;IACE,yBAAyB;IACzB,eAAe;IACf,cAAc;IACd,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,MAAM;IACN,OAAO;EACT;AACF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;;;EAIE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,aAAa;EACb,YAAY;EACZ,WAAW;EACX,aAAa;EACb,eAAe;EACf,SAAS;EACT,OAAO;AACT;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,gCAAgC;EAChC,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,MAAM;EACN,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,OAAO;AACT;;AAEA;EACE;IACE,mBAAmB;IACnB,cAAc;IACd,oBAAoB;IACpB,WAAW;IACX,eAAe;IACf,YAAY;IACZ,uBAAuB;IACvB,iBAAiB;IACjB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,UAAU;IACV,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,UAAU;IACV,aAAa;EACf;AACF;;AAEA;EACE;IACE,WAAW;IACX,WAAW;IACX,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,WAAW;IACX,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,WAAW;IACX,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,UAAU;IACV,QAAQ;EACV;AACF;;AAEA;EACE;IACE,UAAU;IACV,QAAQ;EACV;AACF;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;;;;EAIE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,SAAS;AACX;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gDAAgD;AAClD;;AAEA;;EAEE,iCAAiC;AACnC;;AAEA;EACE,UAAU;AACZ;;AAEA;;EAEE,6BAA6B;EAC7B,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;;;;EAIE,oCAAoC;AACtC;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;;;;EAIE,oCAAoC;AACtC;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;;;;EAIE,oCAAoC;AACtC;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;;;;EAIE,oCAAoC;AACtC;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;;;;EAIE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;;;;EAIE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;;EAIE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;;;;;;;;;;;;;;;;;;EAkBE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;;;;EAIE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;;EAGE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;;;;;;EAME,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;;;;EAIE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;;;;;;EAME,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;;;;EAIE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;;;;;;EAME,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;;;;EAIE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;;;;;;EAME,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;;;;EAIE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;;;;;;EAME,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;EACpC,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,4BAA4B;EAC5B,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,+CAA+C;EAC/C,4CAA4C;EAC5C,uCAAuC;EACvC,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;EAEE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,oDAAoD;EACpD,yBAAyB;AAC3B;;AAEA;EACE,qDAAqD;EACrD,yBAAyB;AAC3B;;AAEA;EACE,oDAAoD;EACpD,yBAAyB;AAC3B;;AAEA;EACE,oDAAoD;EACpD,yBAAyB;AAC3B;;AAEA;EACE,qDAAqD;EACrD,yBAAyB;AAC3B;;AAEA;EACE,sDAAsD;EACtD,yBAAyB;AAC3B;;AAEA;EACE,mDAAmD;EACnD,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE;IACE,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,eAAe;IACf,UAAU;EACZ;AACF;;AAEA;EACE;IACE,eAAe;IACf,WAAW;EACb;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,aAAa;IACb,UAAU;IACV,wCAAwC;IACxC,oCAAoC;IACpC,gCAAgC;EAClC;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,2CAA2C;EAC3C,uCAAuC;EACvC,mCAAmC;EACnC,YAAY;EACZ,aAAa;EACb,eAAe;EACf,SAAS;EACT,SAAS;EACT,OAAO;AACT;;AAEA;EACE;IACE,mBAAmB;IACnB,YAAY;IACZ,iCAAiC;IACjC,6BAA6B;IAC7B,yBAAyB;IACzB,aAAa;EACf;AACF;;AAEA;EACE,iCAAiC;EACjC,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,2BAA2B;EAC3B,kBAAkB;EAClB,cAAc;EACd,2CAA2C;EAC3C,uCAAuC;EACvC,mCAAmC;EACnC,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,2CAA2C;EAC3C,uCAAuC;EACvC,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,0BAA0B;EAC1B,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,mCAAmC;EACnC,kCAAkC;EAClC,iBAAiB;EACjB,mCAAmC;EACnC,+BAA+B;EAC/B,2BAA2B;EAC3B,0BAA0B;EAC1B,kCAAkC;EAClC,8BAA8B;EAC9B,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;EACxB,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;EACX,2CAA2C;EAC3C,uCAAuC;EACvC,mCAAmC;AACrC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,2CAA2C;EAC3C,uCAAuC;EACvC,mCAAmC;AACrC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,cAAc;EACd,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,eAAe;AACjB;;AAEA;;;EAGE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,eAAe;AACjB;;AAEA;;;EAGE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,eAAe;AACjB;;AAEA;;;EAGE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,eAAe;AACjB;;AAEA;;;EAGE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;;;EAGE,iBAAiB;AACnB;;AAEA;EACE;;;IAGE,iBAAiB;EACnB;AACF;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,6CAA6C;EAC7C,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,QAAQ;EACR,kBAAkB;EAClB,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;;;;EAIE,6CAA6C;EAC7C,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,0BAA0B;EAC1B,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,8BAA8B;EAC9B,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,WAAW;EACX,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;EAEE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE;IACE,iBAAiB;IACjB,wBAAwB;EAC1B;AACF;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,eAAe;EACf,yBAAyB;AAC3B;;AAEA;;EAEE,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,cAAc;EACd,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,+CAA+C;EAC/C,4CAA4C;EAC5C,uCAAuC;AACzC;;AAEA;EACE;IACE,gBAAgB;IAChB,iBAAiB;EACnB;AACF;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,qDAAqD;EACrD,0BAA0B;EAC1B,aAAa;AACf;;AAEA;EACE;IACE,UAAU;IACV,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE;IACE,UAAU;IACV,aAAa;EACf;AACF;;AAEA;EACE;IACE,WAAW;IACX,WAAW;IACX,iBAAiB;EACnB;AACF;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,WAAW;EACX,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;;;EAGE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,uBAAuB;EACvB,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE;IACE,WAAW;IACX,gBAAgB;EAClB;AACF;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE;IACE,WAAW;IACX,gBAAgB;EAClB;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,qBAAqB;IACrB,WAAW;IACX,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,WAAW;IACX,YAAY;IACZ,cAAc;EAChB;AACF;;AAEA;EACE;IACE,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,WAAW;IACX,mBAAmB;EACrB;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;;;;;EAKE,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;;;;;;;EAOE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,0BAA0B;EAC1B,2BAA2B;EAC3B,6BAA6B;EAC7B,uBAAuB;EACvB,wBAAwB;EACxB,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;EAGE,oCAAoC;EACpC,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,cAAc;EACd,aAAa;AACf;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;;EAGE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;;;;;EAME,gCAAgC;EAChC,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;;EAEE,gCAAgC;EAChC,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;;;EAGE,iBAAiB;AACnB;;AAEA;EACE;IACE,WAAW;IACX,gBAAgB;IAChB,WAAW;EACb;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,WAAW;EACX,0BAA0B;EAC1B,6BAA6B;EAC7B,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB;IAChB,iBAAiB;EACnB;AACF;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE;IACE,mBAAmB;IACnB,aAAa;EACf;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,0BAA0B;EAC1B,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,WAAW;EACX,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,WAAW;EACX,oCAAoC;EACpC,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,OAAO;AACT;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,UAAU;EACV,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,cAAc;IACd,mBAAmB;IACnB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,cAAc;IACd,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;EACjB,aAAa;EACb,cAAc;EACd,UAAU;EACV,kBAAkB;EAClB,OAAO;AACT;;AAEA;EACE;IACE,iBAAiB;IACjB,aAAa;IACb,cAAc;EAChB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf;;+BAE2B;IAC3B,WAAW;IACX,eAAe;EACjB;AACF;;AAEA;EACE;;IAEE,gBAAgB;EAClB;AACF;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;EAChC,cAAc;EACd,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;EAChC,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,UAAU;EACV,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,oCAAoC;EACpC,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;;;;;;;EAOE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE;;;;;;;IAOE,gBAAgB;EAClB;AACF;;AAEA;EACE;;;;;;;IAOE,gBAAgB;EAClB;AACF;;AAEA;EACE;;;;;;;IAOE,gBAAgB;EAClB;AACF;;AAEA;EACE;;;;;;;IAOE,gBAAgB;EAClB;AACF;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;;;;;EAOE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE;IACE,iBAAiB;IACjB,aAAa;IACb,cAAc;EAChB;AACF;;AAEA;EACE;IACE,UAAU;IACV,kBAAkB;IAClB,kBAAkB;IAClB,MAAM;IACN,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf;;+BAE2B;IAC3B,WAAW;EACb;AACF;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;EAChC,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE;IACE,sBAAsB;IACtB,8BAA8B;IAC9B,oBAAoB;EACtB;AACF;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,SAAS;AACX;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,cAAc;EACd,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;EACpC,+BAA+B;EAC/B,iCAAiC;EACjC,WAAW;EACX,SAAS;EACT,QAAQ;EACR,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,iCAAiC;EACjC,WAAW;EACX,SAAS;EACT,QAAQ;EACR,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;;;;;;;EAQE,2BAA2B;AAC7B;;AAEA;;;;;;;;EAQE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,WAAW;EACX,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,UAAU;EACV,mBAAmB;EACnB,kBAAkB;EAClB,+BAA+B;EAC/B,uCAAuC;EACvC,mCAAmC;EACnC,kBAAkB;EAClB,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,QAAQ;IACR,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,wBAAwB;EACxB,oBAAoB;EACpB,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;AACT;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,UAAU;EACV,4BAA4B;EAC5B,wBAAwB;EACxB,oBAAoB;EACpB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,OAAO;AACT;;AAEA;EACE,UAAU;EACV,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,oCAAoC;EACpC,kBAAkB;EAClB,gCAAgC;EAChC,4BAA4B;EAC5B,wBAAwB;EACxB,oBAAoB;EACpB,kBAAkB;EAClB,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,0CAA0C;EAC1C,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,UAAU;EACV,2BAA2B;EAC3B,mCAAmC;EACnC,+BAA+B;EAC/B,4BAA4B;EAC5B,wBAAwB;EACxB,oBAAoB;EACpB,kBAAkB;EAClB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,eAAe;EACf,YAAY;EACZ,SAAS;EACT,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,QAAQ;AACV;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;AACf;;AAEA,iGAAiG;AACjG;EACE,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;AAChC","sourcesContent":["@import url(\"https://fonts.googleapis.com/css?family=Mada:400,500,600,700&display=swap\");\n\n.error-page .main-wrapper,\n.css-equal-content,\n.css-equal-heights {\n  display: flex;\n  display: -webkit-flex;\n  flex-wrap: wrap;\n  -webkit-flex-wrap: wrap;\n}\n\n.css-equal-content {\n  color: red;\n  float: left;\n}\n\n.attach-file,\n.login-wrapper .loginbox .login-right,\n.align-center {\n  display: flex;\n  display: -webkit-flex;\n  align-items: center;\n  -webkit-align-items: center;\n  justify-content: center;\n  -webkit-justify-content: center;\n}\n\n.error-page .main-wrapper,\n.login-wrapper .loginbox .login-left,\n.dash-widget-icon,\n.avatar .avatar-title {\n  justify-content: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n}\n\n.dash-widget-icon,\n.avatar .avatar-title {\n  align-items: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n}\n\n.avatar-group {\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n}\n\n.avatar .avatar-title {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n\n.onoffswitch {\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n@font-face {\n  font-family: \"Material Icons\";\n  font-style: normal;\n  font-weight: 400;\n  src: url(../fonts/MaterialIcons-Regular.eot);\n\n  src:\n    local(\"Material Icons\"),\n    local(\"MaterialIcons-Regular\"),\n    url(../fonts/MaterialIcons-Regular.woff2) format(\"woff2\"),\n    url(../fonts/MaterialIcons-Regular.woff) format(\"woff\"),\n    url(../fonts/MaterialIcons-Regular.ttf) format(\"truetype\");\n}\n\n.primary {\n  background-color: #00d0f1;\n}\n\nhtml {\n  height: 100%;\n}\n\nbody {\n  background-color: #f8f9fa;\n  color: #333333;\n  font-family: \"Mada\", sans-serif;\n  font-size: 1rem;\n  height: 100%;\n  line-height: 1.5;\n  overflow-x: hidden;\n}\n\n@media (max-width: 767.98px) {\n  body {\n    font-size: 15px;\n  }\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-family: \"Mada\", sans-serif;\n  margin-top: 0;\n}\n\na {\n  -webkit-transition: all 0.4s ease;\n  -ms-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n  text-decoration: none;\n}\n\na:hover,\na:focus,\na:active {\n  outline: none;\n  text-decoration: none;\n  color: #00d0f1;\n}\n\ninput:-webkit-autofill,\ninput:-webkit-autofill:hover,\ninput:-webkit-autofill:focus {\n  box-shadow: 0 0 0px 1000px white inset !important;\n  -webkit-box-shadow: 0 0 0px 1000px white inset !important;\n}\n\n.form-control {\n  border: 1px solid #dddddd;\n  box-shadow: none;\n  color: #333333;\n  font-size: 15px;\n  height: 40px;\n}\n\n.form-control:focus {\n  border-color: #00d0f1;\n  box-shadow: none;\n  outline: 0 none;\n}\n\n.form-control.form-control-sm {\n  height: calc(1.5em + 0.5rem + 2px);\n}\n\n.form-control.form-control-lg {\n  height: calc(1.5em + 1rem + 2px);\n}\n\na {\n  color: #0dd9f9;\n}\n\ninput,\nbutton {\n  -webkit-transition: all 0.4s ease;\n  -ms-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n\ninput:focus,\ninput:hover,\nbutton:focus,\nbutton:hover {\n  outline: none;\n}\n\ninput[type=\"file\"] {\n  height: auto;\n  min-height: calc(1.5em + 0.75rem + 2px);\n}\n\ninput[type=\"text\"],\ninput[type=\"password\"] {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n}\n\ntextarea.form-control {\n  resize: vertical;\n}\n\n.navbar-nav > li {\n  float: left;\n}\n\n.form-group {\n  margin-bottom: 1.25rem;\n}\n\n.input-group .form-control {\n  height: 40px;\n}\n\n.nav .open a,\n.nav .open a:hover,\n.nav .open a:focus {\n  background-color: rgba(0, 0, 0, 0.1);\n  border-color: rgba(0, 0, 0, 0.1);\n}\n\n.material-icons {\n  font-family: \"Material Icons\";\n  font-weight: normal;\n  font-style: normal;\n  font-size: 24px;\n  display: inline-block;\n  line-height: 1;\n  text-transform: none;\n  letter-spacing: normal;\n  word-wrap: normal;\n  white-space: nowrap;\n  direction: ltr;\n  -webkit-font-smoothing: antialiased;\n  text-rendering: optimizeLegibility;\n  -moz-osx-font-smoothing: grayscale;\n  font-feature-settings: \"liga\";\n}\n\n.font-weight-600 {\n  font-weight: 600;\n}\n\n@media (max-width: 767.98px) {\n  h1,\n  .h1 {\n    font-size: 32px;\n  }\n}\n\n@media (max-width: 767.98px) {\n  h2,\n  .h2 {\n    font-size: 28px;\n  }\n}\n\n@media (max-width: 767.98px) {\n  h3,\n  .h3 {\n    font-size: 24px;\n  }\n}\n\n@media (max-width: 767.98px) {\n  h4,\n  .h4 {\n    font-size: 18px;\n  }\n}\n\n@media (max-width: 767.98px) {\n  h5,\n  .h5 {\n    font-size: 16px;\n  }\n}\n\n@media (max-width: 767.98px) {\n  h6,\n  .h6 {\n    font-size: 14px;\n  }\n}\n\n.error-page .main-wrapper,\n.css-equal-heights,\n.css-equal-content {\n  display: flex;\n  display: -webkit-flex;\n  flex-wrap: wrap;\n  -webkit-flex-wrap: wrap;\n}\n\n.css-equal-content {\n  color: red;\n  float: left;\n}\n\n.attach-file,\n.login-wrapper .loginbox .login-right,\n.align-center {\n  display: flex;\n  display: -webkit-flex;\n  align-items: center;\n  -webkit-align-items: center;\n  justify-content: center;\n  -webkit-justify-content: center;\n}\n\n.error-page .main-wrapper,\n.login-wrapper .loginbox .login-left,\n.dash-widget-icon,\n.avatar .avatar-title {\n  justify-content: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n}\n\n.dash-widget-icon,\n.avatar .avatar-title {\n  align-items: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n}\n\n.avatar-group {\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n}\n\n.avatar .avatar-title {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n\n.onoffswitch {\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n.col {\n  width: auto;\n  padding-left: 15px;\n  padding-right: 15px;\n  float: left;\n  position: relative;\n  min-height: 1px;\n}\n\n@media (min-width: 320px) {\n  .col.col-xs-12 {\n    width: 100%;\n  }\n\n  .col.col-xs-11 {\n    width: 91.66666667%;\n  }\n\n  .col.col-xs-10 {\n    width: 83.33333333%;\n  }\n\n  .col.col-xs-9 {\n    width: 75%;\n  }\n\n  .col.col-xs-8 {\n    width: 66.66666667%;\n  }\n\n  .col.col-xs-7 {\n    width: 58.33333333%;\n  }\n\n  .col.col-xs-6 {\n    width: 50%;\n  }\n\n  .col.col-xs-5 {\n    width: 41.66666667%;\n  }\n\n  .col.col-xs-4 {\n    width: 33.33333333%;\n  }\n\n  .col.col-xs-3 {\n    width: 25%;\n  }\n\n  .col.col-xs-2 {\n    width: 16.66666667%;\n  }\n\n  .col.col-xs-1 {\n    width: 8.33333333%;\n  }\n}\n\n@media (min-width: 568px) {\n  .col.col-sm-12 {\n    width: 100%;\n  }\n\n  .col.col-sm-11 {\n    width: 91.66666667%;\n  }\n\n  .col.col-sm-10 {\n    width: 83.33333333%;\n  }\n\n  .col.col-sm-9 {\n    width: 75%;\n  }\n\n  .col.col-sm-8 {\n    width: 66.66666667%;\n  }\n\n  .col.col-sm-7 {\n    width: 58.33333333%;\n  }\n\n  .col.col-sm-6 {\n    width: 50%;\n  }\n\n  .col.col-sm-5 {\n    width: 41.66666667%;\n  }\n\n  .col.col-sm-4 {\n    width: 33.33333333%;\n  }\n\n  .col.col-sm-3 {\n    width: 25%;\n  }\n\n  .col.col-sm-2 {\n    width: 16.66666667%;\n  }\n\n  .col.col-sm-1 {\n    width: 8.33333333%;\n  }\n}\n\n@media (min-width: 768px) {\n  .col.col-md-12 {\n    width: 100%;\n  }\n\n  .col.col-md-11 {\n    width: 91.66666667%;\n  }\n\n  .col.col-md-10 {\n    width: 83.33333333%;\n  }\n\n  .col.col-md-9 {\n    width: 75%;\n  }\n\n  .col.col-md-8 {\n    width: 66.66666667%;\n  }\n\n  .col.col-md-7 {\n    width: 58.33333333%;\n  }\n\n  .col.col-md-6 {\n    width: 50%;\n  }\n\n  .col.col-md-5 {\n    width: 41.66666667%;\n  }\n\n  .col.col-md-4 {\n    width: 33.33333333%;\n  }\n\n  .col.col-md-3 {\n    width: 25%;\n  }\n\n  .col.col-md-2 {\n    width: 16.66666667%;\n  }\n\n  .col.col-md-1 {\n    width: 8.33333333%;\n  }\n}\n\n@media (min-width: 1024px) {\n  .col.col-lg-12 {\n    width: 100%;\n  }\n\n  .col.col-lg-11 {\n    width: 91.66666667%;\n  }\n\n  .col.col-lg-10 {\n    width: 83.33333333%;\n  }\n\n  .col.col-lg-9 {\n    width: 75%;\n  }\n\n  .col.col-lg-8 {\n    width: 66.66666667%;\n  }\n\n  .col.col-lg-7 {\n    width: 58.33333333%;\n  }\n\n  .col.col-lg-6 {\n    width: 50%;\n  }\n\n  .col.col-lg-5 {\n    width: 41.66666667%;\n  }\n\n  .col.col-lg-4 {\n    width: 33.33333333%;\n  }\n\n  .col.col-lg-3 {\n    width: 25%;\n  }\n\n  .col.col-lg-2 {\n    width: 16.66666667%;\n  }\n\n  .col.col-lg-1 {\n    width: 8.33333333%;\n  }\n}\n\n.check {\n  display: block;\n  width: 0;\n  height: 0;\n  visibility: hidden;\n  opacity: 0;\n  pointer-events: none;\n  position: absolute;\n  margin: 0;\n  padding: 0;\n}\n\n.check:checked + .checktoggle {\n  background-color: #55ce63;\n}\n\n.check:checked + .checktoggle:after {\n  left: 100%;\n  transform: translate(calc(-100% - 5px), -50%);\n  -webkit-transform: translate(calc(-100% - 5px), -50%);\n  -ms-transform: translate(calc(-100% - 5px), -50%);\n}\n\n.checktoggle {\n  background-color: #e0001a;\n  cursor: pointer;\n  display: block;\n  font-size: 0;\n  height: 24px;\n  margin-bottom: 0;\n  position: relative;\n  width: 48px;\n  border-radius: 12px;\n}\n\n.checktoggle:after {\n  content: \" \";\n  display: block;\n  width: 16px;\n  height: 16px;\n  background-color: #ffffff;\n  transition:\n    left 300ms ease,\n    transform 300ms ease;\n  transform: translate(5px, -50%);\n  -webkit-transform: translate(5px, -50%);\n  -ms-transform: translate(5px, -50%);\n  border-radius: 50%;\n  position: absolute;\n  top: 50%;\n  left: 0;\n}\n\n.onoffswitch {\n  margin-left: auto;\n  position: relative;\n  width: 73px;\n}\n\n.onoffswitch-checkbox {\n  display: none;\n}\n\n.onoffswitch-checkbox:checked + .onoffswitch-label .onoffswitch-inner {\n  margin-left: 0;\n}\n\n.onoffswitch-checkbox:checked + .onoffswitch-label .onoffswitch-switch {\n  right: 0px;\n}\n\n.onoffswitch-label {\n  display: block;\n  overflow: hidden;\n  cursor: pointer;\n  margin-bottom: 0;\n  border-radius: 20px;\n}\n\n.onoffswitch-inner {\n  display: block;\n  margin-left: -100%;\n  -webkit-transition: margin 0.3s ease-in 0s;\n  -ms-transition: margin 0.3s ease-in 0s;\n  transition: margin 0.3s ease-in 0s;\n  width: 200%;\n}\n\n.onoffswitch-inner:before,\n.onoffswitch-inner:after {\n  box-sizing: border-box;\n  color: #ffffff;\n  display: block;\n  float: left;\n  font-size: 16px;\n  height: 30px;\n  line-height: 32px;\n  width: 50%;\n  padding: 0;\n}\n\n.onoffswitch-inner:before {\n  background-color: #55ce63;\n  color: #ffffff;\n  content: \"ON\";\n  padding-left: 14px;\n}\n\n.onoffswitch-inner:after {\n  content: \"OFF\";\n  padding-right: 14px;\n  background-color: #cccccc;\n  color: #ffffff;\n  text-align: right;\n}\n\n.onoffswitch-switch {\n  background: #ffffff;\n  display: block;\n  height: 20px;\n  width: 20px;\n  border-radius: 20px;\n  -webkit-transition: all 0.3s ease-in 0s;\n  -ms-transition: all 0.3s ease-in 0s;\n  transition: all 0.3s ease-in 0s;\n  margin: 5px;\n  position: absolute;\n  top: 0;\n  right: 43px;\n  bottom: 0;\n}\n\n.card-header-tabs {\n  border-bottom: 0;\n}\n\n.nav-tabs {\n  border-bottom: 1px solid #e6e6e6;\n}\n\n.nav-tabs > li > a {\n  margin-right: 0;\n  color: #888888;\n  border-radius: 0;\n}\n\n.nav-tabs > li > a:hover,\n.nav-tabs > li > a:focus {\n  border-color: transparent;\n  color: #333333;\n}\n\n.nav-tabs .nav-tabs-solid > li > a {\n  color: #333333;\n}\n\n.nav-tabs .nav-tabs-solid > .active > a,\n.nav-tabs .nav-tabs-solid > .active > a:hover,\n.nav-tabs .nav-tabs-solid > .active > a:focus {\n  background-color: #00d0f1;\n  border-color: #00d0f1;\n  color: #ffffff;\n}\n\n.nav-tabs .nav-link {\n  border-radius: 0;\n}\n\n.nav-tabs .nav-link:hover,\n.nav-tabs .nav-link:focus {\n  background-color: #eeeeee;\n  border-color: transparent;\n  color: #333333;\n}\n\n.nav-tabs.nav-justified > li > a {\n  margin-bottom: 0;\n  border-radius: 0;\n}\n\n.nav-tabs.nav-justified > li > a:hover,\n.nav-tabs.nav-justified > li > a:focus {\n  border-bottom-color: #dddddd;\n}\n\n.nav-tabs.nav-justified.nav-tabs-solid > li > a {\n  border-color: transparent;\n}\n\n.nav-tabs.nav-justified.nav-tabs-top {\n  border-bottom: 1px solid #dddddd;\n}\n\n.nav-tabs.nav-justified.nav-tabs-top > li > a,\n.nav-tabs.nav-justified.nav-tabs-top > li > a:hover,\n.nav-tabs.nav-justified.nav-tabs-top > li > a:focus {\n  border-width: 2px 0 0 0;\n}\n\n.nav-tabs.nav-tabs-solid {\n  background-color: #fafafa;\n  border: 0;\n}\n\n.nav-tabs.nav-tabs-solid > li {\n  margin-bottom: 0;\n}\n\n.nav-tabs.nav-tabs-solid > li > a {\n  color: #333333;\n  border-color: transparent;\n}\n\n.nav-tabs.nav-tabs-solid > li > a:hover,\n.nav-tabs.nav-tabs-solid > li > a:focus {\n  background-color: #f5f5f5;\n}\n\n.nav-tabs.nav-tabs-solid > li > a.active,\n.nav-tabs.nav-tabs-solid > li > a.active:hover,\n.nav-tabs.nav-tabs-solid > li > a.active:focus {\n  background-color: #00d0f1;\n  border-color: #00d0f1;\n  color: #ffffff;\n}\n\n.nav-tabs.nav-tabs-solid.nav-tabs-rounded {\n  border-radius: 50px;\n}\n\n.nav-tabs.nav-tabs-solid.nav-tabs-rounded > li > a {\n  border-radius: 50px;\n}\n\n.nav-tabs.nav-tabs-solid.nav-tabs-rounded > li > a.active,\n.nav-tabs.nav-tabs-solid.nav-tabs-rounded > li > a.active:hover,\n.nav-tabs.nav-tabs-solid.nav-tabs-rounded > li > a.active:focus {\n  border-radius: 50px;\n}\n\n.nav-tabs.nav-tabs-solid > .open:not(.active) > a {\n  background-color: #f5f5f5;\n  border-color: transparent;\n}\n\n.nav-tabs.nav-tabs-top > li > a,\n.nav-tabs.nav-tabs-top > li > a:hover,\n.nav-tabs.nav-tabs-top > li > a:focus {\n  border-width: 2px 0 0 0;\n}\n\n.nav-tabs.nav-tabs-top > li > a.active,\n.nav-tabs.nav-tabs-top > li > a.active:hover,\n.nav-tabs.nav-tabs-top > li > a.active:focus {\n  border-top-color: #00d0f1;\n}\n\n.nav-tabs.nav-tabs-top > li.open > a,\n.nav-tabs.nav-tabs-top > li.open > a:hover,\n.nav-tabs.nav-tabs-top > li.open > a:focus {\n  border-top-color: #dddddd;\n}\n\n.nav-tabs.nav-tabs-top > li + li > a {\n  margin-left: 1px;\n}\n\n.nav-tabs.nav-tabs-bottom > li {\n  margin-bottom: -1px;\n}\n\n.nav-tabs.nav-tabs-bottom > li > a.active,\n.nav-tabs.nav-tabs-bottom > li > a.active:hover,\n.nav-tabs.nav-tabs-bottom > li > a.active:focus {\n  border-bottom-width: 2px;\n  border-color: transparent;\n  border-bottom-color: #00d0f1;\n  background-color: transparent;\n  -webkit-transition: none 0s ease 0s;\n  -ms-transition: none 0s ease 0s;\n  transition: none 0s ease 0s;\n}\n\n.card-header-tabs {\n  border-bottom: 0;\n}\n\n.tab-content {\n  padding-top: 20px;\n}\n\n.nav-tabs-justified > li > a {\n  margin-bottom: 0;\n  border-radius: 0;\n}\n\n.nav-tabs-justified > li > a:hover,\n.nav-tabs-justified > li > a:focus {\n  border-bottom-color: #dddddd;\n}\n\n.nav-tabs-justified.nav-tabs-solid > li > a {\n  border-color: transparent;\n}\n\n.nav-tabs-justified.nav-tabs-top {\n  border-bottom: 1px solid #dddddd;\n}\n\n.nav-tabs-justified.nav-tabs-top > li > a,\n.nav-tabs-justified.nav-tabs-top > li > a:hover,\n.nav-tabs-justified.nav-tabs-top > li > a:focus {\n  border-width: 2px 0 0 0;\n}\n\n.main-wrapper {\n  width: 100%;\n  height: 100vh;\n  min-height: 100vh;\n}\n\n.page-wrapper {\n  margin-left: 240px;\n  padding-top: 60px;\n  position: relative;\n  -webkit-transition: all 0.4s ease;\n  -ms-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n\n@media (max-width: 991.98px) {\n  .page-wrapper {\n    margin-left: 0;\n    padding-left: 0;\n    padding-right: 0;\n    -webkit-transition: all 0.4s ease;\n    -ms-transition: all 0.4s ease;\n    transition: all 0.4s ease;\n  }\n}\n\n.page-wrapper > .content {\n  padding: 1.875rem 1.875rem 0;\n}\n\n@media (max-width: 575.98px) {\n  .page-wrapper > .content {\n    padding: 0.9375rem 0.9375rem 0;\n  }\n}\n\n.page-header {\n  margin-bottom: 1.875rem;\n}\n\n@media (max-width: 575.98px) {\n  .page-header {\n    margin-bottom: 0.9375rem;\n  }\n}\n\n.page-header .breadcrumb {\n  background-color: transparent;\n  color: #6c757d;\n  font-size: 16px;\n  font-weight: 500;\n  margin: auto auto 0;\n  padding: 0;\n}\n\n@media (max-width: 479px) {\n  .page-header .breadcrumb {\n    display: none;\n  }\n}\n\n.page-header .breadcrumb a {\n  color: #333333;\n}\n\n.page-title {\n  color: #333333;\n  margin-bottom: 5px;\n}\n\n@media (min-width: 992px) {\n  .mini-sidebar .header .header-left {\n    padding: 0 5px;\n    width: 78px;\n  }\n}\n\n@media (min-width: 992px) {\n  .mini-sidebar .header .header-left .logo {\n    display: none;\n  }\n}\n\n@media (min-width: 992px) {\n  .mini-sidebar .header .header-left .logo img {\n    height: auto;\n    max-height: 40px;\n    width: auto;\n  }\n}\n\n@media (min-width: 992px) {\n  .mini-sidebar .header .header-left .logo.logo-small {\n    display: block;\n  }\n}\n\n.header {\n  background: #ffffff;\n  border-bottom: 1px solid #f0f0f0;\n  z-index: 1001;\n  height: 60px;\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n}\n\n.header .header-left {\n  float: left;\n  height: 60px;\n  position: relative;\n  text-align: center;\n  width: 240px;\n  z-index: 1;\n  -webkit-transition: all 0.2s ease-in-out;\n  -ms-transition: all 0.2s ease-in-out;\n  transition: all 0.2s ease-in-out;\n  padding: 0 20px;\n}\n\n@media (max-width: 991.98px) {\n  .header .header-left {\n    position: absolute;\n    width: 100%;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .header .header-left {\n    padding: 0 15px;\n  }\n}\n\n.header .header-left .logo {\n  display: inline-block;\n  line-height: 60px;\n}\n\n@media (max-width: 767.98px) {\n  .header .header-left .logo {\n    display: none;\n  }\n}\n\n.header .header-left .logo img {\n  max-height: 40px;\n  width: auto;\n}\n\n.header .header-left .logo.logo-small {\n  display: none;\n}\n\n@media (max-width: 767.98px) {\n  .header .header-left .logo.logo-small {\n    display: inline-block;\n  }\n}\n\n.header .dropdown-menu > li > a {\n  position: relative;\n  padding: 10px 18px;\n}\n\n.header .dropdown-menu > li > a:hover,\n.header .dropdown-menu > li > a:focus {\n  background-color: #00d0f1;\n  color: #ffffff;\n}\n\n.header .dropdown-menu > li > a:hover i,\n.header .dropdown-menu > li > a:focus i {\n  color: #ffffff;\n}\n\n.header .dropdown-menu > li > a i {\n  color: #00d0f1;\n  margin-right: 10px;\n  text-align: center;\n  width: 18px;\n}\n\n.header .dropdown-toggle:after {\n  display: none;\n}\n\n.header .has-arrow .dropdown-toggle:after {\n  border-top: 0;\n  border-left: 0;\n  border-bottom: 2px solid #333333;\n  border-right: 2px solid #333333;\n  content: \"\";\n  height: 8px;\n  display: inline-block;\n  pointer-events: none;\n  transform-origin: 66% 66%;\n  -webkit-transform-origin: 66% 66%;\n  -ms-transform-origin: 66% 66%;\n  transform: rotate(45deg);\n  -webkit-transform: rotate(45deg);\n  -ms-transform: rotate(45deg);\n  -webkit-transition: all 0.15s ease-in-out;\n  -ms-transition: all 0.15s ease-in-out;\n  transition: all 0.15s ease-in-out;\n  width: 8px;\n  vertical-align: 2px;\n}\n\n@media (max-width: 767.98px) {\n  .header .has-arrow .dropdown-toggle:after {\n    display: none;\n  }\n}\n\n.header .has-arrow .dropdown-toggle[aria-expanded=\"true\"]:after {\n  transform: rotate(-135deg);\n  -webkit-transform: rotate(-135deg);\n  -ms-transform: rotate(-135deg);\n}\n\n.user-menu {\n  float: right;\n  position: relative;\n  z-index: 99;\n  margin: 0;\n}\n\n.user-menu.nav > li > a {\n  color: #333333;\n  font-size: 14px;\n  line-height: 58px;\n  height: 60px;\n  padding: 0 15px;\n}\n\n.user-menu.nav > li > a:hover,\n.user-menu.nav > li > a:focus {\n  background-color: rgba(0, 0, 0, 0.2);\n}\n\n.user-menu.nav > li > a:hover i,\n.user-menu.nav > li > a:focus i {\n  color: #333333;\n}\n\n.user-menu.nav > li > a i {\n  font-size: 24px;\n  line-height: 60px;\n}\n\n.user-menu.nav > li > a .badge {\n  background-color: #1b5a90;\n  display: block;\n  font-size: 10px;\n  font-weight: 700;\n  min-height: 15px;\n  min-width: 15px;\n  color: #ffffff;\n  position: absolute;\n  top: 6px;\n  right: 3px;\n}\n\n@media (max-width: 767.98px) {\n  .user-menu.nav > li > a > span:not(.user-img) {\n    display: none;\n  }\n}\n\n.user-menu .dropdown-menu {\n  min-width: 200px;\n  padding: 0;\n}\n\n.user-menu .dropdown-menu > li > a i {\n  color: #00d0f1;\n  font-size: 16px;\n  margin-right: 10px;\n  min-width: 18px;\n  text-align: center;\n}\n\n.user-menu .dropdown-menu > li > a:hover i,\n.user-menu .dropdown-menu > li > a:focus i {\n  color: #ffffff;\n}\n\n.user-menu .dropdown-menu .dropdown-item {\n  display: flex;\n  align-items: center;\n  border-top: 1px solid #e3e3e3;\n  padding: 10px 15px;\n}\n\n.user-menu .dropdown-menu .dropdown-item:hover {\n  color: #ffffff;\n  background: #00d0f1;\n}\n\n.user-img {\n  display: inline-block;\n  margin-right: 3px;\n  position: relative;\n}\n\n.user-img.nav > li > a .mobile_btn {\n  border: 0;\n  position: relative;\n  cursor: pointer;\n  margin: 0;\n  padding: 0;\n}\n\n.user-img .dropdown-menu {\n  min-width: 200px;\n  padding: 0;\n}\n\n.user-img .dropdown-menu .dropdown-item {\n  display: flex;\n  align-items: center;\n  border-top: 1px solid #e3e3e3;\n  padding: 10px 15px;\n}\n\n.user-img .dropdown-menu .dropdown-item:hover {\n  color: #ffffff;\n  background: #00d0f1;\n}\n\n.mobile_btn {\n  display: none;\n  float: left;\n}\n\n@media (max-width: 991.98px) {\n  .mobile_btn {\n    color: #333333 !important;\n    cursor: pointer;\n    display: block;\n    font-size: 24px;\n    height: 60px;\n    line-height: 60px;\n    text-align: center;\n    z-index: 10;\n    padding: 0 15px;\n    position: absolute;\n    top: 0;\n    left: 0;\n  }\n}\n\n.slide-nav .sidebar {\n  margin-left: 0;\n}\n\n@media (max-width: 767.98px) {\n  .app-dropdown {\n    display: none;\n  }\n}\n\n.app-dropdown .dropdown-menu {\n  width: 300px;\n  padding: 0;\n}\n\n.app-dropdown-menu .app-list {\n  padding: 15px;\n}\n\n.app-dropdown-menu .app-item {\n  border: 1px solid transparent;\n  color: #737373;\n  display: block;\n  text-align: center;\n  border-radius: 3px;\n  padding: 10px 0;\n}\n\n.app-dropdown-menu .app-item i {\n  font-size: 20px;\n  height: 24px;\n}\n\n.app-dropdown-menu .app-item span {\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.app-dropdown-menu .app-item:hover,\n.app-dropdown-menu .app-item:focus,\n.app-dropdown-menu .app-item:active,\n.app-dropdown-menu .app-item.active {\n  background-color: #f9f9f9;\n  border-color: #e3e3e3;\n}\n\n.app-list > div + div {\n  margin-top: 5px;\n}\n\n.app-list > .row {\n  margin-left: -5px;\n  margin-right: -5px;\n}\n\n.app-list > .row > .col {\n  padding-left: 5px;\n  padding-right: 5px;\n}\n\n.user-header {\n  background-color: #f9f9f9;\n  display: flex;\n  padding: 10px 15px;\n}\n\n.user-header .user-text {\n  margin-left: 10px;\n}\n\n.user-header .user-text h6 {\n  margin-bottom: 2px;\n}\n\n.menu-title {\n  color: #a3a3a3;\n  display: block;\n  font-size: 14px;\n  margin-bottom: 5px;\n  padding: 0 25px;\n}\n\n.sidebar-overlay {\n  background-color: rgba(0, 0, 0, 0.6);\n  display: none;\n  height: 100%;\n  width: 100%;\n  z-index: 1000;\n  position: fixed;\n  top: 60px;\n  left: 0;\n}\n\n@media (max-width: 991.98px) {\n  .sidebar-overlay.opened {\n    display: block;\n  }\n}\n\nhtml.menu-opened {\n  overflow: hidden;\n}\n\nhtml.menu-opened body {\n  overflow: hidden;\n}\n\n.top-nav-search {\n  float: left;\n  margin-left: 15px;\n}\n\n@media (max-width: 991.98px) {\n  .top-nav-search {\n    display: none;\n  }\n}\n\n.top-nav-search form {\n  margin-top: 10px;\n  position: relative;\n  width: 230px;\n}\n\n.top-nav-search .form-control {\n  border-color: rgba(0, 0, 0, 0.1);\n  color: #333333;\n  height: 40px;\n  border-radius: 50px;\n  padding: 10px 50px 10px 15px;\n}\n\n.top-nav-search .form-control::-webkit-input-placeholder {\n  color: #333333;\n  opacity: 1;\n}\n\n.top-nav-search .form-control:-moz-placeholder {\n  color: #333333;\n  opacity: 1;\n}\n\n.top-nav-search .form-control::-moz-placeholder {\n  color: #333333;\n  opacity: 1;\n}\n\n.top-nav-search .form-control:-ms-input-placeholder {\n  color: #333333;\n  opacity: 1;\n}\n\n.top-nav-search .btn {\n  background-color: transparent;\n  border-color: transparent;\n  color: #333333;\n  min-height: 40px;\n  padding: 7px 15px;\n  position: absolute;\n  top: 0;\n  right: 0;\n}\n\n.top-nav-search.active form {\n  display: block;\n  position: absolute;\n  left: 0;\n}\n\n@media (min-width: 991.98px) {\n  #toggle_btn {\n    align-items: center;\n    color: #333333;\n    display: inline-flex;\n    float: left;\n    font-size: 30px;\n    height: 60px;\n    justify-content: center;\n    margin-left: 15px;\n    padding: 0 15px;\n  }\n}\n\n@media (max-width: 991.98px) {\n  #toggle_btn {\n    display: none;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .login-wrapper .loginbox {\n    max-width: 450px;\n    min-height: unset;\n  }\n}\n\n@media (max-width: 991.98px) {\n  .login-wrapper .loginbox .login-left {\n    width: 50%;\n    padding: 80px 50px;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .login-wrapper .loginbox .login-left {\n    display: none;\n  }\n}\n\n@media (max-width: 991.98px) {\n  .login-wrapper .loginbox .login-right {\n    width: 50%;\n    padding: 50px;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .login-wrapper .loginbox .login-right {\n    float: none;\n    width: 100%;\n    padding: 1.875rem;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .login-wrapper .loginbox .login-right h1 {\n    font-size: 22px;\n  }\n}\n\n@media (max-width: 991.98px) {\n  .navbar-nav .open .dropdown-menu {\n    float: left;\n    position: absolute;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .navbar-nav .open .dropdown-menu {\n    float: left;\n    position: absolute;\n  }\n}\n\n@media (max-width: 991.98px) {\n  .navbar-nav.user-menu .open .dropdown-menu {\n    left: auto;\n    right: 0;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .navbar-nav.user-menu .open .dropdown-menu {\n    left: auto;\n    right: 0;\n  }\n}\n\n.table {\n  color: #333333;\n  max-width: 100%;\n  margin-bottom: 0;\n  width: 100%;\n  --bs-table-bg: transparent;\n}\n\n.table > tbody > tr > th {\n  border-top: 0;\n  padding: 10px 8px;\n}\n\n.table.no-border > tbody > tr > td,\n.table.no-border > tbody > tr th,\n.table.no-border tfoot > tr > td,\n.table.no-border tfoot > tr th {\n  border-top: 0;\n  padding: 10px 8px;\n}\n\n.table.dataTable {\n  border-collapse: collapse !important;\n}\n\n.table thead {\n  background-color: #f8f9fa;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.03);\n}\n\n.table thead tr {\n  border-bottom: 1px solid rgba(0, 0, 0, 0.05);\n}\n\n.table thead tr:last-child {\n  border-color: transparent;\n}\n\n.table thead tr th {\n  font-weight: 600;\n  border: 0;\n}\n\n.table.table-center th,\n.table.table-center td {\n  vertical-align: middle;\n}\n\n.table tbody tr {\n  border-bottom: 1px solid rgba(0, 0, 0, 0.05);\n}\n\n.table tbody tr:last-child {\n  border-color: transparent;\n}\n\n.table-striped > thead > tr:nth-of-type(2n + 1) {\n  background-color: #f8f9fa;\n}\n\n.table-striped thead tr {\n  border-color: transparent;\n}\n\n.table-striped tbody tr {\n  border-color: transparent;\n}\n\n.table-striped tbody tr:nth-of-type(even) {\n  background-color: rgba(255, 255, 255, 0.3);\n}\n\n.table-striped tbody tr:nth-of-type(odd) {\n  background-color: rgba(235, 235, 235, 0.4);\n}\n\n.table-nowrap th,\n.table-nowrap td {\n  white-space: nowrap;\n}\n\ntable.table td h2 {\n  display: inline-block;\n  font-size: inherit;\n  font-weight: 400;\n  vertical-align: middle;\n  margin: 0;\n  padding: 0;\n}\n\ntable.table td h2.table-avatar {\n  align-items: center;\n  display: inline-flex;\n  font-size: inherit;\n  font-weight: 400;\n  vertical-align: middle;\n  white-space: nowrap;\n  margin: 0;\n  padding: 0;\n}\n\ntable.table td h2 a {\n  color: #333333;\n}\n\ntable.table td h2 a:hover {\n  color: #00d0f1;\n}\n\ntable.table td h2 span {\n  color: #888888;\n  display: block;\n  font-size: 12px;\n  margin-top: 3px;\n}\n\n.table-hover tbody tr:hover {\n  background-color: #f7f7f7;\n}\n\n.table-hover tbody tr:hover td {\n  color: #474648;\n}\n\n.table-bordered {\n  border: 1px solid rgba(0, 0, 0, 0.05) !important;\n}\n\n.table-bordered th,\n.table-bordered td {\n  border-color: rgba(0, 0, 0, 0.05);\n}\n\n.card-table .card-body {\n  padding: 0;\n}\n\n.card-table .card-body .table td,\n.card-table .card-body .table th {\n  border-top: 1px solid #e2e5e8;\n  white-space: nowrap;\n  padding: 1rem 0.75rem;\n}\n\n.card-table .card-body .table > thead > tr > th {\n  border-top: 0;\n}\n\n.card-table .card-body .table tr th:first-child,\n.card-table .card-body .table tr td:first-child {\n  padding-left: 1.5rem;\n}\n\n.card-table .card-body .table tr th:last-child,\n.card-table .card-body .table tr td:last-child {\n  padding-right: 1.5rem;\n}\n\n#delete_modal .modal-content {\n  text-align: center;\n}\n\n.table-responsive {\n  white-space: nowrap;\n}\n\n.btn.focus,\n.btn:focus {\n  box-shadow: unset;\n}\n\n.btn.btn-rounded {\n  border-radius: 50px;\n}\n\n.btn-white {\n  background-color: #ffffff;\n  border: 1px solid #cccccc;\n  color: #272b41;\n}\n\n.bg-primary,\n.badge-primary {\n  background-color: #00d0f1 !important;\n}\n\na.bg-primary:focus,\na.bg-primary:hover,\nbutton.bg-primary:focus,\nbutton.bg-primary:hover {\n  background-color: #19c1dc !important;\n}\n\n.bg-success,\n.badge-success {\n  background-color: #7bb13c !important;\n}\n\na.bg-success:focus,\na.bg-success:hover,\nbutton.bg-success:focus,\nbutton.bg-success:hover {\n  background-color: #699834 !important;\n}\n\n.bg-info,\n.badge-info {\n  background-color: #009efb !important;\n}\n\na.bg-info:focus,\na.bg-info:hover,\nbutton.bg-info:focus,\nbutton.bg-info:hover {\n  background-color: #028ee1 !important;\n}\n\n.bg-warning,\n.badge-warning {\n  background-color: #ffbc34 !important;\n}\n\na.bg-warning:focus,\na.bg-warning:hover,\nbutton.bg-warning:focus,\nbutton.bg-warning:hover {\n  background-color: #e9ab2e !important;\n}\n\n.bg-danger,\n.badge-danger {\n  background-color: #e84646 !important;\n}\n\na.bg-danger:focus,\na.bg-danger:hover,\nbutton.bg-danger:focus,\nbutton.bg-danger:hover {\n  background-color: #e63333 !important;\n}\n\n.bg-white {\n  background-color: #ffffff;\n}\n\n.bg-purple,\n.badge-purple {\n  background-color: #9368e9 !important;\n}\n\n.text-primary {\n  color: #00d0f1 !important;\n}\n\n.dropdown-menu li > a.text-primary {\n  color: #00d0f1 !important;\n}\n\n.text-success {\n  color: #699834 !important;\n}\n\n.dropdown-menu li > a.text-success {\n  color: #699834 !important;\n}\n\n.text-danger {\n  color: #e84646 !important;\n}\n\n.dropdown-menu li > a.text-danger {\n  color: #e84646 !important;\n}\n\n.text-info {\n  color: #009efb !important;\n}\n\n.dropdown-menu li > a.text-info {\n  color: #009efb !important;\n}\n\n.text-warning {\n  color: #ffbc34 !important;\n}\n\n.dropdown-menu li > a.text-warning {\n  color: #ffbc34 !important;\n}\n\n.text-purple {\n  color: #7460ee !important;\n}\n\n.dropdown-menu li > a.text-purple {\n  color: #7460ee !important;\n}\n\n.text-muted {\n  color: #757575 !important;\n}\n\n.btn-primary {\n  background-color: #00d0f1;\n  border: 1px solid #00d0f1;\n}\n\n.btn-primary:focus,\n.btn-primary:hover,\n.btn-primary:active,\n.btn-primary.active {\n  color: #ffffff;\n  background-color: #19c1dc;\n  border-color: #19c1dc;\n}\n\n.btn-primary:focus .open > .dropdown-toggle.btn-primary,\n.btn-primary:hover .open > .dropdown-toggle.btn-primary,\n.btn-primary:active .open > .dropdown-toggle.btn-primary,\n.btn-primary.active .open > .dropdown-toggle.btn-primary {\n  background-color: #19c1dc;\n  border: 1px solid #19c1dc;\n}\n\n.btn-primary.active.focus .open > .dropdown-toggle.btn-primary.focus,\n.btn-primary.active.focus .open > .dropdown-toggle.btn-primary:focus,\n.btn-primary.active.focus .open > .dropdown-toggle.btn-primary:hover,\n.btn-primary.active:focus .open > .dropdown-toggle.btn-primary.focus,\n.btn-primary.active:focus .open > .dropdown-toggle.btn-primary:focus,\n.btn-primary.active:focus .open > .dropdown-toggle.btn-primary:hover,\n.btn-primary.active:hover .open > .dropdown-toggle.btn-primary.focus,\n.btn-primary.active:hover .open > .dropdown-toggle.btn-primary:focus,\n.btn-primary.active:hover .open > .dropdown-toggle.btn-primary:hover,\n.btn-primary .focus.focus .open > .dropdown-toggle.btn-primary.focus,\n.btn-primary .focus.focus .open > .dropdown-toggle.btn-primary:focus,\n.btn-primary .focus.focus .open > .dropdown-toggle.btn-primary:hover,\n.btn-primary .focus:focus .open > .dropdown-toggle.btn-primary.focus,\n.btn-primary .focus:focus .open > .dropdown-toggle.btn-primary:focus,\n.btn-primary .focus:focus .open > .dropdown-toggle.btn-primary:hover,\n.btn-primary .focus:hover .open > .dropdown-toggle.btn-primary.focus,\n.btn-primary .focus:hover .open > .dropdown-toggle.btn-primary:focus,\n.btn-primary .focus:hover .open > .dropdown-toggle.btn-primary:hover {\n  background-color: #19c1dc;\n  border: 1px solid #19c1dc;\n}\n\n.btn-primary:active:focus,\n.btn-primary:active:hover {\n  background-color: #19c1dc;\n  border: 1px solid #19c1dc;\n}\n\n.btn-primary .active:not(:disabled):not(.disabled),\n.btn-primary:active:not(:disabled):not(.disabled) {\n  background-color: #19c1dc;\n  border-color: #19c1dc;\n  color: #ffffff;\n}\n\n.btn-primary .active:focus:not(:disabled):not(.disabled),\n.btn-primary:active:focus:not(:disabled):not(.disabled) {\n  box-shadow: unset;\n}\n\n.btn-primary .show > .btn-primary.dropdown-toggle {\n  background-color: #19c1dc;\n  border-color: #19c1dc;\n  color: #ffffff;\n}\n\n.btn-primary .show > .btn-primary.dropdown-toggle:focus {\n  box-shadow: unset;\n}\n\n.btn-primary.disabled,\n.btn-primary:disabled {\n  background-color: #00d0f1;\n  border-color: #00d0f1;\n  color: #ffffff;\n}\n\n.btn-secondary.active:focus :not(:disabled):not(.disabled),\n.btn-secondary:active:focus :not(:disabled):not(.disabled) {\n  box-shadow: unset;\n}\n\n.show > .btn-secondary.dropdown-toggle:focus {\n  box-shadow: unset;\n}\n\n.show > .btn-success.dropdown-toggle {\n  background-color: #699834;\n  border-color: #699834;\n  color: #ffffff;\n}\n\n.show > .btn-success.dropdown-toggle:focus {\n  box-shadow: unset;\n}\n\n.show > .btn-info.dropdown-toggle {\n  background-color: #028ee1;\n  border-color: #028ee1;\n  color: #ffffff;\n}\n\n.show > .btn-info.dropdown-toggle:focus {\n  box-shadow: unset;\n}\n\n.show > .btn-warning.dropdown-toggle {\n  background-color: #e9ab2e;\n  border-color: #e9ab2e;\n  color: #ffffff;\n}\n\n.show > .btn-warning.dropdown-toggle:focus {\n  box-shadow: unset;\n}\n\n.show > .btn-danger.dropdown-toggle {\n  background-color: #e63333;\n  border-color: #e63333;\n  color: #ffffff;\n}\n\n.show > .btn-danger.dropdown-toggle:focus {\n  box-shadow: unset;\n}\n\n.show > .btn-light.dropdown-toggle:focus,\n.show > .btn-dark.dropdown-toggle:focus {\n  box-shadow: unset;\n}\n\n.show > .btn-outline-primary.dropdown-toggle {\n  background-color: #00d0f1;\n  border-color: #00d0f1;\n}\n\n.show > .btn-outline-primary.dropdown-toggle:focus {\n  box-shadow: none;\n}\n\n.show > .btn-outline-success.dropdown-toggle {\n  background-color: #7bb13c;\n  border-color: #7bb13c;\n}\n\n.show > .btn-outline-success.dropdown-toggle:focus {\n  box-shadow: none;\n}\n\n.show > .btn-outline-info.dropdown-toggle {\n  background-color: #009efb;\n  border-color: #009efb;\n}\n\n.show > .btn-outline-info.dropdown-toggle:focus {\n  box-shadow: none;\n}\n\n.show > .btn-outline-warning.dropdown-toggle {\n  color: #212529;\n  background-color: #ffbc34;\n  border-color: #ffbc34;\n}\n\n.show > .btn-outline-warning.dropdown-toggle:focus {\n  box-shadow: none;\n}\n\n.show > .btn-outline-danger.dropdown-toggle {\n  color: #212529;\n  background-color: #ffbc34;\n  border-color: #ffbc34;\n}\n\n.show > .btn-outline-danger.dropdown-toggle:focus {\n  box-shadow: none;\n}\n\n.btn-success {\n  background-color: #7bb13c;\n  border: 1px solid #7bb13c;\n}\n\n.btn-success:hover,\n.btn-success:focus .btn-success.active,\n.btn-success:active,\n.btn-success .open__ > .dropdown-toggle.btn-sccess {\n  background-color: #699834;\n  border: 1px solid #699834;\n  color: #ffffff;\n}\n\n.btn-success .open > .dropdown-toggle.btn-success {\n  background-color: #699834;\n  border: 1px solid #699834;\n  color: #ffffff;\n}\n\n.btn-success .open > .dropdown-toggle.btn-success.focus,\n.btn-success .open > .dropdown-toggle.btn-success:hover,\n.btn-success .open > .dropdown-toggle.btn-success:focus {\n  background-color: #699834;\n  border: 1px solid #699834;\n}\n\n.btn-success.active:focus,\n.btn-success.active.focus,\n.btn-success.active:hover,\n.btn-success.focus,\n.btn-success:active:focus,\n.btn-success:active:hover {\n  background-color: #699834;\n  border: 1px solid #699834;\n}\n\n.btn-success.active:not(:disabled):not(.disabled),\n.btn-success:active:not(:disabled):not(.disabled) {\n  background-color: #699834;\n  border-color: #699834;\n  color: #ffffff;\n}\n\n.btn-success.active:focus:not(:disabled):not(.disabled),\n.btn-success:active:focus:not(:disabled):not(.disabled) {\n  box-shadow: unset;\n}\n\n.btn-success.disabled,\n.btn-success:disabled {\n  background-color: #7bb13c;\n  border-color: #7bb13c;\n  color: #ffffff;\n}\n\n.btn-info {\n  background-color: #009efb;\n  border: 1px solid #009efb;\n}\n\n.btn-info:hover,\n.btn-info:focus,\n.btn-info:active,\n.btn-info.active {\n  background-color: #028ee1;\n  border: 1px solid #028ee1;\n}\n\n.btn-info.active:focus,\n.btn-info.active.focus,\n.btn-info.active:hover,\n.btn-info.focus,\n.btn-info:active:focus,\n.btn-info:active:hover {\n  background-color: #028ee1;\n  border: 1px solid #028ee1;\n}\n\n.btn-info.active:not(:disabled):not(.disabled),\n.btn-info:active:not(:disabled):not(.disabled) {\n  background-color: #028ee1;\n  border-color: #028ee1;\n  color: #ffffff;\n}\n\n.btn-info.active:not(:disabled):not(.disabled):focus,\n.btn-info:active:not(:disabled):not(.disabled):focus {\n  box-shadow: unset;\n}\n\n.btn-info.disabled,\n.btn-info:disabled {\n  background-color: #009efb;\n  border-color: #009efb;\n  color: #ffffff;\n}\n\n.btn-warning {\n  background-color: #ffbc34;\n  border: 1px solid #ffbc34;\n}\n\n.btn-warning:hover,\n.btn-warning:focus,\n.btn-warning:active,\n.btn-warning.active {\n  background-color: #e9ab2e;\n  border: 1px solid #e9ab2e;\n}\n\n.btn-warning.active:focus,\n.btn-warning.active.focus,\n.btn-warning.active:hover,\n.btn-warning.focus,\n.btn-warning:active:focus,\n.btn-warning:active:hover {\n  background-color: #e9ab2e;\n  border: 1px solid #e9ab2e;\n}\n\n.btn-warning.active:not(:disabled):not(.disabled),\n.btn-warning:active:not(:disabled):not(.disabled) {\n  background-color: #e9ab2e;\n  border-color: #e9ab2e;\n  color: #ffffff;\n}\n\n.btn-warning.active:not(:disabled):not(.disabled):focus,\n.btn-warning:active:not(:disabled):not(.disabled):focus {\n  box-shadow: unset;\n}\n\n.btn-warning.disabled,\n.btn-warning:disabled {\n  background-color: #ffbc34;\n  border-color: #ffbc34;\n  color: #ffffff;\n}\n\n.btn-danger {\n  background-color: #e84646;\n  border: 1px solid #e84646;\n}\n\n.btn-danger:hover,\n.btn-danger:focus,\n.btn-danger:active,\n.btn-danger.active {\n  background-color: #e63333;\n  border: 1px solid #e63333;\n}\n\n.btn-danger.active:focus,\n.btn-danger.active.focus,\n.btn-danger.active:hover,\n.btn-danger.focus,\n.btn-danger:active:focus,\n.btn-danger:active:hover {\n  background-color: #e63333;\n  border: 1px solid #e63333;\n}\n\n.btn-danger.active:not(:disabled):not(.disabled),\n.btn-danger:active:not(:disabled):not(.disabled) {\n  background-color: #e63333;\n  border-color: #e63333;\n  color: #ffffff;\n}\n\n.btn-danger.active:not(:disabled):not(.disabled):focus,\n.btn-danger:active:not(:disabled):not(.disabled):focus {\n  box-shadow: unset;\n}\n\n.btn-danger.disabled,\n.btn-danger:disabled {\n  background-color: #e84646;\n  border-color: #e84646;\n  color: #ffffff;\n}\n\n.open > .dropdown-toggle.btn-info {\n  background-color: #028ee1;\n  border: 1px solid #028ee1;\n}\n\n.open > .dropdown-toggle.btn-info.focus,\n.open > .dropdown-toggle.btn-info:focus,\n.open > .dropdown-toggle.btn-info:hover {\n  background-color: #028ee1;\n  border: 1px solid #028ee1;\n}\n\n.open > .dropdown-toggle.btn-warning {\n  background-color: #e9ab2e;\n  border: 1px solid #e9ab2e;\n}\n\n.open > .dropdown-toggle.btn-warning.focus,\n.open > .dropdown-toggle.btn-warning:focus,\n.open > .dropdown-toggle.btn-warning:hover {\n  background-color: #e9ab2e;\n  border: 1px solid #e9ab2e;\n}\n\n.open > .dropdown-toggle.btn-danger {\n  background-color: #e63333;\n  border: 1px solid #e63333;\n}\n\n.open > .dropdown-toggle.btn-danger.focus,\n.open > .dropdown-toggle.btn-danger:focus,\n.open > .dropdown-toggle.btn-danger:hover {\n  background-color: #e63333;\n  border: 1px solid #e63333;\n}\n\n.btn-light.active:focus:not(:disabled):not(.disabled),\n.btn-light:active:focus:not(:disabled):not(.disabled),\n.btn-dark.active:focus:not(:disabled):not(.disabled),\n.btn-dark:active:focus:not(:disabled):not(.disabled) {\n  box-shadow: unset;\n}\n\n.btn-outline-primary {\n  color: #00d0f1;\n  border-color: #00d0f1;\n}\n\n.btn-outline-primary:hover {\n  background-color: #00d0f1;\n  border-color: #00d0f1;\n}\n\n.btn-outline-primary.focus,\n.btn-outline-primary:focus {\n  box-shadow: none;\n}\n\n.btn-outline-primary.disabled,\n.btn-outline-primary:disabled {\n  color: #00d0f1;\n  background-color: transparent;\n}\n\n.btn-outline-primary:not(:disabled):not(.disabled).active,\n.btn-outline-primary:not(:disabled):not(.disabled):active {\n  background-color: #00d0f1;\n  border-color: #00d0f1;\n}\n\n.btn-outline-success {\n  color: #7bb13c;\n  border-color: #7bb13c;\n}\n\n.btn-outline-success:hover {\n  background-color: #7bb13c;\n  border-color: #7bb13c;\n}\n\n.btn-outline-success.focus,\n.btn-outline-success:focus {\n  box-shadow: none;\n}\n\n.btn-outline-success.disabled,\n.btn-outline-success:disabled {\n  color: #7bb13c;\n  background-color: transparent;\n}\n\n.btn-outline-success:not(:disabled):not(.disabled).active,\n.btn-outline-success:not(:disabled):not(.disabled):active {\n  background-color: #7bb13c;\n  border-color: #7bb13c;\n}\n\n.btn-outline-success:not(:disabled):not(.disabled).active:focus,\n.btn-outline-success:not(:disabled):not(.disabled):active:focus {\n  box-shadow: none;\n}\n\n.btn-outline-info {\n  color: #009efb;\n  border-color: #009efb;\n}\n\n.btn-outline-info:hover {\n  color: #ffffff;\n  background-color: #009efb;\n  border-color: #009efb;\n}\n\n.btn-outline-info.disabled,\n.btn-outline-info:disabled {\n  background-color: transparent;\n  color: #009efb;\n}\n\n.btn-outline-info:focus,\n.btn-outline-info.focus {\n  box-shadow: none;\n}\n\n.btn-outline-info:not(:disabled):not(.disabled).active,\n.btn-outline-info:not(:disabled):not(.disabled):active {\n  background-color: #009efb;\n  border-color: #009efb;\n}\n\n.btn-outline-info:not(:disabled):not(.disabled).active:focus,\n.btn-outline-info:not(:disabled):not(.disabled):active:focus {\n  box-shadow: none;\n}\n\n.btn-outline-warning {\n  color: #ffbc34;\n  border-color: #ffbc34;\n}\n\n.btn-outline-warning:hover {\n  color: #212529;\n  background-color: #ffbc34;\n  border-color: #ffbc34;\n}\n\n.btn-outline-warning.disabled,\n.btn-outline-warning:disabled {\n  background-color: transparent;\n  color: #ffbc34;\n}\n\n.btn-outline-warning:focus,\n.btn-outline-warning.focus {\n  box-shadow: none;\n}\n\n.btn-outline-warning:not(:disabled):not(.disabled).active,\n.btn-outline-warning:not(:disabled):not(.disabled):active {\n  background-color: #ffbc34;\n  border-color: #ffbc34;\n}\n\n.btn-outline-warning:not(:disabled):not(.disabled).active:focus,\n.btn-outline-warning:not(:disabled):not(.disabled):active:focus {\n  box-shadow: none;\n}\n\n.btn-outline-danger {\n  color: #e84646;\n  border-color: #e84646;\n}\n\n.btn-outline-danger:hover {\n  color: #212529;\n  background-color: #e84646;\n  border-color: #e84646;\n}\n\n.btn-outline-danger.disabled,\n.btn-outline-danger:disabled {\n  background-color: transparent;\n  color: #e84646;\n}\n\n.btn-outline-danger:focus,\n.btn-outline-danger.focus {\n  box-shadow: none;\n}\n\n.btn-outline-danger:not(:disabled):not(.disabled).active,\n.btn-outline-danger:not(:disabled):not(.disabled):active {\n  background-color: #e84646;\n  border-color: #e84646;\n}\n\n.btn-outline-danger:not(:disabled):not(.disabled).active:focus,\n.btn-outline-danger:not(:disabled):not(.disabled):active:focus {\n  box-shadow: none;\n}\n\n.btn-outline-light {\n  color: #ababab;\n  border-color: #e6e6e6;\n}\n\n.btn-outline-light.disabled,\n.btn-outline-light:disabled {\n  color: #ababab;\n}\n\n.pagination {\n  --bs-pagination-disabled-bg: transparent;\n}\n\n.pagination > .active > a,\n.pagination > .active > a:hover,\n.pagination > .active > a:focus,\n.pagination > .active > span,\n.pagination > .active > span:hover,\n.pagination > .active > span:focus {\n  background-color: #20c0f3;\n  border-color: #20c0f3;\n}\n\n.pagination > .active > a,\n.pagination > .active > span {\n  color: #ffffff;\n}\n\n.pagination > li > a,\n.pagination > li > span {\n  color: #20c0f3;\n}\n\n.page-link:hover {\n  color: #20c0f3;\n}\n\n.page-link:focus {\n  box-shadow: unset;\n}\n\n.page-item.active .page-link {\n  background-color: #20c0f3;\n  border-color: #20c0f3;\n}\n\n.dropdown-menu {\n  background-color: #ffffff;\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  box-shadow: inherit;\n  font-size: 14px;\n  border-radius: 3px;\n  transform-origin: left top 0;\n  -webkit-transform-origin: left top 0;\n  -ms-transform-origin: left top 0;\n}\n\n.dropdown-item.active,\n.dropdown-item:active {\n  background-color: #0de0fe;\n}\n\n.navbar-nav__.open--.dropdown-menu {\n  border: 0;\n  -webkit-box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n  -moz-box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n  background-color: #ffffff;\n}\n\n.btn-light {\n  border-color: #e6e6e6;\n  color: #a6a6a6;\n}\n\n.bootstrap-datetimepicker-widget table td.active,\n.bootstrap-datetimepicker-widget table td.active:hover {\n  background-color: #20c0f3;\n  text-shadow: unset;\n}\n\n.bootstrap-datetimepicker-widget table td.today::before {\n  border-bottom-color: #20c0f3;\n}\n\n.bg-info-light {\n  background-color: rgba(2, 182, 179, 0.12) !important;\n  color: #1db9aa !important;\n}\n\n.bg-primary-light {\n  background-color: rgba(17, 148, 247, 0.12) !important;\n  color: #2196f3 !important;\n}\n\n.bg-danger-light {\n  background-color: rgba(242, 17, 54, 0.12) !important;\n  color: #e63c3c !important;\n}\n\n.bg-warning-light {\n  background-color: rgba(255, 152, 0, 0.12) !important;\n  color: #f39c12 !important;\n}\n\n.bg-success-light {\n  background-color: rgba(15, 183, 107, 0.12) !important;\n  color: #26af48 !important;\n}\n\n.bg-purple-light {\n  background-color: rgba(197, 128, 255, 0.12) !important;\n  color: #c580ff !important;\n}\n\n.bg-default-light {\n  background-color: rgba(40, 52, 71, 0.12) !important;\n  color: #283447 !important;\n}\n\n.text-xs {\n  font-size: 12px !important;\n}\n\n.text-sm {\n  font-size: 14px !important;\n}\n\n.text-lg {\n  font-size: 18px !important;\n}\n\n.text-xl {\n  font-size: 24px !important;\n}\n\n.form-group {\n  margin-bottom: 20px;\n}\n\n.card {\n  border: 1px solid #f0f0f0;\n  margin-bottom: 30px;\n}\n\n@media (max-width: 575.98px) {\n  .card {\n    margin-bottom: 15px;\n  }\n}\n\n.card .card-header {\n  background-color: #ffffff;\n  border-bottom: 1px solid #eaeaea;\n}\n\n.card .card-header .card-title {\n  margin-bottom: 0;\n}\n\n.card-body {\n  padding: 1.5rem;\n}\n\n@media (max-width: 575.98px) {\n  .card-body {\n    padding: 1.25rem;\n  }\n}\n\n.card-header {\n  border-bottom: 1px solid #e6e6e6;\n  padding: 1rem 1.5rem;\n}\n\n@media (max-width: 575.98px) {\n  .card-header {\n    padding: 0.75rem 1.25rem;\n  }\n}\n\n.card-footer {\n  background-color: #ffffff;\n  border-top: 1px solid #e6e6e6;\n  padding: 1rem 1.5rem;\n}\n\n@media (max-width: 575.98px) {\n  .card-footer {\n    padding: 0.75rem 1.25rem;\n  }\n}\n\n.modal-footer.text-start {\n  text-align: left;\n}\n\n.modal-footer.text-center {\n  text-align: center;\n}\n\n.border-primary {\n  border-color: #00d0f1 !important;\n}\n\n.text-secondary {\n  color: #b8bdc1 !important;\n}\n\n.page-item.active .page-link {\n  background-color: #00d0f1;\n  border-color: #00d0f1;\n}\n\n@media (max-width: 767.98px) {\n  div.dataTables_wrapper div.dataTables_paginate ul.pagination {\n    justify-content: center;\n    margin-top: 10px;\n  }\n\n  div.dataTables_wrapper div.dataTables_info {\n    text-align: center;\n  }\n}\n\n@media (min-width: 992px) {\n  .mini-sidebar.expand-menu .sidebar {\n    width: 240px;\n  }\n}\n\n@media (min-width: 992px) {\n  .mini-sidebar.expand-menu .sidebar .sidebar-menu ul > li > a span {\n    display: inline;\n    opacity: 1;\n  }\n}\n\n@media (min-width: 992px) {\n  .mini-sidebar.expand-menu .sidebar .sidebar-menu ul > li > a i {\n    font-size: 24px;\n    width: 20px;\n  }\n}\n\n@media (min-width: 992px) {\n  .mini-sidebar.expand-menu .menu-title {\n    visibility: visible;\n  }\n}\n\n@media (min-width: 992px) {\n  .mini-sidebar.expand-menu .menu-title a {\n    visibility: hidden;\n  }\n}\n\n@media (min-width: 992px) {\n  .mini-sidebar .sidebar {\n    width: 78px;\n  }\n}\n\n@media (min-width: 992px) {\n  .mini-sidebar .sidebar .sidebar-menu ul > li > a span {\n    display: none;\n    opacity: 0;\n    -webkit-transition: all 0.2s ease-in-out;\n    -ms-transition: all 0.2s ease-in-out;\n    transition: all 0.2s ease-in-out;\n  }\n}\n\n@media (min-width: 992px) {\n  .mini-sidebar .menu-title {\n    visibility: hidden;\n    white-space: nowrap;\n  }\n}\n\n@media (min-width: 992px) {\n  .mini-sidebar .menu-title a {\n    visibility: hidden;\n  }\n}\n\n@media (min-width: 992px) {\n  .mini-sidebar .page-wrapper {\n    margin-left: 78px;\n  }\n}\n\n.sidebar {\n  background-color: #1b5a90;\n  margin-top: 0;\n  -webkit-transition: all 0.2s ease-in-out 0s;\n  -ms-transition: all 0.2s ease-in-out 0s;\n  transition: all 0.2s ease-in-out 0s;\n  width: 240px;\n  z-index: 1001;\n  position: fixed;\n  top: 60px;\n  bottom: 0;\n  left: 0;\n}\n\n@media (max-width: 991.98px) {\n  .sidebar {\n    margin-left: -225px;\n    width: 225px;\n    -webkit-transition: all 0.4s ease;\n    -ms-transition: all 0.4s ease;\n    transition: all 0.4s ease;\n    z-index: 1000;\n  }\n}\n\n.sidebar.opened {\n  -webkit-transition: all 0.4s ease;\n  -ms-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n\n.sidebar .sidebar-menu > ul > li {\n  margin-bottom: 3px;\n  position: relative;\n}\n\n.sidebar .sidebar-menu > ul > li:last-child {\n  margin-bottom: 0;\n}\n\n.sidebar .sidebar-menu > ul > li > a {\n  align-items: center;\n  display: flex;\n  justify-content: flex-start;\n  position: relative;\n  color: #f1f1f1;\n  -webkit-transition: all 0.2s ease-in-out 0s;\n  -ms-transition: all 0.2s ease-in-out 0s;\n  transition: all 0.2s ease-in-out 0s;\n  border-radius: 3px;\n  padding: 8px 15px;\n}\n\n.sidebar .sidebar-menu > ul > li > a span {\n  display: inline-block;\n  margin-left: 10px;\n  white-space: nowrap;\n  -webkit-transition: all 0.2s ease-in-out 0s;\n  -ms-transition: all 0.2s ease-in-out 0s;\n  transition: all 0.2s ease-in-out 0s;\n}\n\n.sidebar .sidebar-menu > ul > li > a span.chat-user {\n  margin-left: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.sidebar .sidebar-menu > ul > li > a span.badge {\n  margin-left: auto;\n}\n\n.sidebar .sidebar-menu .menu-arrow {\n  display: inline-block;\n  font-family: \"FontAwesome\";\n  text-rendering: auto;\n  line-height: 40px;\n  font-size: 16px;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  line-height: 18px;\n  -webkit-transition: transform 0.15s;\n  -ms-transition: transform 0.15s;\n  transition: transform 0.15s;\n  transform: translate(0, 0);\n  -webkit-transform: translate(0, 0);\n  -ms-transform: translate(0, 0);\n  position: absolute;\n  top: 11px;\n  right: 15px;\n}\n\n.sidebar .sidebar-menu .menu-arrow:before {\n  content: \"\\f105\";\n}\n\n.sidebar ul ul {\n  display: none;\n}\n\n.sidebar ul ul a {\n  display: block;\n  font-size: 15px !important;\n  padding: 7px 10px 7px 45px !important;\n  position: relative;\n}\n\n.sidebar ul ul a .menu-arrow {\n  top: 10px !important;\n}\n\n.sidebar ul ul ul a {\n  padding-left: 65px !important;\n}\n\n.sidebar ul ul ul ul a {\n  padding-left: 85px !important;\n}\n\n.sidebar ul li a.subdrop .menu-arrow {\n  transform: rotate(90deg);\n  -webkit-transform: rotate(90deg);\n  -ms-transform: rotate(90deg);\n}\n\n.sidebar ul li a i {\n  display: inline-block;\n  font-size: 24px;\n  line-height: 24px;\n  text-align: left;\n  vertical-align: middle;\n  width: 20px;\n  -webkit-transition: all 0.2s ease-in-out 0s;\n  -ms-transition: all 0.2s ease-in-out 0s;\n  transition: all 0.2s ease-in-out 0s;\n}\n\n.sidebar ul li a > .badge {\n  color: #ffffff;\n}\n\n.sidebar ul li.menu-title a i {\n  font-size: 16px !important;\n  margin-right: 0;\n  text-align: right;\n  width: auto;\n}\n\n.sidebar-inner {\n  height: 100%;\n  min-height: 100%;\n  -webkit-transition: all 0.2s ease-in-out 0s;\n  -ms-transition: all 0.2s ease-in-out 0s;\n  transition: all 0.2s ease-in-out 0s;\n}\n\n.sidebar-menu {\n  padding: 15px;\n}\n\n.sidebar-menu ul {\n  font-size: 15px;\n  list-style-type: none;\n  position: relative;\n  margin: 0;\n  padding: 0;\n}\n\n.sidebar-menu ul li a {\n  color: #ffffff;\n  display: block;\n  font-size: 16px;\n  height: auto;\n  padding: 0 20px;\n}\n\n.sidebar-menu ul li a:hover {\n  color: #5ae8ff;\n}\n\n.sidebar-menu ul li.active a {\n  background-color: #00d0f1;\n  color: #fff;\n}\n\n.sidebar-menu ul ul a.active {\n  color: #20e3ff;\n  text-decoration: underline;\n}\n\n.sidebar-menu > ul > li > a:hover {\n  background-color: #19c1dc;\n  color: #ffffff;\n}\n\n.sidebar-menu > ul > li.active > a:hover {\n  background-color: #19c1dc;\n  color: #ffffff;\n}\n\n.menu-title {\n  color: #ebebeb;\n  display: flex;\n  font-size: 14px;\n  font-weight: 600;\n  opacity: 1;\n  white-space: nowrap;\n  padding: 5px 15px;\n}\n\n.menu-title > i {\n  float: right;\n  line-height: 40px;\n}\n\n.menu-title li.menu-title a {\n  color: #ff9b44;\n  display: inline-block;\n  margin-left: auto;\n  padding: 0;\n}\n\n.menu-title li.menu-title a .btn {\n  color: #ffffff;\n  display: block;\n  float: none;\n  font-size: 15px;\n  margin: auto auto 15px;\n  padding: 10px 15px;\n}\n\n@media (min-width: 992px) {\n  .modal-open.mini-sidebar .sidebar {\n    z-index: 1051;\n  }\n}\n\n.avatar {\n  position: relative;\n  display: inline-block;\n  width: 3rem;\n  height: 3rem;\n}\n\n.avatar > img {\n  width: 100%;\n  height: 100%;\n  -o-object-fit: cover;\n  object-fit: cover;\n}\n\n.avatar .avatar-title {\n  width: 100%;\n  height: 100%;\n  background-color: #00d0f1;\n  color: #ffffff;\n}\n\n.avatar.avatar-online::before {\n  width: 25%;\n  height: 25%;\n  border-radius: 50%;\n  content: \"\";\n  border: 2px solid #ffffff;\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  background-color: #7bb13c;\n}\n\n.avatar.avatar-offline::before {\n  width: 25%;\n  height: 25%;\n  border-radius: 50%;\n  content: \"\";\n  border: 2px solid #ffffff;\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  background-color: #e84646;\n}\n\n.avatar.avatar-away::before {\n  width: 25%;\n  height: 25%;\n  border-radius: 50%;\n  content: \"\";\n  border: 2px solid #ffffff;\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  background-color: #ffbc34;\n}\n\n.avatar .border {\n  border-width: 3px !important;\n}\n\n.avatar .rounded {\n  border-radius: 6px !important;\n}\n\n.avatar .avatar-title {\n  font-size: 18px;\n}\n\n.avatar .avatar-xs {\n  width: 1.65rem;\n  height: 1.65rem;\n}\n\n.avatar .avatar-xs .border {\n  border-width: 2px !important;\n}\n\n.avatar .avatar-xs .rounded {\n  border-radius: 4px !important;\n}\n\n.avatar .avatar-xs .avatar-title {\n  font-size: 12px;\n}\n\n.avatar .avatar-xs.avatar-away::before,\n.avatar .avatar-xs.avatar-offline::before,\n.avatar .avatar-xs.avatar-online::before {\n  border-width: 1px;\n}\n\n.avatar-sm {\n  width: 2.5rem;\n  height: 2.5rem;\n}\n\n.avatar-sm .border {\n  border-width: 3px !important;\n}\n\n.avatar-sm .rounded {\n  border-radius: 4px !important;\n}\n\n.avatar-sm .avatar-title {\n  font-size: 15px;\n}\n\n.avatar-sm.avatar-away::before,\n.avatar-sm.avatar-offline::before,\n.avatar-sm.avatar-online::before {\n  border-width: 2px;\n}\n\n.avatar-lg {\n  width: 3.75rem;\n  height: 3.75rem;\n}\n\n.avatar-lg .border {\n  border-width: 3px !important;\n}\n\n.avatar-lg .rounded {\n  border-radius: 8px !important;\n}\n\n.avatar-lg .avatar-title {\n  font-size: 24px;\n}\n\n.avatar-lg.avatar-away::before,\n.avatar-lg.avatar-offline::before,\n.avatar-lg.avatar-online::before {\n  border-width: 3px;\n}\n\n.avatar-xl {\n  width: 5rem;\n  height: 5rem;\n}\n\n.avatar-xl .border {\n  border-width: 4px !important;\n}\n\n.avatar-xl .rounded {\n  border-radius: 8px !important;\n}\n\n.avatar-xl .avatar-title {\n  font-size: 28px;\n}\n\n.avatar-xl.avatar-away::before,\n.avatar-xl.avatar-offline::before,\n.avatar-xl.avatar-online::before {\n  border-width: 4px;\n}\n\n.avatar-xxl {\n  width: 5.125rem;\n  height: 5.125rem;\n}\n\n@media (min-width: 768px) {\n  .avatar-xxl {\n    width: 8rem;\n    height: 8rem;\n  }\n}\n\n.avatar-xxl .border {\n  border-width: 6px !important;\n}\n\n@media (min-width: 768px) {\n  .avatar-xxl .border {\n    border-width: 6px !important;\n  }\n}\n\n.avatar-xxl .rounded {\n  border-radius: 8px !important;\n}\n\n@media (min-width: 768px) {\n  .avatar-xxl .rounded {\n    border-width: 12px !important;\n  }\n}\n\n.avatar-xxl .avatar-title {\n  font-size: 30px;\n}\n\n@media (min-width: 768px) {\n  .avatar-xxl .avatar-title {\n    font-size: 42px;\n  }\n}\n\n.avatar-xxl.avatar-away::before,\n.avatar-xxl.avatar-offline::before,\n.avatar-xxl.avatar-online::before {\n  border-width: 4px;\n}\n\n@media (min-width: 768px) {\n  .avatar-xxl.avatar-away::before,\n  .avatar-xxl.avatar-offline::before,\n  .avatar-xxl.avatar-online::before {\n    border-width: 4px;\n  }\n}\n\n.avatar-group .avatar + .avatar {\n  margin-left: -0.75rem;\n}\n\n.avatar-group .avatar:hover {\n  z-index: 1;\n}\n\n.avatar-group .avatar-xs + .avatar-xs {\n  margin-left: -0.40625rem;\n}\n\n.avatar-group .avatar-sm + .avatar-sm {\n  margin-left: -0.625rem;\n}\n\n.avatar-group .avatar-lg + .avatar-lg {\n  margin-left: -1rem;\n}\n\n.avatar-group .avatar-xl + .avatar-xl {\n  margin-left: -1.28125rem;\n}\n\n.avatar-xs {\n  width: 1.65rem;\n  height: 1.65rem;\n}\n\n.select2-results__option {\n  padding: 6px 15px;\n}\n\n.select2-container .select2-selection--single {\n  border: 1px solid #dddddd;\n  height: 40px;\n}\n\n.select2-container .select2-selection--single .select2-selection__rendered {\n  padding-right: 30px;\n  padding-left: 15px;\n}\n\n.select2-container--default .select2-selection--single .select2-selection__arrow {\n  height: 38px;\n  right: 7px;\n}\n\n.select2-container--default .select2-selection--single .select2-selection__arrow b {\n  border-color: #dcdcdc transparent transparent;\n  border-style: solid;\n  border-width: 6px 6px 0;\n  height: 0;\n  margin-left: -10px;\n  margin-top: -2px;\n  width: 0;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n}\n\n.select2-container--default .select2-selection--single .select2-selection__rendered {\n  color: #272b41;\n  font-size: 15px;\n  font-weight: normal;\n  line-height: 38px;\n}\n\n.select2-container--default.select2-container--open\n  .select2-selection--single\n  .select2-selection__arrow\n  b {\n  border-color: transparent transparent #dcdcdc;\n  border-width: 0 6px 6px;\n}\n\n.select2-container--default .select2-results__option--highlighted[aria-selected] {\n  background-color: #20c0f3;\n}\n\n.select2-container--default .select2-selection--multiple {\n  border: 1px solid #dcdcdc;\n  min-height: 46px;\n}\n\n.select2-dropdown {\n  border-color: #dcdcdc;\n}\n\n.p-20 {\n  padding: 20px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.m-0 {\n  margin: 0 !important;\n}\n\n.m-r-5 {\n  margin-right: 5px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-15 {\n  margin-left: 15px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-0 {\n  margin-top: 0 !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-50 {\n  margin-top: 50px !important;\n}\n\n.m-b-5 {\n  margin-bottom: 5px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-15 {\n  margin-bottom: 15px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.block {\n  display: block !important;\n}\n\n.cal-icon {\n  position: relative;\n  width: 100%;\n}\n\n.cal-icon:after {\n  color: #979797;\n  content: \"\\f073\";\n  display: block;\n  font-family: \"FontAwesome\";\n  font-size: 15px;\n  margin: auto;\n  position: absolute;\n  top: 10px;\n  right: 15px;\n}\n\n.dash-widget-icon {\n  display: inline-flex;\n  font-size: 30px;\n  height: 50px;\n  line-height: 48px;\n  text-align: center;\n  width: 50px;\n  border: 3px solid;\n  border-radius: 50px;\n  padding: 28px;\n}\n\n.dash-widget-icon h3 {\n  margin-bottom: 10px;\n}\n\n.dash-count {\n  font-size: 18px;\n  margin-left: auto;\n}\n\n@media (max-width: 767.98px) {\n  .dash-count {\n    font-size: 16px;\n  }\n}\n\n.dash-widget-header {\n  align-items: center;\n  display: flex;\n  margin-bottom: 15px;\n}\n\n.card-chart .card-body {\n  padding: 8px;\n}\n\n@media (max-width: 575.98px) {\n  .card-chart .card-body {\n    padding: 5px;\n  }\n}\n\n#morrisArea > svg,\n#morrisArea #morrisLine > svg {\n  width: 100%;\n}\n\n.activity-feed {\n  list-style: none;\n  margin-bottom: 0;\n  margin-left: 5px;\n  padding: 0;\n}\n\n.activity-feed .feed-item {\n  border-left: 2px solid #e4e8eb;\n  padding-bottom: 19px;\n  padding-left: 20px;\n  position: relative;\n}\n\n.activity-feed .feed-item:last-child {\n  border-color: transparent;\n  padding-bottom: 0;\n}\n\n.activity-feed .feed-item:after {\n  content: \"\";\n  display: block;\n  width: 12px;\n  height: 12px;\n  background-color: #177dff;\n  border-radius: 50%;\n  position: absolute;\n  top: 0;\n  left: -7px;\n}\n\n.activity-feed .feed-item .feed-date {\n  display: block;\n  position: relative;\n  color: #777;\n  text-transform: uppercase;\n  font-size: 13px;\n}\n\n.activity-feed .feed-item .feed-text {\n  color: #777;\n  position: relative;\n}\n\n.activity-feed .feed-item .feed-text a {\n  color: #333333;\n  font-weight: 600;\n}\n\n.section-header {\n  margin-bottom: 1.875rem;\n}\n\n.section-header .section-title {\n  color: #333333;\n}\n\n.comp-header {\n  margin-bottom: 1.875rem;\n}\n\n.comp-header .comp-title {\n  color: #272b41;\n}\n\n.line {\n  background-color: #20c0f3;\n  height: 2px;\n  width: 60px;\n  margin: 0;\n}\n\n.comp-buttons .btn {\n  margin-bottom: 5px;\n}\n\n.pagination-box .pagination {\n  margin-top: 0;\n}\n\n.comp-dropdowns .btn-group {\n  margin-bottom: 5px;\n}\n\n.progress-example .progress {\n  margin-bottom: 1.5rem;\n}\n\n.progress-xs {\n  height: 4px;\n}\n\n.progress-sm {\n  height: 15px;\n}\n\n.progress.progress-sm {\n  height: 6px;\n}\n\n.progress.progress-md {\n  height: 8px;\n}\n\n.progress.progress-lg {\n  height: 18px;\n}\n\n.row.row-sm {\n  margin-left: -3px;\n  margin-right: -3px;\n}\n\n.row.row-sm > div {\n  padding-left: 3px;\n  padding-right: 3px;\n}\n\n.nav-pills .nav-link.active,\n.nav-pills .show > .nav-link {\n  color: #ffffff;\n  background-color: #00d0f1;\n}\n\n@media (max-width: 575.98px) {\n  .pagination-lg .page-link {\n    font-size: 1.2rem;\n    padding: 0.5rem 0.625rem;\n  }\n}\n\n.notifications {\n  padding: 0;\n}\n\n.notifications .notification-time {\n  font-size: 12px;\n  line-height: 1.35;\n  color: #bdbdbd;\n}\n\n.notifications .notify-block {\n  margin-top: 0;\n  border-bottom: 1px solid #f5f5f5;\n}\n\n.notifications .notify-block:last-child {\n  border-bottom: none;\n}\n\n.notifications .notify-block a {\n  display: block;\n  padding: 10px 15px;\n  border-radius: 2px;\n}\n\n.notifications .notify-block a:hover {\n  background-color: #fafafa;\n}\n\n.notifications .notify-block > .avatar {\n  margin-right: 10px;\n}\n\n.notifications .media-list .media-left {\n  padding-right: 8px;\n}\n\n.notifications .noti-content {\n  height: 290px;\n  width: 350px;\n  overflow-y: auto;\n  position: relative;\n}\n\n@media (max-width: 479px) {\n  .notifications .noti-content {\n    width: 300px;\n  }\n}\n\n.notifications ul.notification-list > li {\n  margin-top: 0;\n  border-bottom: 1px solid #f5f5f5;\n}\n\n.notifications ul.notification-list > li:last-child {\n  border-bottom: none;\n}\n\n.notifications ul.notification-list > li a {\n  display: block;\n  border-radius: 2px;\n  padding: 10px 15px;\n}\n\n.notifications ul.notification-list > li a:hover {\n  background-color: #fafafa;\n}\n\n.notifications ul.notification-list > li .list-item {\n  border: 0;\n  position: relative;\n  padding: 0;\n}\n\n.topnav-dropdown-header {\n  border-bottom: 1px solid #eeeeee;\n  text-align: center;\n}\n\n.topnav-dropdown-header .notification-title {\n  color: #333333;\n  display: block;\n  float: left;\n  font-size: 14px;\n}\n\n.topnav-dropdown-header .clear-noti {\n  color: #f83f37;\n  float: right;\n  font-size: 12px;\n  text-transform: uppercase;\n}\n\n.topnav-dropdown-header,\n.topnav-dropdown-footer {\n  font-size: 14px;\n  height: 40px;\n  line-height: 40px;\n  padding-left: 15px;\n  padding-right: 15px;\n}\n\n.topnav-dropdown-footer {\n  border-top: 1px solid #eeeeee;\n}\n\n.topnav-dropdown-footer a {\n  display: block;\n  text-align: center;\n  color: #333333;\n}\n\n.noti-details {\n  color: #989c9e;\n  margin-bottom: 0;\n}\n\n.noti-title {\n  color: #333333;\n}\n\n.notification-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.noti-time {\n  margin: 0;\n}\n\n.login-body {\n  display: table;\n  height: 100vh;\n  min-height: 100vh;\n}\n\n.login-wrapper {\n  width: 100%;\n  height: 100%;\n  display: table-cell;\n  vertical-align: middle;\n}\n\n.login-wrapper .loginbox {\n  background-color: #ffffff;\n  display: flex;\n  max-width: 800px;\n  min-height: 500px;\n  width: 100%;\n  margin: 1.875rem auto;\n  border-radius: 6px;\n  -webkit-box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n  -moz-box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n}\n\n@media (max-width: 767.98px) {\n  .login-wrapper .loginbox {\n    max-width: 450px;\n    min-height: unset;\n  }\n}\n\n.login-wrapper .loginbox .login-left {\n  align-items: center;\n  flex-direction: column;\n  width: 400px;\n  display: flex;\n  background: linear-gradient(180deg, #aab6c1, #4b8b96);\n  border-radius: 6px 0 0 6px;\n  padding: 80px;\n}\n\n@media (max-width: 991.98px) {\n  .login-wrapper .loginbox .login-left {\n    width: 50%;\n    padding: 80px 50px;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .login-wrapper .loginbox .login-left {\n    display: none;\n  }\n}\n\n.login-wrapper .loginbox .login-right {\n  padding: 40px;\n  width: 400px;\n}\n\n@media (max-width: 991.98px) {\n  .login-wrapper .loginbox .login-right {\n    width: 50%;\n    padding: 50px;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .login-wrapper .loginbox .login-right {\n    float: none;\n    width: 100%;\n    padding: 1.875rem;\n  }\n}\n\n.login-wrapper .loginbox .login-right .login-right-wrap {\n  max-width: 100%;\n  flex: 0 0 100%;\n}\n\n.login-wrapper .loginbox .login-right h1 {\n  font-size: 26px;\n  font-weight: 500;\n  margin-bottom: 5px;\n  text-align: center;\n}\n\n@media (max-width: 767.98px) {\n  .login-wrapper .loginbox .login-right h1 {\n    font-size: 22px;\n  }\n}\n\n.login-wrapper .loginbox .login-right .forgotpass a {\n  color: #a0a0a0;\n}\n\n.login-wrapper .loginbox .login-right .forgotpass a:hover {\n  color: #333333;\n  text-decoration: underline;\n}\n\n.login-wrapper .loginbox .login-right .dont-have {\n  color: #a0a0a0;\n  margin-top: 1.875rem;\n}\n\n.login-wrapper .loginbox .login-right .dont-have a {\n  color: #333333;\n}\n\n.login-wrapper .loginbox .login-right .dont-have a:hover {\n  text-decoration: underline;\n}\n\n.account-subtitle {\n  color: #4c4c4c;\n  font-size: 17px;\n  margin-bottom: 1.875rem;\n  text-align: center;\n}\n\n.social-login {\n  text-align: center;\n}\n\n.social-login > span {\n  color: #a0a0a0;\n  margin-right: 8px;\n}\n\n.social-login > a {\n  background-color: #cccccc;\n  color: #ffffff;\n  display: inline-block;\n  font-size: 18px;\n  height: 32px;\n  line-height: 32px;\n  margin-right: 6px;\n  text-align: center;\n  width: 32px;\n  border-radius: 4px;\n}\n\n.social-login > a:last-child {\n  margin-right: 0;\n}\n\n.social-login > a.facebook {\n  background-color: #4b75bd;\n}\n\n.social-login > a.google {\n  background-color: #fe5240;\n}\n\n.login-or {\n  color: #a0a0a0;\n  position: relative;\n  margin-bottom: 20px;\n  margin-top: 20px;\n  padding-bottom: 10px;\n  padding-top: 10px;\n}\n\n.or-line {\n  background-color: #e5e5e5;\n  height: 1px;\n  display: block;\n  margin: 0 auto;\n}\n\n.span-or {\n  background-color: #ffffff;\n  display: block;\n  margin-left: -20px;\n  text-align: center;\n  text-transform: uppercase;\n  width: 42px;\n  position: absolute;\n  top: 0;\n  left: 50%;\n}\n\n.lock-user {\n  margin-bottom: 20px;\n  text-align: center;\n}\n\n.lock-user img {\n  margin-bottom: 15px;\n  width: 100px;\n}\n\n.add-btn {\n  border: 1px solid transparent;\n  color: #666;\n  display: inline-block;\n  padding: 0.375rem 0.75rem;\n  border-radius: 20px;\n}\n\n@media (max-width: 479px) {\n  .add-btn {\n    font-size: 14px;\n    padding: 6px 7px;\n  }\n}\n\n.add-btn:focus,\n.add-btn:active,\n.add-btn:hover {\n  background-color: #ffffff;\n  border-color: #dddddd;\n  color: #666;\n}\n\n.add-btn span {\n  align-items: center;\n  background-color: #ffc107;\n  color: #ffffff;\n  display: inline-flex;\n  font-size: 14px;\n  height: 22px;\n  justify-content: center;\n  margin-right: 3px;\n  width: 22px;\n  border-radius: 50%;\n}\n\n.invoice-details {\n  float: right;\n  text-align: right;\n}\n\n@media (max-width: 575.98px) {\n  .invoice-details {\n    float: left;\n    text-align: left;\n  }\n}\n\n.invoice-details h4 {\n  color: #666;\n  font-size: 16px;\n  font-weight: 400;\n  margin-bottom: 1.875rem;\n  text-transform: uppercase;\n}\n\n.inv-badge {\n  color: #ffffff;\n  display: inline-flex;\n  font-size: 11px;\n  justify-content: center;\n  min-width: 80px;\n}\n\n.inv-logo {\n  max-height: 80px;\n  height: auto;\n  max-height: 100px;\n  width: auto;\n}\n\n.invoice-container {\n  background-color: #ffffff;\n  border: 1px solid #f0f0f0;\n  max-width: 900px;\n  margin: 0 auto 1.875rem;\n  padding: 1.5rem;\n}\n\n@media (max-width: 767.98px) {\n  .invoice-container {\n    padding: 20px;\n  }\n}\n\n.invoice-payment-details > li span {\n  float: right;\n  text-align: right;\n}\n\n@media (max-width: 575.98px) {\n  .invoice-payment-details > li span {\n    float: left;\n    text-align: left;\n  }\n}\n\n#calendar-events {\n  background-color: #fcfcfc;\n}\n\n.calendar-events {\n  border: 1px solid transparent;\n  cursor: move;\n  padding: 10px 15px;\n}\n\n.calendar-events:hover {\n  border-color: #e9e9e9;\n  background-color: #ffffff;\n}\n\n.calendar-events i {\n  margin-right: 8px;\n}\n\n.calendar {\n  float: left;\n  margin-bottom: 0;\n}\n\n.fc-toolbar.fc-header-toolbar {\n  margin-bottom: 1.5rem;\n}\n\n@media (max-width: 575.98px) {\n  .fc-toolbar .fc-center {\n    display: inline-block;\n    width: 100%;\n    text-align: center;\n  }\n}\n\n@media (max-width: 575.98px) {\n  .fc-toolbar .fc-center h2 {\n    width: 100%;\n  }\n}\n\n@media (max-width: 575.98px) {\n  .fc-toolbar .fc-left {\n    float: none;\n    width: 200px;\n    margin: 0 auto;\n  }\n}\n\n@media (max-width: 575.98px) {\n  .fc-toolbar .fc-right {\n    display: inline-block;\n    float: none;\n    width: 200px;\n    clear: both;\n    margin: 10px auto 0;\n  }\n}\n\n.fc-toolbar h2 {\n  font-size: 18px;\n  font-weight: 600;\n  font-family: \"Roboto\", sans-serif;\n  line-height: 30px;\n  text-transform: uppercase;\n}\n\n.fc-toolbar .fc-state-active,\n.fc-toolbar .ui-state-active,\n.fc-toolbar .ui-state-hover,\n.fc-toolbar button:hover,\n.fc-toolbar button:focus {\n  z-index: 0;\n}\n\n.none-border .modal-footer {\n  border-top: none;\n}\n\n.fc-day-grid-event .fc-time {\n  font-family: \"Roboto\", sans-serif;\n}\n\n.fc-day {\n  background: #ffffff;\n}\n\n.fc th.fc-widget-header {\n  background: #eeeeee;\n  font-size: 14px;\n  line-height: 20px;\n  text-transform: uppercase;\n  padding: 10px 0;\n}\n\n.fc-unthemed th,\n.fc-unthemed td,\n.fc-unthemed thead,\n.fc-unthemed tbody,\n.fc-unthemed .fc-divider,\n.fc-unthemed .fc-row,\n.fc-unthemed .fc-popover {\n  border-color: #f3f3f3;\n}\n\n.fc-unthemed .fc-today {\n  background: #ffffff;\n}\n\n.fc-basic-view .fc-day-number,\n.fc-basic-view .fc-week-number {\n  padding: 2px 5px;\n}\n\n.fc-basic-view td.fc-week-number span {\n  padding-right: 8px;\n  font-weight: 700;\n  font-family: \"Roboto\", sans-serif;\n}\n\n.fc-basic-view td.fc-day-number {\n  padding-right: 8px;\n  font-weight: 700;\n  font-family: \"Roboto\", sans-serif;\n}\n\n.fc-button {\n  background: #f1f1f1;\n  border: none;\n  color: #797979;\n  text-transform: capitalize;\n  box-shadow: none !important;\n  border-radius: 3px !important;\n  height: auto !important;\n  margin: 0 3px !important;\n  padding: 6px 12px !important;\n}\n\n.fc-text-arrow {\n  font-family: inherit;\n  font-size: 16px;\n}\n\n.fc-state-hover {\n  background: #f3f3f3;\n}\n\n.fc-state-highlight {\n  background: #f0f0f0;\n}\n\n.fc-state-down,\n.fc-state-active,\n.fc-state-disabled {\n  background-color: #20c0f3 !important;\n  color: #ffffff !important;\n  text-shadow: none !important;\n}\n\n.fc-cell-overlay {\n  background: #f0f0f0;\n}\n\n.fc-event {\n  border: none;\n  color: #ffffff !important;\n  cursor: move;\n  font-size: 13px;\n  text-align: center;\n  border-radius: 2px;\n  margin: 1px 7px;\n  padding: 5px 5px;\n}\n\n.event-form .input-group .form-control {\n  height: 40px;\n}\n\n.dropdown-action {\n  margin-bottom: 5px;\n}\n\n.dropdown-action .dropdown-toggle:after {\n  display: none;\n}\n\n.table-inbox {\n  font-size: 15px;\n  margin-bottom: 0;\n}\n\n.table-inbox input[type=\"radio\"],\n.table-inbox input[type=\"checkbox\"] {\n  cursor: pointer;\n}\n\n.table-inbox .starred.fa-star,\n.table-inbox .fa-star {\n  color: #ffd200;\n}\n\n.table-inbox tr {\n  cursor: pointer;\n}\n\n.mail-list {\n  list-style: none;\n  padding: 0;\n}\n\n.mail-list > li > a {\n  color: #333333;\n  display: block;\n  padding: 10px;\n}\n\n.mail-list > li.active > a {\n  color: #00d0f1;\n  font-weight: 700;\n}\n\n.unread .name,\n.unread .subject,\n.unread .mail-date {\n  color: #000000;\n  font-weight: 600;\n}\n\n.table.table-inbox > tbody > tr > th,\n.table.table-inbox > tbody > tr > td,\n.table.table-inbox > thead > tr > th,\n.table.table-inbox > thead > tr > td,\n.table.table-inbox > tfoot > tr > th,\n.table.table-inbox > tfoot > tr > td {\n  border-bottom: 1px solid #f2f2f2;\n  border-top: 0;\n}\n\n.table.table-inbox thead {\n  background-color: #ffffff;\n}\n\n.note-editor.note-frame {\n  border: 1px solid #dddddd;\n  box-shadow: inherit;\n}\n\n.note-editor.note-frame .note-statusbar {\n  background-color: #ffffff;\n}\n\n.note-editor.note-frame.fullscreen {\n  top: 60px;\n}\n\n.note-editor.note-frame .btn-light {\n  background-color: #f9f9f9;\n  box-shadow: unset;\n  color: #333333;\n}\n\n.mail-title {\n  font-weight: 700;\n  text-transform: uppercase;\n}\n\n.form-control.search-message {\n  border-color: #cccccc;\n  height: 38px;\n  width: 180px;\n  border-radius: 4px;\n}\n\ntable.table-inbox tbody tr.checked {\n  background-color: #ffffcc;\n}\n\n.mail-label {\n  font-size: 16px !important;\n  margin-right: 5px;\n}\n\n.attachments {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.attachments li {\n  border: 1px solid #eeeeee;\n  float: left;\n  margin-bottom: 10px;\n  margin-right: 10px;\n  width: 180px;\n}\n\n.attach-info {\n  background-color: #f4f4f4;\n  padding: 10px;\n}\n\n.attach-file {\n  color: #777;\n  font-size: 70px;\n  min-height: 138px;\n  padding: 10px;\n}\n\n.attach-file img {\n  height: auto;\n  max-width: 100%;\n}\n\n.mailview-header,\n.mailview-footer {\n  border-bottom: 1px solid #dddddd;\n  margin-bottom: 20px;\n  padding-bottom: 15px;\n}\n\n.mailview-footer .btn-white {\n  margin-top: 10px;\n  min-width: 102px;\n}\n\n.sender-img {\n  float: left;\n  margin-right: 10px;\n  width: 40px;\n}\n\n.sender-name {\n  display: block;\n}\n\n.receiver-name {\n  color: #777;\n}\n\n.right-action,\n.mail-view-action,\n.mail-sent-time {\n  text-align: right;\n}\n\n@media (max-width: 767.98px) {\n  .mail-sent-time {\n    float: left;\n    margin-top: 10px;\n    width: 100%;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .right-action {\n    text-align: center;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .left-action {\n    text-align: center;\n    margin-bottom: 15px;\n  }\n}\n\n.mail-view-title {\n  font-weight: 500;\n  font-size: 24px;\n  margin: 0;\n}\n\n.inbox-menu {\n  display: inline-block;\n  width: 100%;\n  margin: 0 0 1.875rem;\n  padding: 0;\n}\n\n.inbox-menu li {\n  display: inline-block;\n  width: 100%;\n}\n\n.inbox-menu li + li {\n  margin-top: 2px;\n}\n\n.inbox-menu li a {\n  color: #333333;\n  display: inline-block;\n  width: 100%;\n  text-transform: capitalize;\n  -webkit-transition: 0.3s ease;\n  -ms-transition: 0.3s ease;\n  transition: 0.3s ease;\n  padding: 10px 15px;\n}\n\n.inbox-menu li a i {\n  font-size: 16px;\n  padding-right: 10px;\n  color: #878787;\n}\n\n.inbox-menu li a:hover,\n.inbox-menu li a:focus {\n  background: rgba(33, 33, 33, 0.05);\n}\n\n.inbox-menu li.active a {\n  background: rgba(33, 33, 33, 0.05);\n}\n\n.compose-btn {\n  margin-bottom: 1.875rem;\n}\n\n.compose-btn a {\n  font-weight: 600;\n  padding: 8px 15px;\n}\n\n.error-page {\n  align-items: center;\n  color: #1f1f1f;\n  display: flex;\n}\n\n.error-page .main-wrapper {\n  height: auto;\n  width: 100%;\n  min-height: unset;\n}\n\n.error-box {\n  max-width: 480px;\n  text-align: center;\n  width: 100%;\n  margin: 0 auto;\n  padding: 1.875rem 0;\n}\n\n.error-box h1 {\n  color: #00d0f1;\n  font-size: 10em;\n}\n\n@media (max-width: 767.98px) {\n  .error-box h1 {\n    font-size: 6em;\n  }\n}\n\n.error-box p {\n  margin-bottom: 1.875rem;\n}\n\n.error-box .btn {\n  font-size: 18px;\n  font-weight: 600;\n  min-width: 200px;\n  border-radius: 50px;\n  padding: 10px 20px;\n}\n\n@media (max-width: 767.98px) {\n  .error-box .btn {\n    font-size: 15px;\n    min-width: 150px;\n    padding: 8px 20px;\n  }\n}\n\n.profile-header {\n  background-color: #ffffff;\n  border: 1px solid #f0f0f0;\n  padding: 1.5rem;\n}\n\n.profile-header img {\n  height: auto;\n  max-width: 120px;\n  width: 120px;\n}\n\n.profile-menu {\n  background-color: #ffffff;\n  border: 1px solid #f0f0f0;\n  padding: 0.9375rem 1.5rem;\n}\n\n.profile-menu .nav-tabs.nav-tabs-solid {\n  background-color: transparent;\n}\n\n.profile-tab-cont {\n  padding-top: 1.875rem;\n}\n\n@media (max-width: 575.98px) {\n  .profile-tab-cont {\n    padding-top: 1.25rem;\n  }\n}\n\n.about-text {\n  max-width: 500px;\n}\n\n.skill-tags span {\n  background-color: #f4f4f5;\n  color: #66676b;\n  display: inline-block;\n  font-size: 15px;\n  line-height: 22px;\n  border-radius: 4px;\n  margin: 2px 0;\n  padding: 5px 15px;\n}\n\n.edit-link {\n  color: #66676b;\n  font-size: 16px;\n  margin-top: 4px;\n}\n\n@media (max-width: 767.98px) {\n  .edit-link {\n    font-size: 0.875rem;\n    margin-top: 0;\n  }\n}\n\n.cal-icon {\n  position: relative;\n  width: 100%;\n}\n\n.cal-icon:after {\n  color: #979797;\n  content: \"\\f073\";\n  display: block;\n  font-family: \"FontAwesome\";\n  font-size: 15px;\n  margin: auto;\n  position: absolute;\n  top: 10px;\n  right: 15px;\n}\n\n.form-title {\n  width: 100%;\n  max-width: 100%;\n  font-size: 20px;\n  font-weight: 500;\n  line-height: inherit;\n  color: #333333;\n  white-space: normal;\n  position: relative;\n  display: block;\n  margin: auto auto 20px;\n  padding: 0;\n}\n\n.form-title:before {\n  content: \"\";\n  height: 1px;\n  background-color: rgba(0, 0, 0, 0.1);\n  position: absolute;\n  top: 50%;\n  right: 0px;\n  left: 0;\n}\n\n.form-title span {\n  background-color: #ffffff;\n  display: inline-block;\n  z-index: 2;\n  position: relative;\n  padding: 0px 0.5rem 0 0;\n}\n\n@media (max-width: 575.98px) {\n  .account-wrapper {\n    padding: 0.9375rem;\n  }\n}\n\n@media (max-width: 575.98px) {\n  .profile-image {\n    flex: 0 0 100%;\n    margin-bottom: 20px;\n    text-align: center;\n  }\n}\n\n@media (max-width: 575.98px) {\n  .profile-user-info {\n    text-align: center;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .profile-btn {\n    flex: 0 0 100%;\n    margin-top: 20px;\n  }\n}\n\n@media (max-width: 575.98px) {\n  .profile-btn {\n    text-align: center;\n  }\n}\n\n.ant-form-item-label {\n  padding: 0px !important;\n  height: auto !important;\n}\n\n.chat-page .footer {\n  display: none;\n}\n\n.chat-window {\n  position: relative;\n}\n\n.chat-window .chat-cont-left {\n  border-right: 1px solid #f0f0f0;\n  -ms-flex: 0 0 35%;\n  flex: 0 0 35%;\n  max-width: 35%;\n  z-index: 4;\n  position: relative;\n  left: 0;\n}\n\n@media (max-width: 1199.98px) {\n  .chat-window .chat-cont-left {\n    -ms-flex: 0 0 40%;\n    flex: 0 0 40%;\n    max-width: 40%;\n  }\n}\n\n@media (max-width: 991.98px) {\n  .chat-window .chat-cont-left {\n    -ms-flex: 0 0 100%;\n    flex: 0 0 100%;\n    max-width: 100%;\n    transition:\n      left 0.3s ease-in-out 0s,\n      right 0.3s ease-in-out 0s;\n    width: 100%;\n    border-right: 0;\n  }\n}\n\n@media (max-width: 479.98px) {\n  .chat-window .chat-cont-left a.media .media-body > div:first-child .user-name,\n  .chat-window .chat-cont-left a.media .media-body > div:first-child .user-last-chat {\n    max-width: 160px;\n  }\n}\n\n.chat-window .chat-cont-left .chat-header {\n  background-color: #ffffff;\n  border-bottom: 1px solid #f0f0f0;\n  color: #272b41;\n  height: 72px;\n  padding: 0 15px;\n}\n\n.chat-window .chat-cont-left .chat-header span {\n  font-size: 20px;\n  font-weight: 500;\n  text-transform: capitalize;\n}\n\n.chat-window .chat-cont-left .chat-header .chat-compose {\n  color: #8a8a8a;\n}\n\n.chat-window .chat-cont-left .chat-search {\n  background-color: #f5f5f6;\n  border-bottom: 1px solid #f3f3f3;\n  padding: 10px 15px;\n  width: 100%;\n}\n\n.chat-window .chat-cont-left .chat-search .input-group {\n  width: 100%;\n}\n\n.chat-window .chat-cont-left .chat-search .input-group .form-control {\n  background-color: #ffffff;\n  padding-left: 36px;\n  border-radius: 50px;\n}\n\n.chat-window .chat-cont-left .chat-search .input-group .form-control:focus {\n  border-color: #cccccc;\n  box-shadow: none;\n}\n\n.chat-window .chat-cont-left .chat-search .input-group .form-control::placeholder {\n  font-size: 14px;\n}\n\n.chat-window .chat-cont-left .chat-search .input-group .input-group-prepend {\n  color: #666;\n  pointer-events: none;\n  z-index: 4;\n  position: absolute;\n  top: 10px;\n  bottom: 0;\n  left: 15px;\n}\n\n.chat-window .chat-cont-left .chat-users-list {\n  background-color: #ffffff;\n}\n\n.chat-window .chat-cont-left .chat-users-list a.media {\n  border-bottom: 1px solid #f0f0f0;\n  padding: 10px 15px;\n  -webkit-transition: all 0.2s ease 0s;\n  -ms-transition: all 0.2s ease 0s;\n  transition: all 0.2s ease 0s;\n}\n\n.chat-window .chat-cont-left .chat-users-list a.media:last-child {\n  border-bottom: 0;\n}\n\n.chat-window .chat-cont-left .chat-users-list a.media .media-img-wrap {\n  margin-right: 15px;\n  position: relative;\n}\n\n.chat-window .chat-cont-left .chat-users-list a.media .media-img-wrap .avatar {\n  height: 45px;\n  width: 45px;\n}\n\n.chat-window .chat-cont-left .chat-users-list a.media .media-img-wrap .status {\n  height: 10px;\n  width: 10px;\n  border: 2px solid #ffffff;\n  position: absolute;\n  right: 4px;\n  bottom: 7px;\n}\n\n.chat-window .chat-cont-left .chat-users-list a.media .media-body > div:first-child .user-name {\n  max-width: 250px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  color: #272b41;\n  text-transform: capitalize;\n}\n\n@media (max-width: 1399.98px) {\n  .chat-window .chat-cont-left .chat-users-list a.media .media-body > div:first-child .user-name {\n    max-width: 180px;\n  }\n}\n\n@media (max-width: 1199.98px) {\n  .chat-window .chat-cont-left .chat-users-list a.media .media-body > div:first-child .user-name {\n    max-width: 150px;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .chat-window .chat-cont-left .chat-users-list a.media .media-body > div:first-child .user-name {\n    max-width: 250px;\n  }\n}\n\n@media (max-width: 479.98px) {\n  .chat-window .chat-cont-left .chat-users-list a.media .media-body > div:first-child .user-name {\n    max-width: 160px;\n  }\n}\n\n.chat-window\n  .chat-cont-left\n  .chat-users-list\n  a.media\n  .media-body\n  > div:first-child\n  .user-last-chat {\n  max-width: 250px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  color: #8a8a8a;\n  font-size: 14px;\n  line-height: 24px;\n}\n\n@media (max-width: 1399.98px) {\n  .chat-window\n    .chat-cont-left\n    .chat-users-list\n    a.media\n    .media-body\n    > div:first-child\n    .user-last-chat {\n    max-width: 180px;\n  }\n}\n\n@media (max-width: 1199.98px) {\n  .chat-window\n    .chat-cont-left\n    .chat-users-list\n    a.media\n    .media-body\n    > div:first-child\n    .user-last-chat {\n    max-width: 150px;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .chat-window\n    .chat-cont-left\n    .chat-users-list\n    a.media\n    .media-body\n    > div:first-child\n    .user-last-chat {\n    max-width: 250px;\n  }\n}\n\n@media (max-width: 479.98px) {\n  .chat-window\n    .chat-cont-left\n    .chat-users-list\n    a.media\n    .media-body\n    > div:first-child\n    .user-last-chat {\n    max-width: 160px;\n  }\n}\n\n.chat-window .chat-cont-left .chat-users-list a.media .media-body > div:last-child {\n  text-align: right;\n}\n\n.chat-window .chat-cont-left .chat-users-list a.media .media-body > div:last-child .last-chat-time {\n  color: #8a8a8a;\n  font-size: 13px;\n}\n\n.chat-window .chat-cont-left .chat-users-list a.media:hover {\n  background-color: #f5f5f6;\n}\n\n.chat-window\n  .chat-cont-left\n  .chat-users-list\n  a.media.read-chat\n  .media-body\n  > div:last-child\n  .last-chat-time {\n  color: #8a8a8a;\n}\n\n.chat-window .chat-cont-left .chat-users-list a.media.active {\n  background-color: #f5f5f6;\n}\n\n.chat-window .chat-scroll {\n  min-height: 300px;\n  max-height: calc(100vh - 224px);\n  overflow-y: auto;\n}\n\n.chat-window .chat-cont-right {\n  -ms-flex: 0 0 65%;\n  flex: 0 0 65%;\n  max-width: 65%;\n}\n\n@media (max-width: 1199.98px) {\n  .chat-window .chat-cont-right {\n    -ms-flex: 0 0 60%;\n    flex: 0 0 60%;\n    max-width: 60%;\n  }\n}\n\n@media (max-width: 991.98px) {\n  .chat-window .chat-cont-right {\n    opacity: 0;\n    visibility: hidden;\n    position: absolute;\n    top: 0;\n    right: -100%;\n    -ms-flex: 0 0 100%;\n    flex: 0 0 100%;\n    max-width: 100%;\n    transition:\n      left 0.3s ease-in-out 0s,\n      right 0.3s ease-in-out 0s;\n    width: 100%;\n  }\n}\n\n.chat-window .chat-cont-right .chat-header {\n  background-color: #ffffff;\n  border-bottom: 1px solid #f0f0f0;\n  height: 72px;\n  padding: 0 15px;\n}\n\n@media (max-width: 991.98px) {\n  .chat-window .chat-cont-right .chat-header {\n    justify-content: start;\n    -webkit-justify-content: start;\n    -ms-flex-pack: start;\n  }\n}\n\n.chat-window .chat-cont-right .chat-header .back-user-list {\n  display: none;\n  margin-right: 5px;\n  margin-left: -7px;\n}\n\n@media (max-width: 991.98px) {\n  .chat-window .chat-cont-right .chat-header .back-user-list {\n    display: block;\n  }\n}\n\n.chat-window .chat-cont-right .chat-header .media .media-img-wrap {\n  position: relative;\n  margin-right: 15px;\n}\n\n.chat-window .chat-cont-right .chat-header .media .media-img-wrap .avatar {\n  height: 50px;\n  width: 50px;\n}\n\n.chat-window .chat-cont-right .chat-header .media .media-img-wrap .status {\n  border: 2px solid #ffffff;\n  height: 10px;\n  width: 10px;\n  position: absolute;\n  right: 3px;\n  bottom: 0;\n}\n\n@media (max-width: 767.98px) {\n  .chat-window .chat-cont-right .chat-header .media .media-body {\n    display: none;\n  }\n}\n\n.chat-window .chat-cont-right .chat-header .media .media-body .user-name {\n  color: #272b41;\n  font-size: 16px;\n  font-weight: 500;\n  text-transform: capitalize;\n}\n\n.chat-window .chat-cont-right .chat-header .media .media-body .user-status {\n  color: #666;\n  font-size: 14px;\n}\n\n@media (max-width: 991.98px) {\n  .chat-window .chat-cont-right .chat-header .chat-options {\n    margin-left: auto;\n  }\n}\n\n.chat-window .chat-cont-right .chat-header .chat-options > a {\n  border-radius: 50%;\n  height: 30px;\n  color: #8a8a8a;\n  margin-left: 10px;\n  width: 30px;\n}\n\n.chat-window .chat-cont-right .chat-body {\n  background-color: #f5f5f6;\n}\n\n.chat-window .chat-cont-right .chat-body ul.list-unstyled {\n  width: 100%;\n  margin: 0 auto;\n  padding: 15px;\n}\n\n.chat-window .chat-cont-right .chat-body .media .avatar {\n  height: 30px;\n  width: 30px;\n}\n\n.chat-window .chat-cont-right .chat-body .media .media-body {\n  margin-left: 20px;\n}\n\n.chat-window .chat-cont-right .chat-body .media .media-body .msg-box > div {\n  display: inline-block;\n  position: relative;\n  border-radius: 0.25rem;\n  padding: 10px 15px;\n}\n\n.chat-window .chat-cont-right .chat-body .media .media-body .msg-box > div p {\n  color: #272b41;\n  margin-bottom: 0;\n}\n\n.chat-window .chat-cont-right .chat-body .media .media-body .msg-box + .msg-box {\n  margin-top: 5px;\n}\n\n.chat-window .chat-cont-right .chat-body .media.received {\n  margin-bottom: 20px;\n}\n\n.chat-window .chat-cont-right .chat-body .media.received .media-body {\n  position: relative;\n}\n\n.chat-window .chat-cont-right .chat-body .media.received .media-body .msg-box > div {\n  background-color: #ffffff;\n}\n\n.chat-window .chat-cont-right .chat-body .media.received .media-body .msg-box > div .chat-time {\n  color: rgba(50, 65, 72, 0.4);\n}\n\n.chat-window .chat-cont-right .chat-body .media.received .media-body .msg-box:first-child:before {\n  border-bottom: 6px solid transparent;\n  border-right: 6px solid #ffffff;\n  border-top: 6px solid transparent;\n  content: \"\";\n  height: 0;\n  width: 0;\n  position: absolute;\n  top: 8px;\n  right: auto;\n  left: -6px;\n}\n\n.chat-window .chat-cont-right .chat-body .media.sent .media-body .msg-box {\n  padding-left: 50px;\n  position: relative;\n}\n\n.chat-window .chat-cont-right .chat-body .media.sent .media-body .msg-box:first-child:before {\n  border-bottom: 6px solid transparent;\n  border-left: 6px solid #e3e3e3;\n  border-top: 6px solid transparent;\n  content: \"\";\n  height: 0;\n  width: 0;\n  position: absolute;\n  top: 8px;\n  right: -6px;\n  left: auto;\n}\n\n.chat-window .chat-cont-right .chat-body .media.sent .media-body .msg-box > div .chat-time {\n  color: rgba(50, 65, 72, 0.4);\n}\n\n.chat-window .chat-cont-right .chat-body .media:last-child {\n  margin-bottom: 0;\n}\n\n.chat-window .chat-cont-right .chat-body .media.sent {\n  margin-bottom: 20px;\n}\n\n.chat-window .chat-cont-right .chat-body .media.sent .media-body {\n  margin-left: 0;\n}\n\n.chat-window .chat-cont-right .chat-body .media.sent .media-body .msg-box > div {\n  background-color: #e3e3e3;\n}\n\n.chat-window .chat-cont-right .chat-body .media.sent .media-body .msg-box > div p {\n  color: #272b41;\n}\n\n.chat-window .chat-cont-right .chat-body .media.sent .media-body .msg-box > div .chat-msg-info {\n  flex-direction: row-reverse;\n}\n\n.chat-window .chat-cont-right .chat-body .media.sent .media-body .msg-box > div .chat-msg-info li {\n  padding-left: 16px;\n  padding-right: 0;\n  position: relative;\n}\n\n.chat-window\n  .chat-cont-right\n  .chat-body\n  .media.sent\n  .media-body\n  .msg-box\n  > div\n  .chat-msg-attachments {\n  flex-direction: row-reverse;\n}\n\n.chat-window\n  .chat-cont-right\n  .chat-body\n  .media.sent\n  .media-body\n  .msg-box\n  > div:hover\n  .chat-msg-actions {\n  opacity: 1;\n}\n\n.chat-window .chat-cont-right .chat-body .chat-date {\n  font-size: 14px;\n  margin: 1.875rem 0;\n  overflow: hidden;\n  position: relative;\n  text-align: center;\n  text-transform: capitalize;\n}\n\n.chat-window .chat-cont-right .chat-body .chat-date:before {\n  background-color: #eef6ff;\n  content: \"\";\n  height: 1px;\n  margin-right: 28px;\n  width: 100%;\n  position: absolute;\n  top: 50%;\n  right: 50%;\n}\n\n.chat-window .chat-cont-right .chat-body .chat-date:after {\n  background-color: #eef6ff;\n  content: \"\";\n  height: 1px;\n  margin-left: 28px;\n  width: 100%;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n}\n\n.chat-window .chat-cont-right .chat-footer {\n  background-color: #ffffff;\n  position: relative;\n  border-top: 1px solid #f0f0f0;\n  padding: 10px 15px;\n}\n\n.chat-window .chat-cont-right .chat-footer .input-group {\n  width: 100%;\n}\n\n.chat-window .chat-cont-right .chat-footer .input-group .form-control {\n  background-color: #f5f5f6;\n  border: none;\n  border-radius: 50px;\n}\n\n.chat-window .chat-cont-right .chat-footer .input-group .form-control:focus {\n  background-color: #f5f5f6;\n  border: none;\n  box-shadow: none;\n}\n\n.chat-window .chat-cont-right .chat-footer .input-group .form-control::placeholder {\n  font-size: 14px;\n}\n\n.chat-window .chat-cont-right .chat-footer .input-group .btn {\n  background-color: transparent;\n  border: none;\n  color: #9f9f9f;\n}\n\n.chat-window .chat-cont-right .chat-footer .input-group .btn.msg-send-btn {\n  background-color: #0de0fe;\n  border-color: #0de0fe;\n  color: #ffffff;\n  margin-left: 10px;\n  min-width: 46px;\n  font-size: 20px;\n  border-radius: 50%;\n}\n\n.chat-window .chat-cont-right .msg-typing {\n  width: auto;\n  height: 24px;\n  padding-top: 8px;\n}\n\n.chat-window .chat-cont-right .msg-typing span {\n  height: 8px;\n  width: 8px;\n  float: left;\n  margin: 0 1px;\n  background-color: #a0a0a0;\n  display: block;\n  opacity: 0.4;\n  border-radius: 50%;\n}\n\n.chat-window .chat-cont-right .msg-typing span:nth-of-type(1) {\n  animation: 1s blink infinite 0.33333s;\n}\n\n.chat-window .chat-cont-right .msg-typing span:nth-of-type(2) {\n  animation: 1s blink infinite 0.66666s;\n}\n\n.chat-window .chat-cont-right .msg-typing span:nth-of-type(3) {\n  animation: 1s blink infinite 0.99999s;\n}\n\n.chat-window .chat-msg-info {\n  clear: both;\n  list-style: none;\n  margin: 5px 0 0;\n  padding: 0;\n}\n\n.chat-window .chat-msg-info li {\n  font-size: 13px;\n  padding-right: 16px;\n  position: relative;\n}\n\n.chat-window .chat-msg-info li:not(:last-child):after {\n  content: \"\";\n  height: 4px;\n  width: 4px;\n  background: #d2dde9;\n  border-radius: 50%;\n  transform: translate(50%, -50%);\n  -webkit-transform: translate(50%, -50%);\n  -ms-transform: translate(50%, -50%);\n  position: absolute;\n  top: 50%;\n  right: 8px;\n}\n\n.chat-window .chat-msg-info li a {\n  color: #777;\n}\n\n.chat-window .chat-msg-info li a:hover {\n  color: #2c80ff;\n}\n\n@media (max-width: 991.98px) {\n  .chat-window.chat-slide .chat-cont-left {\n    left: -100%;\n  }\n}\n\n@media (max-width: 991.98px) {\n  .chat-window.chat-slide .chat-cont-right {\n    right: 0;\n    opacity: 1;\n    visibility: visible;\n  }\n}\n\n.chat-seen i {\n  color: #00d285;\n  font-size: 16px;\n}\n\n.chat-msg-attachments {\n  width: 100%;\n  margin: 0 -1px;\n  padding: 4px 0;\n}\n\n.chat-msg-attachments > div {\n  margin: 0 1px;\n}\n\n.chat-attachment {\n  position: relative;\n  max-width: 130px;\n  overflow: hidden;\n  border-radius: 0.25rem;\n}\n\n.chat-attachment img {\n  max-width: 100%;\n}\n\n.chat-attachment:before {\n  background: #000000;\n  content: \"\";\n  opacity: 0.4;\n  -webkit-transition: all 0.4s;\n  -ms-transition: all 0.4s;\n  transition: all 0.4s;\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n}\n\n.chat-attachment:hover:before {\n  opacity: 0.6;\n}\n\n.chat-attachment:hover .chat-attach-caption {\n  opacity: 0;\n}\n\n.chat-attachment:hover .chat-attach-download {\n  opacity: 1;\n}\n\n.chat-attach-caption {\n  color: #ffffff;\n  padding: 7px 15px;\n  font-size: 13px;\n  opacity: 1;\n  -webkit-transition: all 0.4s;\n  -ms-transition: all 0.4s;\n  transition: all 0.4s;\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n}\n\n.chat-attach-download {\n  opacity: 0;\n  color: #ffffff;\n  width: 32px;\n  line-height: 32px;\n  background: rgba(255, 255, 255, 0.2);\n  text-align: center;\n  transform: translate(-50%, -50%);\n  -webkit-transition: all 0.4s;\n  -ms-transition: all 0.4s;\n  transition: all 0.4s;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n}\n\n.chat-attach-download:hover {\n  color: #495463;\n  background: #ffffff;\n}\n\nchat-attachment-list {\n  margin: -5px;\n}\n\nchat-attachment-list li {\n  width: 33.33%;\n  padding: 5px;\n}\n\n.chat-attachment-item {\n  border: 5px solid rgba(230, 239, 251, 0.5);\n  height: 100%;\n  min-height: 60px;\n  text-align: center;\n  font-size: 30px;\n}\n\n.chat-msg-actions {\n  opacity: 0;\n  z-index: 2;\n  transform: translateY(-50%);\n  -webkit-transform: translateY(-50%);\n  -ms-transform: translateY(-50%);\n  -webkit-transition: all 0.4s;\n  -ms-transition: all 0.4s;\n  transition: all 0.4s;\n  position: absolute;\n  top: 50%;\n  left: -30px;\n}\n\n.chat-msg-actions > a {\n  color: #495463;\n  font-size: 24px;\n  padding: 0 10px;\n}\n\n.chat-msg-actions > a:hover {\n  color: #2c80ff;\n}\n\n@keyframes blink {\n  50% {\n    opacity: 1;\n  }\n}\n\n.btn-file {\n  font-size: 20px;\n  overflow: hidden;\n  position: relative;\n  vertical-align: middle;\n  padding: 0 0.75rem;\n}\n\n.btn-file input {\n  cursor: pointer;\n  filter: alpha(opacity=0);\n  font-size: 23px;\n  height: 100%;\n  margin: 0;\n  opacity: 0;\n  width: 100%;\n  position: absolute;\n  top: 0;\n  right: 0;\n}\n\n.incoming-btns {\n  margin-top: 20px;\n}\n\n.call-wrapper {\n  position: relative;\n  height: calc(100vh - 145px);\n}\n\n.chat-window {\n  display: flex;\n}\n\n/* Only the search *button* icon sits on a filled background; icons in inputs keep their color. */\n.ant-input-search-button .anticon.anticon-search {\n  color: #fff !important;\n}\n\n.ant-alert-with-description {\n  align-items: center !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
